import { Form, Spin, Typography } from "antd/es";
import { connect } from "react-redux";
import {
  AutoComplete,
  Button,
  Footer,
  Header,
  HorizontalStack,
  Icon,
  KCol,
  KDatePicker,
  KRow,
  KTab,
  KTabItem,
  KTable,
  KTableColumn,
  KTableHeader,
  KTableRow,
  Label,
  NumberInput,
  TextArea,
  TextInput,
  VerticalStack,
} from "../../components/web-components";
import { KSelectBox } from "../../kuika";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { withContext } from "../../shared/hoc/with-context";
import { withForm } from "../../shared/hoc/with-form";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { CatiGesOnSurecler_ScreenBase } from "./catigesonsurecler-base";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [];

class CatiGesOnSurecler_Screen extends CatiGesOnSurecler_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin spinning={this.state.spinnerCount > 0}>
          <Form
            form={this.props.form}
            name="basic"
            initialValues={{
              catigesonsurecler_261399_value: undefined,
              catigesonsurecler_913183_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.kesifTarihi ??
                undefined,
              catigesonsurecler_662082_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.kUserID ??
                undefined,
              catigesonsurecler_203346_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.adaParselBilgisi ??
                undefined,
              catigesonsurecler_14467_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.sozlesmeGucu_kW ??
                undefined,
              catigesonsurecler_707377_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.aboneTipi ??
                undefined,
              catigesonsurecler_766200_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.trafoGucu_kVA ??
                undefined,
              catigesonsurecler_145387_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.anaŞalterAkim_A ??
                undefined,
              catigesonsurecler_743336_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.panoMesafesi_m ??
                undefined,
              catigesonsurecler_166467_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiTipi ??
                undefined,
              catigesonsurecler_724523_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiEgimi_Derece ??
                undefined,
              catigesonsurecler_380385_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiYonu ??
                undefined,
              catigesonsurecler_886075_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)
                  ?.kullanilabilirAlan_m2 ?? undefined,
              catigesonsurecler_950845_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.tahminiGuc_kWp ??
                undefined,
              catigesonsurecler_323299_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)
                  ?.kullanilabilirAlan_m2 ?? undefined,
              catigesonsurecler_246942_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.golgelenmeDurumu ??
                undefined,
              catigesonsurecler_681014_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)
                  ?.catiTasiyiciSistem ?? undefined,
              catigesonsurecler_585296_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.hadveAraligi_m ??
                undefined,
              catigesonsurecler_629508_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.kaplamaDurumu ??
                undefined,
              catigesonsurecler_946973_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.vincKurulumAlani ??
                undefined,
              catigesonsurecler_394531_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)
                  ?.inverterMontajYeri ?? undefined,
              catigesonsurecler_397937_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)
                  ?.kabloYoluGuzergahi ?? undefined,
              catigesonsurecler_393036_value: "",
              catigesonsurecler_207266_value: undefined,
              catigesonsurecler_480487_value: undefined,
              catigesonsurecler_353063_value: 0,
              catigesonsurecler_570640_value: 0,
              catigesonsurecler_225026_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(-1)?.kesif_Aciklama1 ??
                undefined,
              catigesonsurecler_26200_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(-1)?.kesif_Aciklama2 ??
                undefined,
              catigesonsurecler_122352_value:
                this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.kesif_Aciklama3 ??
                undefined,
              catigesonsurecler_505390_value:
                this.state.PROFORMA_GENEL_BILGILERI_GETIR?.at?.(0)
                  ?.proforma_Tutar ?? undefined,
              catigesonsurecler_169821_value:
                this.state.PROFORMA_GENEL_BILGILERI_GETIR?.at?.(0)
                  ?.proforma_Notu ?? undefined,
              catigesonsurecler_990822_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.kesifTarihi ??
                undefined,
              catigesonsurecler_864033_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.kullaniciId ??
                undefined,
              catigesonsurecler_784281_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.adaParselBilgisi ??
                undefined,
              catigesonsurecler_798603_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.sozlesmeGucu_kW ??
                undefined,
              catigesonsurecler_569086_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.aboneTipi ??
                undefined,
              catigesonsurecler_865048_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.trafoGucu_kVA ??
                undefined,
              catigesonsurecler_907314_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.anaŞalterAkim_A ??
                undefined,
              catigesonsurecler_320637_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.panoMesafesi_m ??
                undefined,
              catigesonsurecler_940300_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.catiTipi ?? undefined,
              catigesonsurecler_967785_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.catiEgimi_Derece ??
                undefined,
              catigesonsurecler_775375_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.catiYonu ?? undefined,
              catigesonsurecler_257886_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)
                  ?.kullanilabilirAlan_m2 ?? undefined,
              catigesonsurecler_672009_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.tahminiGuc_kWp ??
                undefined,
              catigesonsurecler_235750_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)
                  ?.kullanilabilirAlan_m2 ?? undefined,
              catigesonsurecler_568262_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.golgelenmeDurumu ??
                undefined,
              catigesonsurecler_868333_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.catiTasiyiciSistem ??
                undefined,
              catigesonsurecler_219090_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.hadveAraligi_m ??
                undefined,
              catigesonsurecler_328449_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.kaplamaDurumu ??
                undefined,
              catigesonsurecler_4244_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.vincKurulumAlani ??
                undefined,
              catigesonsurecler_494854_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.inverterMontajYeri ??
                undefined,
              catigesonsurecler_592482_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.kabloYoluGuzergahi ??
                undefined,
              catigesonsurecler_600320_value: "",
              catigesonsurecler_102756_value: undefined,
              catigesonsurecler_372323_value: undefined,
              catigesonsurecler_180639_value: 0,
              catigesonsurecler_153946_value: 0,
              catigesonsurecler_490847_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.netKesif_Aciklama1 ??
                undefined,
              catigesonsurecler_668639_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.netKesif_Aciklama2 ??
                undefined,
              catigesonsurecler_91916_value:
                this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.netKesif_Aciklama3 ??
                undefined,
              catigesonsurecler_858665_value: "",
              catigesonsurecler_961677_value: "",
            }}
            onValuesChange={(changedValues, allValues) => {
              this.clearFieldValidation(changedValues);
            }}
          >
            <div
              style={
                {
                  display: "flex",
                  flexDirection: "column",
                  minHeight: "100%",
                } as any
              }
            >
              <Header
                key="-2"
                id="catigesonsurecler_header"
                style={
                  {
                    borderStyle: "solid",
                    borderTopWidth: 0,
                    borderRightWidth: 0,
                    borderBottomWidth: 0,
                    borderLeftWidth: 0,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "left",
                    paddingTop: 0,
                    paddingRight: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    fontSize: "14px",
                    color: "rgba(68, 68, 68, 1)",
                  } as any
                }
              >
                <KRow
                  key="997986"
                  id="997986"
                  align="top"
                  justify="start"
                  horizontalGutter={0}
                  verticalGutter={0}
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "rgba(9, 124, 176, 1)",
                      paddingTop: 8,
                      paddingRight: 8,
                      paddingBottom: 8,
                      paddingLeft: 8,
                      alignItems: "flex-start",
                      textAlign: "-webkit-left",
                    } as any
                  }
                >
                  <KCol
                    key="589562"
                    id="589562"
                    xs={21}
                    sm={21}
                    md={21}
                    lg={21}
                    xl={21}
                    xxl={21}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <VerticalStack
                      key="920977"
                      id="920977"
                      direction="vertical"
                      size={2}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 0,
                          paddingRight: 0,
                          paddingBottom: 0,
                          paddingLeft: 0,
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <HorizontalStack
                        key="284288"
                        id="284288"
                        direction="horizontal"
                        size={5}
                        overflowX="auto"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <Label
                          key="271446"
                          id="271446"
                          value={
                            this.state.GET_ON_SUREC_OZET_GETIR?.at?.(0)
                              ?.netsisProjKodu ?? undefined
                          }
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "10px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                        <Label
                          key="547809"
                          id="547809"
                          value={ReactSystemFunctions.translate(
                            this.ml,
                            547809,
                            "value",
                            this.defaultML
                          )}
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "10px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                        <Label
                          key="585180"
                          id="585180"
                          value={
                            this.state.GET_ON_SUREC_OZET_GETIR?.at?.(0)
                              ?.kategoriAdi ?? undefined
                          }
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "10px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                      </HorizontalStack>
                      <HorizontalStack
                        key="312208"
                        id="312208"
                        direction="horizontal"
                        size={0}
                        overflowX="auto"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <Label
                          key="491925"
                          id="491925"
                          value={
                            this.state.GET_ON_SUREC_OZET_GETIR?.at?.(0)
                              ?.projeAdi ?? undefined
                          }
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 600,
                              fontSize: "16px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                        <Label
                          key="114330"
                          id="114330"
                          value={ReactSystemFunctions.translate(
                            this.ml,
                            114330,
                            "value",
                            this.defaultML
                          )}
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 600,
                              fontSize: "16px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                      </HorizontalStack>
                      <HorizontalStack
                        key="71236"
                        id="71236"
                        direction="horizontal"
                        size={2}
                        overflowX="auto"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <Icon
                          key="151432"
                          id="151432"
                          iconName="person"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "12px",
                              color: "rgba(217, 217, 217, 1)",
                              letterSpacing: "1px",
                            } as any
                          }
                        ></Icon>
                        <Label
                          key="135540"
                          id="135540"
                          value={
                            this.state.GET_ON_SUREC_OZET_GETIR?.at?.(0)
                              ?.iletisimKisi ?? undefined
                          }
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontWeight: 300,
                              fontSize: "10px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                        <Label
                          key="19253"
                          id="19253"
                          value={ReactSystemFunctions.translate(
                            this.ml,
                            19253,
                            "value",
                            this.defaultML
                          )}
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontWeight: 600,
                              fontSize: "12px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                        <Icon
                          key="138416"
                          id="138416"
                          iconName="business"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "12px",
                              color: "rgba(217, 217, 217, 1)",
                              letterSpacing: "1px",
                            } as any
                          }
                        ></Icon>
                        <Label
                          key="554247"
                          id="554247"
                          value={
                            this.state.GET_ON_SUREC_OZET_GETIR?.at?.(0)
                              ?.musteriAdi ?? undefined
                          }
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontWeight: 300,
                              fontSize: "10px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                        <Label
                          key="551015"
                          id="551015"
                          value={ReactSystemFunctions.translate(
                            this.ml,
                            551015,
                            "value",
                            this.defaultML
                          )}
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontWeight: 600,
                              fontSize: "12px",
                              color: "rgba(255, 255, 255, 1)",
                            } as any
                          }
                        ></Label>
                        <Icon
                          key="985877"
                          id="985877"
                          iconName="calendar_month"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "12px",
                              color: "rgba(217, 217, 217, 1)",
                              letterSpacing: "1px",
                            } as any
                          }
                        ></Icon>
                        <HorizontalStack
                          key="751789"
                          id="751789"
                          direction="horizontal"
                          size={0}
                          overflowX="auto"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="470797"
                            id="470797"
                            value={
                              this.state.GET_ON_SUREC_OZET_GETIR?.at?.(0)
                                ?.baslangicTarihi ?? undefined
                            }
                            formatter="date"
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontWeight: 300,
                                fontSize: "10px",
                                color: "rgba(255, 255, 255, 1)",
                              } as any
                            }
                          ></Label>
                          <Label
                            key="321188"
                            id="321188"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              321188,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontWeight: 300,
                                fontSize: "10px",
                                color: "rgba(255, 255, 255, 1)",
                              } as any
                            }
                          ></Label>
                          <Label
                            key="931176"
                            id="931176"
                            value={
                              this.state.GET_ON_SUREC_OZET_GETIR?.at?.(0)
                                ?.tahminiBitis ?? undefined
                            }
                            formatter="date"
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontWeight: 300,
                                fontSize: "10px",
                                color: "rgba(255, 255, 255, 1)",
                              } as any
                            }
                          ></Label>
                        </HorizontalStack>
                      </HorizontalStack>
                    </VerticalStack>
                  </KCol>
                  <KCol
                    key="561047"
                    id="561047"
                    xs={3}
                    sm={3}
                    md={3}
                    lg={3}
                    xl={3}
                    xxl={3}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "center",
                        textAlign: "-webkit-right",
                      } as any
                    }
                  >
                    <VerticalStack
                      key="903177"
                      id="903177"
                      direction="vertical"
                      size={4}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 0,
                          paddingRight: 0,
                          paddingBottom: 0,
                          paddingLeft: 0,
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <Icon
                        key="838016"
                        id="838016"
                        onClick={(e?: any) => {
                          if (e && e.stopPropagation) e.stopPropagation();
                          this.CatiGesOnSureclerComponent_838016_onClick();
                        }}
                        showCursorPointer
                        iconName="close"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "24px",
                            color: "rgba(255, 255, 255, 1)",
                            letterSpacing: "1px",
                          } as any
                        }
                      ></Icon>
                    </VerticalStack>
                  </KCol>
                </KRow>
              </Header>
              <div
                key="-1"
                id="catigesonsurecler_body"
                style={
                  {
                    borderStyle: "solid",
                    borderTopWidth: 0,
                    borderRightWidth: 0,
                    borderBottomWidth: 0,
                    borderLeftWidth: 0,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "left",
                    display: "block",
                  } as any
                }
              >
                <KRow
                  key="586288"
                  id="586288"
                  align="top"
                  justify="start"
                  horizontalGutter={0}
                  verticalGutter={0}
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                    } as any
                  }
                >
                  <KCol
                    key="505771"
                    id="505771"
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <Form.Item
                      className="kFormItem"
                      name="catigesonsurecler_261399_value"
                      noStyle
                    >
                      <KTab
                        key="261399"
                        id="261399"
                        visibility={
                          this.state
                            .isCompcatigesonsurecler_261399AuthorizationVisible
                        }
                        visibilityByAuthorization={
                          this.state
                            .isCompcatigesonsurecler_261399AuthorizationVisible
                        }
                        type="line"
                        size="default"
                        tabPosition="top"
                        selectedTabColor="#0078FF"
                        justifiedTabTitles={false}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KTabItem
                          key={490554}
                          id="490554"
                          onActive={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.CatiGesOnSureclerComponent_490554_onActive();
                          }}
                          tab={ReactSystemFunctions.translate(
                            this.ml,
                            490554,
                            "tab",
                            this.defaultML
                          )}
                          forceRender={false}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(255, 255, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KRow
                            key="475411"
                            id="475411"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                              } as any
                            }
                          >
                            <KCol
                              key="28477"
                              id="28477"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                } as any
                              }
                            >
                              <KRow
                                key="58742"
                                id="58742"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingBottom: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="309819"
                                  id="309819"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={12}
                                  xxl={12}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 0,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="934626"
                                    id="934626"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 12,
                                        borderTopRightRadius: 12,
                                        borderBottomRightRadius: 12,
                                        borderBottomLeftRadius: 12,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor:
                                          "rgba(244, 248, 251, 1)",
                                        paddingTop: 0,
                                        paddingRight: 8,
                                        paddingBottom: 0,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="378127"
                                      id="378127"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="27771"
                                        id="27771"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="999265"
                                          id="999265"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="370812"
                                            id="370812"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              370812,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 600,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="357914"
                                          id="357914"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        ></KCol>
                                      </KRow>
                                      <KRow
                                        key="125787"
                                        id="125787"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="485049"
                                          id="485049"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="873090"
                                            id="873090"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              873090,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="329271"
                                          id="329271"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="286346"
                                            id="286346"
                                            value={
                                              this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                0
                                              )?.kategoriAdi ?? undefined
                                            }
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="821933"
                                        id="821933"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="726756"
                                          id="726756"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="707335"
                                            id="707335"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              707335,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="364836"
                                          id="364836"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="725534"
                                            id="725534"
                                            value={
                                              this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                0
                                              )?.netsisProjKodu ?? undefined
                                            }
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="697919"
                                        id="697919"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="392952"
                                          id="392952"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="692080"
                                            id="692080"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              692080,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="530667"
                                          id="530667"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="82922"
                                            id="82922"
                                            value={
                                              this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                0
                                              )?.musteriAdi ?? undefined
                                            }
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="452229"
                                        id="452229"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="344225"
                                          id="344225"
                                          xs={8}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="756078"
                                            id="756078"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              756078,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="650610"
                                          id="650610"
                                          xs={16}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="548"
                                            id="548"
                                            value={
                                              this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                0
                                              )?.iletisimKisi ?? undefined
                                            }
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="783022"
                                        id="783022"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="566733"
                                          id="566733"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="300522"
                                            id="300522"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              300522,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="59294"
                                          id="59294"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="21963"
                                            id="21963"
                                            value={
                                              this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                0
                                              )?.telefon ?? undefined
                                            }
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                                <KCol
                                  key="387114"
                                  id="387114"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={12}
                                  xxl={12}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 0,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="860116"
                                    id="860116"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 12,
                                        borderTopRightRadius: 12,
                                        borderBottomRightRadius: 12,
                                        borderBottomLeftRadius: 12,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor:
                                          "rgba(244, 248, 251, 1)",
                                        paddingTop: 0,
                                        paddingRight: 8,
                                        paddingBottom: 0,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="229691"
                                      id="229691"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="515824"
                                        id="515824"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="365698"
                                          id="365698"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="652581"
                                            id="652581"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              652581,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 600,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="450799"
                                          id="450799"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        ></KCol>
                                      </KRow>
                                      <KRow
                                        key="271622"
                                        id="271622"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="940110"
                                          id="940110"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="695712"
                                            id="695712"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              695712,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="169556"
                                          id="169556"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <HorizontalStack
                                            key="930685"
                                            id="930685"
                                            visibility={
                                              this.state.isComp930685Visible
                                            }
                                            direction="horizontal"
                                            size={2}
                                            overflowX="auto"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Icon
                                              key="910684"
                                              id="910684"
                                              iconName="check_circle"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "20px",
                                                  color:
                                                    "rgba(114, 194, 64, 1)",
                                                  letterSpacing: "1px",
                                                } as any
                                              }
                                            ></Icon>
                                            <Label
                                              key="819965"
                                              id="819965"
                                              value={
                                                this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                  0
                                                )?.kesif_Tarih ?? undefined
                                              }
                                              formatter="date"
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                } as any
                                              }
                                            ></Label>
                                            <Label
                                              key="189120"
                                              id="189120"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                189120,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                } as any
                                              }
                                            ></Label>
                                            <Label
                                              key="726292"
                                              id="726292"
                                              value={
                                                this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                  0
                                                )?.netKesif_KullaniciAdi ??
                                                undefined
                                              }
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                } as any
                                              }
                                            ></Label>
                                          </HorizontalStack>
                                          <HorizontalStack
                                            key="200548"
                                            id="200548"
                                            visibility={
                                              this.state.isComp200548Visible
                                            }
                                            direction="horizontal"
                                            size={2}
                                            overflowX="auto"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Icon
                                              key="780701"
                                              id="780701"
                                              iconName="hourglass_bottom"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "20px",
                                                  color:
                                                    "rgba(245, 166, 35, 1)",
                                                  letterSpacing: "1px",
                                                } as any
                                              }
                                            ></Icon>
                                            <Label
                                              key="682190"
                                              id="682190"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                682190,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                  color:
                                                    "rgba(245, 166, 35, 1)",
                                                } as any
                                              }
                                            ></Label>
                                          </HorizontalStack>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="26237"
                                        id="26237"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="437331"
                                          id="437331"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="942475"
                                            id="942475"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              942475,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="447861"
                                          id="447861"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <HorizontalStack
                                            key="38139"
                                            id="38139"
                                            visibility={
                                              this.state.isComp38139Visible
                                            }
                                            direction="horizontal"
                                            size={2}
                                            overflowX="auto"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Icon
                                              key="75067"
                                              id="75067"
                                              iconName="check_circle"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "20px",
                                                  color:
                                                    "rgba(114, 194, 64, 1)",
                                                  letterSpacing: "1px",
                                                } as any
                                              }
                                            ></Icon>
                                            <Label
                                              key="32769"
                                              id="32769"
                                              value={
                                                this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                  0
                                                )?.proforma_Tarih ?? undefined
                                              }
                                              formatter="date"
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                } as any
                                              }
                                            ></Label>
                                            <Label
                                              key="125778"
                                              id="125778"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                125778,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                } as any
                                              }
                                            ></Label>
                                            <Label
                                              key="726526"
                                              id="726526"
                                              value={
                                                this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                  0
                                                )?.proforma_KullaniciAdi ??
                                                undefined
                                              }
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                } as any
                                              }
                                            ></Label>
                                          </HorizontalStack>
                                          <HorizontalStack
                                            key="230193"
                                            id="230193"
                                            visibility={
                                              this.state.isComp230193Visible
                                            }
                                            direction="horizontal"
                                            size={2}
                                            overflowX="auto"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Icon
                                              key="916268"
                                              id="916268"
                                              iconName="hourglass_bottom"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "20px",
                                                  color:
                                                    "rgba(245, 166, 35, 1)",
                                                  letterSpacing: "1px",
                                                } as any
                                              }
                                            ></Icon>
                                            <Label
                                              key="50774"
                                              id="50774"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                50774,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                  color:
                                                    "rgba(245, 166, 35, 1)",
                                                } as any
                                              }
                                            ></Label>
                                          </HorizontalStack>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="813259"
                                        id="813259"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="297788"
                                          id="297788"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="569873"
                                            id="569873"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              569873,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="810903"
                                          id="810903"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <HorizontalStack
                                            key="108416"
                                            id="108416"
                                            visibility={
                                              this.state.isComp108416Visible
                                            }
                                            direction="horizontal"
                                            size={2}
                                            overflowX="auto"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Icon
                                              key="292696"
                                              id="292696"
                                              iconName="check_circle"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "20px",
                                                  color:
                                                    "rgba(114, 194, 64, 1)",
                                                  letterSpacing: "1px",
                                                } as any
                                              }
                                            ></Icon>
                                            <Label
                                              key="776921"
                                              id="776921"
                                              value={
                                                this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                  0
                                                )?.netKesif_Tarih ?? undefined
                                              }
                                              formatter="date"
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                } as any
                                              }
                                            ></Label>
                                            <Label
                                              key="398768"
                                              id="398768"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                398768,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                } as any
                                              }
                                            ></Label>
                                            <Label
                                              key="735264"
                                              id="735264"
                                              value={
                                                this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                  0
                                                )?.netKesif_KullaniciAdi ??
                                                undefined
                                              }
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                } as any
                                              }
                                            ></Label>
                                          </HorizontalStack>
                                          <HorizontalStack
                                            key="167824"
                                            id="167824"
                                            visibility={
                                              this.state.isComp167824Visible
                                            }
                                            direction="horizontal"
                                            size={2}
                                            overflowX="auto"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Icon
                                              key="508890"
                                              id="508890"
                                              iconName="hourglass_bottom"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "20px",
                                                  color:
                                                    "rgba(245, 166, 35, 1)",
                                                  letterSpacing: "1px",
                                                } as any
                                              }
                                            ></Icon>
                                            <Label
                                              key="245857"
                                              id="245857"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                245857,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                  color:
                                                    "rgba(245, 166, 35, 1)",
                                                } as any
                                              }
                                            ></Label>
                                          </HorizontalStack>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="931560"
                                        id="931560"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="569668"
                                          id="569668"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="66815"
                                            id="66815"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              66815,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="641592"
                                          id="641592"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <HorizontalStack
                                            key="995070"
                                            id="995070"
                                            visibility={
                                              this.state.isComp995070Visible
                                            }
                                            direction="horizontal"
                                            size={2}
                                            overflowX="auto"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Icon
                                              key="85176"
                                              id="85176"
                                              iconName="check_circle"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "20px",
                                                  color:
                                                    "rgba(114, 194, 64, 1)",
                                                  letterSpacing: "1px",
                                                } as any
                                              }
                                            ></Icon>
                                            <Label
                                              key="916010"
                                              id="916010"
                                              value={
                                                this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                  0
                                                )?.pM_OnayTarih ?? undefined
                                              }
                                              formatter="date"
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                } as any
                                              }
                                            ></Label>
                                            <Label
                                              key="501661"
                                              id="501661"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                501661,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                } as any
                                              }
                                            ></Label>
                                            <Label
                                              key="365802"
                                              id="365802"
                                              value={
                                                this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                  0
                                                )?.pM_OnaylayanAdi ?? undefined
                                              }
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                } as any
                                              }
                                            ></Label>
                                          </HorizontalStack>
                                          <HorizontalStack
                                            key="606562"
                                            id="606562"
                                            visibility={
                                              this.state.isComp606562Visible
                                            }
                                            direction="horizontal"
                                            size={2}
                                            overflowX="auto"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Icon
                                              key="277478"
                                              id="277478"
                                              iconName="hourglass_bottom"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "20px",
                                                  color:
                                                    "rgba(245, 166, 35, 1)",
                                                  letterSpacing: "1px",
                                                } as any
                                              }
                                            ></Icon>
                                            <Label
                                              key="928750"
                                              id="928750"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                928750,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                  color:
                                                    "rgba(245, 166, 35, 1)",
                                                } as any
                                              }
                                            ></Label>
                                          </HorizontalStack>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="38486"
                                        id="38486"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="671526"
                                          id="671526"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="954260"
                                            id="954260"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              954260,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="65528"
                                          id="65528"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <HorizontalStack
                                            key="777039"
                                            id="777039"
                                            visibility={
                                              this.state.isComp777039Visible
                                            }
                                            direction="horizontal"
                                            size={2}
                                            overflowX="auto"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Icon
                                              key="396593"
                                              id="396593"
                                              iconName="check_circle"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "20px",
                                                  color:
                                                    "rgba(114, 194, 64, 1)",
                                                  letterSpacing: "1px",
                                                } as any
                                              }
                                            ></Icon>
                                            <Label
                                              key="295328"
                                              id="295328"
                                              value={
                                                this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                  -1
                                                )?.uY_OnayTarih ?? undefined
                                              }
                                              formatter="date"
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                } as any
                                              }
                                            ></Label>
                                            <Label
                                              key="964154"
                                              id="964154"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                964154,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                } as any
                                              }
                                            ></Label>
                                            <Label
                                              key="511988"
                                              id="511988"
                                              value={
                                                this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                  -1
                                                )?.uY_OnaylayanAdi ?? undefined
                                              }
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                } as any
                                              }
                                            ></Label>
                                          </HorizontalStack>
                                          <HorizontalStack
                                            key="682157"
                                            id="682157"
                                            visibility={
                                              this.state.isComp682157Visible
                                            }
                                            direction="horizontal"
                                            size={2}
                                            overflowX="auto"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Icon
                                              key="41512"
                                              id="41512"
                                              iconName="hourglass_bottom"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "20px",
                                                  color:
                                                    "rgba(245, 166, 35, 1)",
                                                  letterSpacing: "1px",
                                                } as any
                                              }
                                            ></Icon>
                                            <Label
                                              key="311614"
                                              id="311614"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                311614,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                  color:
                                                    "rgba(245, 166, 35, 1)",
                                                } as any
                                              }
                                            ></Label>
                                          </HorizontalStack>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                              <KRow
                                key="337615"
                                id="337615"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingBottom: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="457735"
                                  id="457735"
                                  visibility={this.state.isComp457735Visible}
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 0,
                                      paddingBottom: 8,
                                      paddingLeft: 0,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="850424"
                                    id="850424"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 12,
                                        borderTopRightRadius: 12,
                                        borderBottomRightRadius: 12,
                                        borderBottomLeftRadius: 12,
                                        borderTopWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                        borderLeftWidth: 1,
                                        borderColor:
                                          "rgba(203, 179, 242, 0.66)",
                                        borderStyle: "solid",
                                        backgroundColor:
                                          "rgba(203, 179, 242, 0.36)",
                                        paddingTop: 0,
                                        paddingRight: 8,
                                        paddingBottom: 0,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="488869"
                                      id="488869"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="989463"
                                        id="989463"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="14922"
                                          id="14922"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="644014"
                                            id="644014"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              644014,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "12px",
                                                color: "rgba(106, 50, 201, 1)",
                                              } as any
                                            }
                                          ></Label>
                                          <KRow
                                            key="201002"
                                            id="201002"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 8,
                                                paddingLeft: 0,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="169804"
                                              id="169804"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={6}
                                              xxl={6}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="451066"
                                                id="451066"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="851781"
                                                  id="851781"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 8,
                                                      borderTopRightRadius: 8,
                                                      borderBottomRightRadius: 8,
                                                      borderBottomLeftRadius: 8,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(255, 255, 255, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign:
                                                        "-webkit-center",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="469559"
                                                    id="469559"
                                                    direction="vertical"
                                                    size={2}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="979930"
                                                      id="979930"
                                                      value={
                                                        this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                          0
                                                        )?.kesif_TahminiGuc ??
                                                        undefined
                                                      }
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "16px",
                                                          color:
                                                            "rgba(106, 50, 201, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <Label
                                                      key="921297"
                                                      id="921297"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        921297,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "12px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                            <KCol
                                              key="584131"
                                              id="584131"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={6}
                                              xxl={6}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="96358"
                                                id="96358"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="852248"
                                                  id="852248"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 8,
                                                      borderTopRightRadius: 8,
                                                      borderBottomRightRadius: 8,
                                                      borderBottomLeftRadius: 8,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(255, 255, 255, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign:
                                                        "-webkit-center",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="47577"
                                                    id="47577"
                                                    direction="vertical"
                                                    size={2}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="120818"
                                                      id="120818"
                                                      value={
                                                        this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                          0
                                                        )?.kesif_AlanM2 ??
                                                        undefined
                                                      }
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "16px",
                                                          color:
                                                            "rgba(106, 50, 201, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <Label
                                                      key="892535"
                                                      id="892535"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        892535,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "12px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                            <KCol
                                              key="817311"
                                              id="817311"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={6}
                                              xxl={6}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="958768"
                                                id="958768"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="976590"
                                                  id="976590"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 8,
                                                      borderTopRightRadius: 8,
                                                      borderBottomRightRadius: 8,
                                                      borderBottomLeftRadius: 8,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(255, 255, 255, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign:
                                                        "-webkit-center",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="956412"
                                                    id="956412"
                                                    direction="vertical"
                                                    size={2}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="300623"
                                                      id="300623"
                                                      value={
                                                        this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                          0
                                                        )?.teknik_CatiTipi ??
                                                        undefined
                                                      }
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "16px",
                                                          color:
                                                            "rgba(106, 50, 201, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <Label
                                                      key="210361"
                                                      id="210361"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        210361,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "12px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                            <KCol
                                              key="404081"
                                              id="404081"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={6}
                                              xxl={6}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="463218"
                                                id="463218"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="116221"
                                                  id="116221"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 8,
                                                      borderTopRightRadius: 8,
                                                      borderBottomRightRadius: 8,
                                                      borderBottomLeftRadius: 8,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(255, 255, 255, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign:
                                                        "-webkit-center",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="664097"
                                                    id="664097"
                                                    direction="vertical"
                                                    size={2}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="379284"
                                                      id="379284"
                                                      value={
                                                        this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                          0
                                                        )
                                                          ?.onKesif_ToplamMaliyet ??
                                                        undefined
                                                      }
                                                      formatter="money-tl"
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 600,
                                                          fontSize: "16px",
                                                          color:
                                                            "rgba(106, 50, 201, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <Label
                                                      key="416312"
                                                      id="416312"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        416312,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "12px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                          </KRow>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                        </KTabItem>
                        <KTabItem
                          key={367991}
                          id="367991"
                          onActive={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.CatiGesOnSureclerComponent_367991_onActive();
                          }}
                          visibility={
                            this.state
                              .isCompcatigesonsurecler_367991AuthorizationVisible
                          }
                          visibilityByAuthorization={
                            this.state
                              .isCompcatigesonsurecler_367991AuthorizationVisible
                          }
                          tab={ReactSystemFunctions.translate(
                            this.ml,
                            367991,
                            "tab",
                            this.defaultML
                          )}
                          forceRender={false}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(255, 255, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KRow
                            key="171653"
                            id="171653"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <KCol
                              key="489532"
                              id="489532"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderTopLeftRadius: 16,
                                  borderTopRightRadius: 16,
                                  borderBottomRightRadius: 16,
                                  borderBottomLeftRadius: 16,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(244, 248, 251, 1)",
                                  borderStyle: "solid",
                                  paddingBottom: 8,
                                } as any
                              }
                            >
                              <KRow
                                key="378288"
                                id="378288"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="858794"
                                  id="858794"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 16,
                                      borderTopRightRadius: 16,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(244, 248, 251, 1)",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="519212"
                                    id="519212"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="891905"
                                      id="891905"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <Label
                                        key="503808"
                                        id="503808"
                                        value={ReactSystemFunctions.translate(
                                          this.ml,
                                          503808,
                                          "value",
                                          this.defaultML
                                        )}
                                        writingMode="horizontal"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      ></Label>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                              <KRow
                                key="616000"
                                id="616000"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="273269"
                                  id="273269"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="666807"
                                    id="666807"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="735009"
                                      id="735009"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="897457"
                                        id="897457"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="440869"
                                          id="440869"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            440869,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_913183_value"
                                        >
                                          <KDatePicker
                                            key="913183"
                                            id="913183"
                                            kuikaRef={
                                              this
                                                .catigesonsurecler_913183_value_kuikaDateRef
                                            }
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              913183,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={true}
                                            format="DD/MM/YYYY"
                                            displayType="date"
                                            returnDisplayValue={false}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></KDatePicker>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="436977"
                                      id="436977"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="46465"
                                        id="46465"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="906806"
                                          id="906806"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            906806,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_662082_value"
                                        >
                                          <KSelectBox
                                            key="662082"
                                            id="662082"
                                            kuikaRef={
                                              this
                                                .catigesonsurecler_662082_value_kuikaSelectBoxRef
                                            }
                                            options={
                                              this.state.GET_SATIS_TEMSILCISI
                                            }
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              662082,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={false}
                                            autoClearSearchValue={true}
                                            showSearch={false}
                                            widthType="fill"
                                            containsNullItem={false}
                                            sortBy="none"
                                            datavaluefield="kuserid"
                                            datatextfield="firstname"
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></KSelectBox>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="735198"
                                      id="735198"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="640089"
                                        id="640089"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="824192"
                                          id="824192"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            824192,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_203346_value"
                                        >
                                          <TextInput
                                            key="203346"
                                            id="203346"
                                            kuikaRef={
                                              this
                                                .catigesonsurecler_203346_value_kuikaTextInputRef
                                            }
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              203346,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={false}
                                            bordered={true}
                                            disabled={false}
                                            type="text"
                                            iconColor="rgba(0, 0, 0, 1)"
                                            formatter="None"
                                            isCharOnly={false}
                                            autoComplete={true}
                                            inputMode="all"
                                            speechToText={false}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></TextInput>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                          <KRow
                            key="934117"
                            id="934117"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <KCol
                              key="26184"
                              id="26184"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderTopLeftRadius: 16,
                                  borderTopRightRadius: 16,
                                  borderBottomRightRadius: 16,
                                  borderBottomLeftRadius: 16,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(244, 248, 251, 1)",
                                  borderStyle: "solid",
                                  paddingBottom: 8,
                                } as any
                              }
                            >
                              <KRow
                                key="872446"
                                id="872446"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="821512"
                                  id="821512"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 16,
                                      borderTopRightRadius: 16,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(244, 248, 251, 1)",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="858396"
                                    id="858396"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="253110"
                                      id="253110"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <Label
                                        key="319997"
                                        id="319997"
                                        value={ReactSystemFunctions.translate(
                                          this.ml,
                                          319997,
                                          "value",
                                          this.defaultML
                                        )}
                                        writingMode="horizontal"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      ></Label>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                              <KRow
                                key="963680"
                                id="963680"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="36795"
                                  id="36795"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="367696"
                                    id="367696"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="965080"
                                      id="965080"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="912040"
                                        id="912040"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="813625"
                                          id="813625"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            813625,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_14467_value"
                                        >
                                          <NumberInput
                                            key="14467"
                                            id="14467"
                                            decimalSeparator=","
                                            decimalScale={2}
                                            disabled={false}
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              14467,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            fixedDecimalScale={false}
                                            allowNegative={true}
                                            allowEmptyFormatting={false}
                                            isThousandSeperatorOn={true}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></NumberInput>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="133635"
                                      id="133635"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="552765"
                                        id="552765"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="588963"
                                          id="588963"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            588963,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_707377_value"
                                        >
                                          <KSelectBox
                                            key="707377"
                                            id="707377"
                                            kuikaRef={
                                              this
                                                .catigesonsurecler_707377_value_kuikaSelectBoxRef
                                            }
                                            options={
                                              this.state.dataSource_707377
                                            }
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              707377,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={false}
                                            autoClearSearchValue={true}
                                            showSearch={false}
                                            widthType="fill"
                                            containsNullItem={false}
                                            sortBy="none"
                                            datavaluefield="key"
                                            datatextfield="text"
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></KSelectBox>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="377696"
                                      id="377696"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="85481"
                                        id="85481"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="716896"
                                          id="716896"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            716896,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_766200_value"
                                        >
                                          <NumberInput
                                            key="766200"
                                            id="766200"
                                            decimalSeparator=","
                                            decimalScale={2}
                                            disabled={false}
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              766200,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            fixedDecimalScale={false}
                                            allowNegative={true}
                                            allowEmptyFormatting={false}
                                            isThousandSeperatorOn={true}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></NumberInput>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="434795"
                                      id="434795"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="671821"
                                        id="671821"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="398710"
                                          id="398710"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            398710,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_145387_value"
                                        >
                                          <NumberInput
                                            key="145387"
                                            id="145387"
                                            decimalSeparator=","
                                            decimalScale={2}
                                            disabled={false}
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              145387,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            fixedDecimalScale={false}
                                            allowNegative={true}
                                            allowEmptyFormatting={false}
                                            isThousandSeperatorOn={true}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></NumberInput>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="307427"
                                      id="307427"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="549416"
                                        id="549416"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="152274"
                                          id="152274"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            152274,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_743336_value"
                                        >
                                          <NumberInput
                                            key="743336"
                                            id="743336"
                                            decimalSeparator=","
                                            decimalScale={2}
                                            disabled={false}
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              743336,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            fixedDecimalScale={false}
                                            allowNegative={true}
                                            allowEmptyFormatting={false}
                                            isThousandSeperatorOn={true}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></NumberInput>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                          <KRow
                            key="242884"
                            id="242884"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <KCol
                              key="521554"
                              id="521554"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderTopLeftRadius: 16,
                                  borderTopRightRadius: 16,
                                  borderBottomRightRadius: 16,
                                  borderBottomLeftRadius: 16,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(244, 248, 251, 1)",
                                  borderStyle: "solid",
                                  paddingBottom: 8,
                                } as any
                              }
                            >
                              <KRow
                                key="482842"
                                id="482842"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="545950"
                                  id="545950"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 16,
                                      borderTopRightRadius: 16,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(244, 248, 251, 1)",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="374542"
                                    id="374542"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="820483"
                                      id="820483"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <Label
                                        key="340500"
                                        id="340500"
                                        value={ReactSystemFunctions.translate(
                                          this.ml,
                                          340500,
                                          "value",
                                          this.defaultML
                                        )}
                                        writingMode="horizontal"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      ></Label>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                              <KRow
                                key="946463"
                                id="946463"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="241309"
                                  id="241309"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="865929"
                                    id="865929"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="320938"
                                      id="320938"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="353970"
                                        id="353970"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="66394"
                                          id="66394"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            66394,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_166467_value"
                                        >
                                          <KSelectBox
                                            key="166467"
                                            id="166467"
                                            kuikaRef={
                                              this
                                                .catigesonsurecler_166467_value_kuikaSelectBoxRef
                                            }
                                            options={
                                              this.state.dataSource_166467
                                            }
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              166467,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={false}
                                            autoClearSearchValue={true}
                                            showSearch={false}
                                            widthType="fill"
                                            containsNullItem={false}
                                            sortBy="none"
                                            datavaluefield="key"
                                            datatextfield="text"
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></KSelectBox>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="832778"
                                      id="832778"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="836091"
                                        id="836091"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="333518"
                                          id="333518"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            333518,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_724523_value"
                                        >
                                          <NumberInput
                                            key="724523"
                                            id="724523"
                                            decimalSeparator=","
                                            decimalScale={2}
                                            disabled={false}
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              724523,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            fixedDecimalScale={false}
                                            allowNegative={true}
                                            allowEmptyFormatting={false}
                                            isThousandSeperatorOn={true}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></NumberInput>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="640269"
                                      id="640269"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="545597"
                                        id="545597"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="287977"
                                          id="287977"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            287977,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_380385_value"
                                        >
                                          <KSelectBox
                                            key="380385"
                                            id="380385"
                                            kuikaRef={
                                              this
                                                .catigesonsurecler_380385_value_kuikaSelectBoxRef
                                            }
                                            options={
                                              this.state.dataSource_380385
                                            }
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              380385,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={false}
                                            autoClearSearchValue={true}
                                            showSearch={false}
                                            widthType="fill"
                                            containsNullItem={false}
                                            sortBy="none"
                                            datavaluefield="key"
                                            datatextfield="text"
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></KSelectBox>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="380816"
                                      id="380816"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="9737"
                                        id="9737"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="595525"
                                          id="595525"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            595525,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_886075_value"
                                        >
                                          <NumberInput
                                            key="886075"
                                            id="886075"
                                            decimalSeparator=","
                                            decimalScale={2}
                                            disabled={false}
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              886075,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            fixedDecimalScale={false}
                                            allowNegative={true}
                                            allowEmptyFormatting={false}
                                            isThousandSeperatorOn={true}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></NumberInput>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="401404"
                                      id="401404"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="838824"
                                        id="838824"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="386476"
                                          id="386476"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            386476,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_950845_value"
                                        >
                                          <NumberInput
                                            key="950845"
                                            id="950845"
                                            decimalSeparator=","
                                            decimalScale={2}
                                            disabled={false}
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              950845,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            fixedDecimalScale={false}
                                            allowNegative={true}
                                            allowEmptyFormatting={false}
                                            isThousandSeperatorOn={true}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></NumberInput>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="64170"
                                      id="64170"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="414773"
                                        id="414773"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="517137"
                                          id="517137"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            517137,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_323299_value"
                                        >
                                          <NumberInput
                                            key="323299"
                                            id="323299"
                                            decimalSeparator=","
                                            decimalScale={2}
                                            disabled={false}
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              323299,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            fixedDecimalScale={false}
                                            allowNegative={true}
                                            allowEmptyFormatting={false}
                                            isThousandSeperatorOn={true}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></NumberInput>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                  </KRow>
                                  <KRow
                                    key="467144"
                                    id="467144"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="468353"
                                      id="468353"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 16,
                                          paddingBottom: 0,
                                          paddingLeft: 16,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="101016"
                                        id="101016"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="971603"
                                          id="971603"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            971603,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_246942_value"
                                        >
                                          <TextArea
                                            key="246942"
                                            id="246942"
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              246942,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={false}
                                            autoSize={false}
                                            showCount={false}
                                            formatter="None"
                                            readOnly={false}
                                            speechToText={false}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></TextArea>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                          <KRow
                            key="715401"
                            id="715401"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <KCol
                              key="544341"
                              id="544341"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderTopLeftRadius: 16,
                                  borderTopRightRadius: 16,
                                  borderBottomRightRadius: 16,
                                  borderBottomLeftRadius: 16,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(244, 248, 251, 1)",
                                  borderStyle: "solid",
                                  paddingBottom: 8,
                                } as any
                              }
                            >
                              <KRow
                                key="307983"
                                id="307983"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="620325"
                                  id="620325"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 16,
                                      borderTopRightRadius: 16,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(244, 248, 251, 1)",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="579222"
                                    id="579222"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="251368"
                                      id="251368"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <Label
                                        key="536916"
                                        id="536916"
                                        value={ReactSystemFunctions.translate(
                                          this.ml,
                                          536916,
                                          "value",
                                          this.defaultML
                                        )}
                                        writingMode="horizontal"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      ></Label>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                              <KRow
                                key="567751"
                                id="567751"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="549854"
                                  id="549854"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="866190"
                                    id="866190"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="439975"
                                      id="439975"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="311109"
                                        id="311109"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="442969"
                                          id="442969"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            442969,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_681014_value"
                                        >
                                          <KSelectBox
                                            key="681014"
                                            id="681014"
                                            kuikaRef={
                                              this
                                                .catigesonsurecler_681014_value_kuikaSelectBoxRef
                                            }
                                            options={
                                              this.state.dataSource_681014
                                            }
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              681014,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={false}
                                            autoClearSearchValue={true}
                                            showSearch={false}
                                            widthType="fill"
                                            containsNullItem={false}
                                            sortBy="none"
                                            datavaluefield="key"
                                            datatextfield="text"
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></KSelectBox>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="530937"
                                      id="530937"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="63026"
                                        id="63026"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="763866"
                                          id="763866"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            763866,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_585296_value"
                                        >
                                          <TextInput
                                            key="585296"
                                            id="585296"
                                            kuikaRef={
                                              this
                                                .catigesonsurecler_585296_value_kuikaTextInputRef
                                            }
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              585296,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={false}
                                            bordered={true}
                                            disabled={false}
                                            type="text"
                                            iconColor="rgba(0, 0, 0, 1)"
                                            formatter="None"
                                            isCharOnly={false}
                                            autoComplete={true}
                                            inputMode="all"
                                            speechToText={false}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></TextInput>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="22465"
                                      id="22465"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="270324"
                                        id="270324"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="763120"
                                          id="763120"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            763120,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_629508_value"
                                        >
                                          <TextInput
                                            key="629508"
                                            id="629508"
                                            kuikaRef={
                                              this
                                                .catigesonsurecler_629508_value_kuikaTextInputRef
                                            }
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              629508,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={false}
                                            bordered={true}
                                            disabled={false}
                                            type="text"
                                            iconColor="rgba(0, 0, 0, 1)"
                                            formatter="None"
                                            isCharOnly={false}
                                            autoComplete={true}
                                            inputMode="all"
                                            speechToText={false}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></TextInput>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                          <KRow
                            key="783440"
                            id="783440"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <KCol
                              key="515371"
                              id="515371"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderTopLeftRadius: 16,
                                  borderTopRightRadius: 16,
                                  borderBottomRightRadius: 16,
                                  borderBottomLeftRadius: 16,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(244, 248, 251, 1)",
                                  borderStyle: "solid",
                                  paddingBottom: 8,
                                } as any
                              }
                            >
                              <KRow
                                key="335025"
                                id="335025"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="645563"
                                  id="645563"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 16,
                                      borderTopRightRadius: 16,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(244, 248, 251, 1)",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="482713"
                                    id="482713"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="25941"
                                      id="25941"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <Label
                                        key="927333"
                                        id="927333"
                                        value={ReactSystemFunctions.translate(
                                          this.ml,
                                          927333,
                                          "value",
                                          this.defaultML
                                        )}
                                        writingMode="horizontal"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      ></Label>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                              <KRow
                                key="135954"
                                id="135954"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="141819"
                                  id="141819"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="465133"
                                    id="465133"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="736727"
                                      id="736727"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="827543"
                                        id="827543"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="893765"
                                          id="893765"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            893765,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_946973_value"
                                        >
                                          <TextInput
                                            key="946973"
                                            id="946973"
                                            kuikaRef={
                                              this
                                                .catigesonsurecler_946973_value_kuikaTextInputRef
                                            }
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              946973,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={false}
                                            bordered={true}
                                            disabled={false}
                                            type="text"
                                            iconColor="rgba(0, 0, 0, 1)"
                                            formatter="None"
                                            isCharOnly={false}
                                            autoComplete={true}
                                            inputMode="all"
                                            speechToText={false}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></TextInput>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="170955"
                                      id="170955"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="904797"
                                        id="904797"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="185287"
                                          id="185287"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            185287,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_394531_value"
                                        >
                                          <TextInput
                                            key="394531"
                                            id="394531"
                                            kuikaRef={
                                              this
                                                .catigesonsurecler_394531_value_kuikaTextInputRef
                                            }
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              394531,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={false}
                                            bordered={true}
                                            disabled={false}
                                            type="text"
                                            iconColor="rgba(0, 0, 0, 1)"
                                            formatter="None"
                                            isCharOnly={false}
                                            autoComplete={true}
                                            inputMode="all"
                                            speechToText={false}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></TextInput>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="702065"
                                      id="702065"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="438521"
                                        id="438521"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="621953"
                                          id="621953"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            621953,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_397937_value"
                                        >
                                          <TextInput
                                            key="397937"
                                            id="397937"
                                            kuikaRef={
                                              this
                                                .catigesonsurecler_397937_value_kuikaTextInputRef
                                            }
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              397937,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={false}
                                            bordered={true}
                                            disabled={false}
                                            type="text"
                                            iconColor="rgba(0, 0, 0, 1)"
                                            formatter="None"
                                            isCharOnly={false}
                                            autoComplete={true}
                                            inputMode="all"
                                            speechToText={false}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                height: "35px",
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></TextInput>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                          <KRow
                            key="201429"
                            id="201429"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <KCol
                              key="470976"
                              id="470976"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderTopLeftRadius: 16,
                                  borderTopRightRadius: 16,
                                  borderBottomRightRadius: 16,
                                  borderBottomLeftRadius: 16,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(244, 248, 251, 1)",
                                  borderStyle: "solid",
                                  paddingBottom: 8,
                                } as any
                              }
                            >
                              <KRow
                                key="311881"
                                id="311881"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="916093"
                                  id="916093"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 16,
                                      borderTopRightRadius: 16,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(244, 248, 251, 1)",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="719090"
                                    id="719090"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="985392"
                                      id="985392"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <Label
                                        key="777770"
                                        id="777770"
                                        value={ReactSystemFunctions.translate(
                                          this.ml,
                                          777770,
                                          "value",
                                          this.defaultML
                                        )}
                                        writingMode="horizontal"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      ></Label>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                              <KRow
                                key="470589"
                                id="470589"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="89165"
                                  id="89165"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="673426"
                                    id="673426"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="550856"
                                      id="550856"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KTable
                                        key="478263"
                                        id="478263"
                                        kuikaRef={
                                          this
                                            .catigesonsurecler_478263_value_kuikaTableRef
                                        }
                                        form={this.props.form}
                                        dataSource={this.state.KalemleriGetir}
                                        size="middle"
                                        bordered={true}
                                        loading={false}
                                        rowKey="id"
                                        transformedOnMobileResolution={false}
                                        hideHeaderOnMobileResolution={false}
                                        showHeader={false}
                                        fixedHeader={false}
                                        tableWidthMode="fit"
                                        editable={false}
                                        editableAlwaysActive={false}
                                        insertRowActive={false}
                                        insertRowPosition="top"
                                        globalSearch={false}
                                        searchable={false}
                                        shouldSearchOnChange={true}
                                        searchDelay={200}
                                        sorter={false}
                                        filtering={false}
                                        resizableColumns={false}
                                        pagination={false}
                                        pageSize={10}
                                        showSizeChanger={false}
                                        paginationSelectedTextColor="#246eff"
                                        paginationUnselectedTextColor="#000"
                                        columnChooser={false}
                                        striped={false}
                                        stripedColor="#F5F7FA"
                                        rowHoverBgColor="#fafafa"
                                        showRowNumbers={false}
                                        showNoDataFound={true}
                                        nodatafoundmessage={ReactSystemFunctions.translate(
                                          this.ml,
                                          478263,
                                          "nodatafoundmessage",
                                          this.defaultML
                                        )}
                                        multiSelect={false}
                                        multiSelectScope="page"
                                        export={false}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KTableHeader
                                          key="889800"
                                          id="889800"
                                          hideOnMobileResolution={false}
                                          textDirection="Default"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 400,
                                              fontSize: "12px",
                                              color: "rgba(155, 155, 155, 1)",
                                              lineHeight: "20px",
                                            } as any
                                          }
                                        ></KTableHeader>
                                        <KTableRow
                                          key="385029"
                                          id="385029"
                                          hoverFontColor="red"
                                          hoverBgColor="#F5F5F5"
                                          style={
                                            {
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KTableColumn
                                            key="686210"
                                            id="686210"
                                            title={ReactSystemFunctions.translate(
                                              this.ml,
                                              686210,
                                              "title",
                                              this.defaultML
                                            )}
                                            alwaysVisibleOnMobileResolution={
                                              false
                                            }
                                            hideFiltering={false}
                                            hideSorting={false}
                                            hideSearch={false}
                                            footerOptions="none"
                                            footerFontSize={14}
                                            footerFontColor="rgb(68, 68, 68)"
                                            excludeFromExport={false}
                                            footerFontWeight="Regular"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KRow
                                              key="932883"
                                              id="932883"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="406534"
                                                id="406534"
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={4}
                                                xxl={4}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="796619"
                                                  id="796619"
                                                  value="[datafield:stokKodu]"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "12px",
                                                      color:
                                                        "rgba(44, 62, 80, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                              <KCol
                                                key="457445"
                                                id="457445"
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={4}
                                                xxl={4}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="43044"
                                                  id="43044"
                                                  value="[datafield:stokAdi]"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "12px",
                                                      color:
                                                        "rgba(44, 62, 80, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                              <KCol
                                                key="1102"
                                                id="1102"
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={4}
                                                xxl={4}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="717414"
                                                  id="717414"
                                                  value="[datafield:birimFiyat]"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "12px",
                                                      color:
                                                        "rgba(44, 62, 80, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                              <KCol
                                                key="680335"
                                                id="680335"
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={4}
                                                xxl={4}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="976519"
                                                  id="976519"
                                                  value="[datafield:miktar]"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "12px",
                                                      color:
                                                        "rgba(44, 62, 80, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                              <KCol
                                                key="541067"
                                                id="541067"
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={4}
                                                xxl={4}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="183286"
                                                  id="183286"
                                                  value="[datafield:satırToplam]"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "12px",
                                                      color:
                                                        "rgba(44, 62, 80, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                              <KCol
                                                key="364739"
                                                id="364739"
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={4}
                                                xxl={4}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-center",
                                                  } as any
                                                }
                                              >
                                                <HorizontalStack
                                                  key="918096"
                                                  id="918096"
                                                  direction="horizontal"
                                                  size={12}
                                                  overflowX="auto"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Icon
                                                    key="78287"
                                                    id="78287"
                                                    onClick={(e?: any) => {
                                                      if (
                                                        e &&
                                                        e.stopPropagation
                                                      )
                                                        e.stopPropagation();
                                                      this.CatiGesOnSureclerComponent_78287_onClick();
                                                    }}
                                                    showCursorPointer
                                                    iconName="mode_edit_outline"
                                                    style={
                                                      {
                                                        borderTopLeftRadius: 8,
                                                        borderTopRightRadius: 8,
                                                        borderBottomRightRadius: 8,
                                                        borderBottomLeftRadius: 8,
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        backgroundColor:
                                                          "rgba(13, 150, 212, 0.36)",
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "20px",
                                                        color:
                                                          "rgba(13, 150, 212, 1)",
                                                        letterSpacing: "1px",
                                                      } as any
                                                    }
                                                  ></Icon>
                                                  <Icon
                                                    key="285034"
                                                    id="285034"
                                                    onClick={(e?: any) => {
                                                      if (
                                                        e &&
                                                        e.stopPropagation
                                                      )
                                                        e.stopPropagation();
                                                      this.CatiGesOnSureclerComponent_285034_onClick();
                                                    }}
                                                    showCursorPointer
                                                    iconName="delete"
                                                    style={
                                                      {
                                                        borderTopLeftRadius: 8,
                                                        borderTopRightRadius: 8,
                                                        borderBottomRightRadius: 8,
                                                        borderBottomLeftRadius: 8,
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        backgroundColor:
                                                          "rgba(225, 60, 57, 0.36)",
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "20px",
                                                        color:
                                                          "rgba(218, 84, 82, 1)",
                                                        letterSpacing: "1px",
                                                      } as any
                                                    }
                                                  ></Icon>
                                                </HorizontalStack>
                                              </KCol>
                                            </KRow>
                                          </KTableColumn>
                                        </KTableRow>
                                      </KTable>
                                      <KRow
                                        key="994978"
                                        id="994978"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="124499"
                                          id="124499"
                                          xs={24}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="399883"
                                            id="399883"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="611509"
                                              id="611509"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                611509,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_393036_value"
                                            >
                                              <AutoComplete
                                                key="393036"
                                                id="393036"
                                                onSearch={(e?: any) => {
                                                  if (e && e.stopPropagation)
                                                    e.stopPropagation();
                                                  this.CatiGesOnSureclerComponent_393036_onSearch();
                                                }}
                                                onChange={(e?: any) => {
                                                  if (e && e.stopPropagation)
                                                    e.stopPropagation();
                                                  this.CatiGesOnSureclerComponent_393036_onChange();
                                                }}
                                                kuikaRef={
                                                  this
                                                    .catigesonsurecler_393036_value_kuikaAutoCompleteRef
                                                }
                                                options={
                                                  this.state
                                                    .GET_NETSIS_STOK_LISTESI
                                                }
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  393036,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                allowClear={false}
                                                searchable={true}
                                                datavaluefield="stoK_KODU"
                                                datatextfield="stoK_ADI"
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></AutoComplete>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="73647"
                                          id="73647"
                                          xs={24}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={3}
                                          xxl={3}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="665769"
                                            id="665769"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="335749"
                                              id="335749"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                335749,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_207266_value"
                                            >
                                              <NumberInput
                                                key="207266"
                                                id="207266"
                                                onChange={(e?: any) => {
                                                  if (e && e.stopPropagation)
                                                    e.stopPropagation();
                                                  this.CatiGesOnSureclerComponent_207266_onChange();
                                                }}
                                                decimalSeparator=","
                                                decimalScale={2}
                                                disabled={false}
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  207266,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                fixedDecimalScale={false}
                                                allowNegative={true}
                                                allowEmptyFormatting={false}
                                                isThousandSeperatorOn={true}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></NumberInput>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="337846"
                                          id="337846"
                                          xs={24}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={3}
                                          xxl={3}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="873748"
                                            id="873748"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="345017"
                                              id="345017"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                345017,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_480487_value"
                                            >
                                              <TextInput
                                                key="480487"
                                                id="480487"
                                                editability={
                                                  this.state.isComp480487Enabled
                                                }
                                                kuikaRef={
                                                  this
                                                    .catigesonsurecler_480487_value_kuikaTextInputRef
                                                }
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  480487,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                allowClear={false}
                                                bordered={true}
                                                disabled={false}
                                                type="text"
                                                iconColor="rgba(0, 0, 0, 1)"
                                                formatter="None"
                                                isCharOnly={false}
                                                autoComplete={true}
                                                inputMode="all"
                                                speechToText={false}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></TextInput>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="351008"
                                          id="351008"
                                          xs={24}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={4}
                                          xxl={4}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="738079"
                                            id="738079"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="464718"
                                              id="464718"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                464718,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_353063_value"
                                            >
                                              <NumberInput
                                                key="353063"
                                                id="353063"
                                                editability={
                                                  this.state.isComp353063Enabled
                                                }
                                                decimalSeparator=","
                                                decimalScale={2}
                                                disabled={false}
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  353063,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                fixedDecimalScale={false}
                                                allowNegative={true}
                                                allowEmptyFormatting={false}
                                                isThousandSeperatorOn={true}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></NumberInput>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="145859"
                                          id="145859"
                                          xs={24}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={4}
                                          xxl={4}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="841684"
                                            id="841684"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="542792"
                                              id="542792"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                542792,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_570640_value"
                                            >
                                              <NumberInput
                                                key="570640"
                                                id="570640"
                                                editability={
                                                  this.state.isComp570640Enabled
                                                }
                                                decimalSeparator=","
                                                decimalScale={2}
                                                disabled={false}
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  570640,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                fixedDecimalScale={false}
                                                allowNegative={true}
                                                allowEmptyFormatting={false}
                                                isThousandSeperatorOn={true}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></NumberInput>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="895429"
                                          id="895429"
                                          xs={24}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={2}
                                          xxl={2}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-end",
                                              textAlign: "-webkit-center",
                                            } as any
                                          }
                                        >
                                          <Button
                                            key="740127"
                                            id="740127"
                                            onClick={(e?: any) => {
                                              if (e && e.stopPropagation)
                                                e.stopPropagation();
                                              this.CatiGesOnSureclerComponent_740127_onClick();
                                            }}
                                            showCursorPointer
                                            label={ReactSystemFunctions.translate(
                                              this.ml,
                                              740127,
                                              "label",
                                              this.defaultML
                                            )}
                                            size="middle"
                                            loading={false}
                                            ghost={false}
                                            block={false}
                                            htmlType="button"
                                            icon="add"
                                            iconPosition="left"
                                            danger={false}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                backgroundColor:
                                                  "rgba(13, 150, 212, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 16,
                                                paddingBottom: 8,
                                                paddingLeft: 16,
                                                alignItems: "center",
                                                textAlign: "-webkit-center",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "12px",
                                                color: "rgba(255, 255, 255, 1)",
                                                lineHeight: "22px",
                                              } as any
                                            }
                                          ></Button>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                          <KRow
                            key="183385"
                            id="183385"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <KCol
                              key="235566"
                              id="235566"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderTopLeftRadius: 16,
                                  borderTopRightRadius: 16,
                                  borderBottomRightRadius: 16,
                                  borderBottomLeftRadius: 16,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(244, 248, 251, 1)",
                                  borderStyle: "solid",
                                  paddingBottom: 8,
                                } as any
                              }
                            >
                              <KRow
                                key="152399"
                                id="152399"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="776765"
                                  id="776765"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 16,
                                      borderTopRightRadius: 16,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(244, 248, 251, 1)",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="364869"
                                    id="364869"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="603658"
                                      id="603658"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <Label
                                        key="282201"
                                        id="282201"
                                        value={ReactSystemFunctions.translate(
                                          this.ml,
                                          282201,
                                          "value",
                                          this.defaultML
                                        )}
                                        writingMode="horizontal"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      ></Label>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                              <KRow
                                key="258720"
                                id="258720"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="103701"
                                  id="103701"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="902443"
                                    id="902443"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="64829"
                                      id="64829"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 16,
                                          paddingRight: 16,
                                          paddingBottom: 16,
                                          paddingLeft: 16,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="264462"
                                        id="264462"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="581913"
                                          id="581913"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            581913,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_225026_value"
                                        >
                                          <TextArea
                                            key="225026"
                                            id="225026"
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              225026,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={false}
                                            autoSize={false}
                                            showCount={false}
                                            formatter="None"
                                            readOnly={false}
                                            speechToText={false}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></TextArea>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="591083"
                                      id="591083"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 12,
                                          paddingRight: 16,
                                          paddingBottom: 12,
                                          paddingLeft: 16,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="364711"
                                        id="364711"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="36234"
                                          id="36234"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            36234,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_26200_value"
                                        >
                                          <TextArea
                                            key="26200"
                                            id="26200"
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              26200,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={false}
                                            autoSize={false}
                                            showCount={false}
                                            formatter="None"
                                            readOnly={false}
                                            speechToText={false}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></TextArea>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="305567"
                                      id="305567"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 12,
                                          paddingRight: 16,
                                          paddingBottom: 12,
                                          paddingLeft: 16,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="633738"
                                        id="633738"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="141893"
                                          id="141893"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            141893,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(140, 140, 140, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_122352_value"
                                        >
                                          <TextArea
                                            key="122352"
                                            id="122352"
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              122352,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={false}
                                            autoSize={false}
                                            showCount={false}
                                            formatter="None"
                                            readOnly={false}
                                            speechToText={false}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></TextArea>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                          <KRow
                            key="393330"
                            id="393330"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <KCol
                              key="599071"
                              id="599071"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderTopLeftRadius: 16,
                                  borderTopRightRadius: 16,
                                  borderBottomRightRadius: 16,
                                  borderBottomLeftRadius: 16,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(244, 248, 251, 1)",
                                  borderStyle: "solid",
                                  paddingBottom: 8,
                                } as any
                              }
                            >
                              <KRow
                                key="265351"
                                id="265351"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="31673"
                                  id="31673"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 16,
                                      borderTopRightRadius: 16,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(244, 248, 251, 1)",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="654843"
                                    id="654843"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="403620"
                                      id="403620"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <Label
                                        key="673720"
                                        id="673720"
                                        value={ReactSystemFunctions.translate(
                                          this.ml,
                                          673720,
                                          "value",
                                          this.defaultML
                                        )}
                                        writingMode="horizontal"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      ></Label>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                              <KRow
                                key="468716"
                                id="468716"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="938690"
                                  id="938690"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="969260"
                                    id="969260"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="82626"
                                      id="82626"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderBottomRightRadius: 8,
                                          borderBottomLeftRadius: 8,
                                          borderTopWidth: 1,
                                          borderRightWidth: 1,
                                          borderBottomWidth: 1,
                                          borderLeftWidth: 1,
                                          borderColor: "rgba(217, 217, 217, 1)",
                                          borderStyle: "solid",
                                          backgroundColor:
                                            "rgba(244, 248, 251, 1)",
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 16,
                                          alignItems: "center",
                                          textAlign: "-webkit-center",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="474925"
                                        id="474925"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="452614"
                                          id="452614"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <KRow
                                            key="926357"
                                            id="926357"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="177700"
                                              id="177700"
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={12}
                                              xxl={12}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="923782"
                                                id="923782"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  923782,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="488590"
                                              id="488590"
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={12}
                                              xxl={12}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <Button
                                                key="261776"
                                                id="261776"
                                                onClick={(e?: any) => {
                                                  if (e && e.stopPropagation)
                                                    e.stopPropagation();
                                                  this.CatiGesOnSureclerComponent_261776_onClick();
                                                }}
                                                showCursorPointer
                                                label={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  261776,
                                                  "label",
                                                  this.defaultML
                                                )}
                                                size="middle"
                                                loading={false}
                                                ghost={false}
                                                block={false}
                                                htmlType="button"
                                                icon="attach_email"
                                                iconPosition="left"
                                                danger={false}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    backgroundColor:
                                                      "rgba(13, 150, 212, 0.64)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 16,
                                                    paddingBottom: 8,
                                                    paddingLeft: 16,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-center",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "12px",
                                                    color:
                                                      "rgba(255, 255, 255, 1)",
                                                    lineHeight: "22px",
                                                  } as any
                                                }
                                              ></Button>
                                            </KCol>
                                          </KRow>
                                        </KCol>
                                        <KCol
                                          key="81570"
                                          id="81570"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <KTable
                                            key="801362"
                                            id="801362"
                                            kuikaRef={
                                              this
                                                .catigesonsurecler_801362_value_kuikaTableRef
                                            }
                                            form={this.props.form}
                                            dataSource={
                                              this.state.DosyalariGetir
                                            }
                                            size="middle"
                                            bordered={true}
                                            loading={false}
                                            rowKey="id"
                                            transformedOnMobileResolution={
                                              false
                                            }
                                            hideHeaderOnMobileResolution={false}
                                            showHeader={false}
                                            fixedHeader={false}
                                            tableWidthMode="fit"
                                            editable={false}
                                            editableAlwaysActive={false}
                                            insertRowActive={false}
                                            insertRowPosition="top"
                                            globalSearch={false}
                                            searchable={false}
                                            shouldSearchOnChange={true}
                                            searchDelay={200}
                                            sorter={false}
                                            filtering={false}
                                            resizableColumns={false}
                                            pagination={false}
                                            pageSize={10}
                                            showSizeChanger={false}
                                            paginationSelectedTextColor="#246eff"
                                            paginationUnselectedTextColor="#000"
                                            columnChooser={false}
                                            striped={false}
                                            stripedColor="#F5F7FA"
                                            rowHoverBgColor="#fafafa"
                                            showRowNumbers={false}
                                            showNoDataFound={true}
                                            nodatafoundmessage={ReactSystemFunctions.translate(
                                              this.ml,
                                              801362,
                                              "nodatafoundmessage",
                                              this.defaultML
                                            )}
                                            multiSelect={false}
                                            multiSelectScope="page"
                                            export={false}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KTableHeader
                                              key="941320"
                                              id="941320"
                                              hideOnMobileResolution={false}
                                              textDirection="Default"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                  color:
                                                    "rgba(155, 155, 155, 1)",
                                                  lineHeight: "20px",
                                                } as any
                                              }
                                            ></KTableHeader>
                                            <KTableRow
                                              key="342470"
                                              id="342470"
                                              hoverFontColor="red"
                                              hoverBgColor="#F5F5F5"
                                              style={
                                                {
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KTableColumn
                                                key="850690"
                                                id="850690"
                                                title={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  850690,
                                                  "title",
                                                  this.defaultML
                                                )}
                                                alwaysVisibleOnMobileResolution={
                                                  false
                                                }
                                                hideFiltering={false}
                                                hideSorting={false}
                                                hideSearch={false}
                                                footerOptions="none"
                                                footerFontSize={14}
                                                footerFontColor="rgb(68, 68, 68)"
                                                excludeFromExport={false}
                                                footerFontWeight="Regular"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <KRow
                                                  key="994369"
                                                  id="994369"
                                                  align="top"
                                                  justify="start"
                                                  horizontalGutter={0}
                                                  verticalGutter={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                    } as any
                                                  }
                                                >
                                                  <KCol
                                                    key="75669"
                                                    id="75669"
                                                    xs={24}
                                                    sm={24}
                                                    md={24}
                                                    lg={24}
                                                    xl={12}
                                                    xxl={12}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                      } as any
                                                    }
                                                  >
                                                    <HorizontalStack
                                                      key="297201"
                                                      id="297201"
                                                      direction="horizontal"
                                                      size={12}
                                                      overflowX="auto"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Icon
                                                        key="843769"
                                                        id="843769"
                                                        iconName="assignment"
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "20px",
                                                            color:
                                                              "rgba(155, 155, 155, 1)",
                                                            letterSpacing:
                                                              "1px",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                      <Label
                                                        key="650738"
                                                        id="650738"
                                                        value="[datafield:dosyaAdi]"
                                                        maxLine={20}
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "10px",
                                                            color:
                                                              "rgba(140, 140, 140, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                    </HorizontalStack>
                                                  </KCol>
                                                  <KCol
                                                    key="386453"
                                                    id="386453"
                                                    xs={24}
                                                    sm={24}
                                                    md={24}
                                                    lg={24}
                                                    xl={12}
                                                    xxl={12}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        textAlign:
                                                          "-webkit-right",
                                                      } as any
                                                    }
                                                  >
                                                    <HorizontalStack
                                                      key="953797"
                                                      id="953797"
                                                      direction="horizontal"
                                                      size={12}
                                                      overflowX="auto"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Icon
                                                        key="218119"
                                                        id="218119"
                                                        onClick={(e?: any) => {
                                                          if (
                                                            e &&
                                                            e.stopPropagation
                                                          )
                                                            e.stopPropagation();
                                                          this.CatiGesOnSureclerComponent_218119_onClick();
                                                        }}
                                                        showCursorPointer
                                                        iconName="get_app"
                                                        hoverText="İndir"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 8,
                                                            borderTopRightRadius: 8,
                                                            borderBottomRightRadius: 8,
                                                            borderBottomLeftRadius: 8,
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.36)",
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "20px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                            letterSpacing:
                                                              "1px",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                      <Icon
                                                        key="885016"
                                                        id="885016"
                                                        onClick={(e?: any) => {
                                                          if (
                                                            e &&
                                                            e.stopPropagation
                                                          )
                                                            e.stopPropagation();
                                                          this.CatiGesOnSureclerComponent_885016_onClick();
                                                        }}
                                                        showCursorPointer
                                                        iconName="delete"
                                                        hoverText="Sil"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 8,
                                                            borderTopRightRadius: 8,
                                                            borderBottomRightRadius: 8,
                                                            borderBottomLeftRadius: 8,
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            backgroundColor:
                                                              "rgba(225, 60, 57, 0.36)",
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "20px",
                                                            color:
                                                              "rgba(218, 84, 82, 1)",
                                                            letterSpacing:
                                                              "1px",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                    </HorizontalStack>
                                                  </KCol>
                                                </KRow>
                                              </KTableColumn>
                                            </KTableRow>
                                          </KTable>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                  <KRow
                                    key="237521"
                                    id="237521"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        borderBottomRightRadius: 8,
                                        borderBottomLeftRadius: 8,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor: "rgba(9, 124, 176, 1)",
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="479322"
                                      id="479322"
                                      xs={16}
                                      sm={16}
                                      md={16}
                                      lg={16}
                                      xl={16}
                                      xxl={16}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <Label
                                        key="338419"
                                        id="338419"
                                        value={ReactSystemFunctions.translate(
                                          this.ml,
                                          338419,
                                          "value",
                                          this.defaultML
                                        )}
                                        writingMode="horizontal"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(255, 255, 255, 1)",
                                          } as any
                                        }
                                      ></Label>
                                    </KCol>
                                    <KCol
                                      key="972765"
                                      id="972765"
                                      xs={8}
                                      sm={8}
                                      md={8}
                                      lg={8}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "center",
                                          textAlign: "-webkit-right",
                                        } as any
                                      }
                                    >
                                      <Label
                                        key="742412"
                                        id="742412"
                                        value={
                                          this.state.KalemleriGetir?.at?.(0)
                                            ?.genelToplam ?? undefined
                                        }
                                        formatter="money-tl-4-decimal"
                                        writingMode="horizontal"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 600,
                                            fontSize: "14px",
                                            color: "rgba(255, 255, 255, 1)",
                                          } as any
                                        }
                                      ></Label>
                                    </KCol>
                                  </KRow>
                                  <KRow
                                    key="362879"
                                    id="362879"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="467877"
                                      id="467877"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 30,
                                          paddingRight: 0,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-right",
                                        } as any
                                      }
                                    >
                                      <HorizontalStack
                                        key="102706"
                                        id="102706"
                                        direction="horizontal"
                                        size={12}
                                        overflowX="auto"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Button
                                          key="970414"
                                          id="970414"
                                          onClick={(e?: any) => {
                                            if (e && e.stopPropagation)
                                              e.stopPropagation();
                                            this.CatiGesOnSureclerComponent_970414_onClick();
                                          }}
                                          showCursorPointer
                                          label={ReactSystemFunctions.translate(
                                            this.ml,
                                            970414,
                                            "label",
                                            this.defaultML
                                          )}
                                          size="middle"
                                          loading={false}
                                          ghost={false}
                                          block={false}
                                          htmlType="button"
                                          icon="save"
                                          iconPosition="left"
                                          danger={false}
                                          style={
                                            {
                                              borderTopLeftRadius: 8,
                                              borderTopRightRadius: 8,
                                              borderBottomRightRadius: 8,
                                              borderBottomLeftRadius: 8,
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              backgroundColor:
                                                "rgba(13, 150, 212, 1)",
                                              backgroundRepeat: "no-repeat",
                                              backgroundSize: "contain",
                                              backgroundPosition: "left",
                                              paddingTop: 8,
                                              paddingRight: 16,
                                              paddingBottom: 8,
                                              paddingLeft: 16,
                                              alignItems: "center",
                                              textAlign: "-webkit-center",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "12px",
                                              color: "rgba(255, 255, 255, 1)",
                                              lineHeight: "22px",
                                            } as any
                                          }
                                        ></Button>
                                      </HorizontalStack>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                        </KTabItem>
                        <KTabItem
                          key={832682}
                          id="832682"
                          onActive={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.CatiGesOnSureclerComponent_832682_onActive();
                          }}
                          visibility={
                            this.state
                              .isCompcatigesonsurecler_832682AuthorizationVisible
                          }
                          visibilityByAuthorization={
                            this.state
                              .isCompcatigesonsurecler_832682AuthorizationVisible
                          }
                          tab={ReactSystemFunctions.translate(
                            this.ml,
                            832682,
                            "tab",
                            this.defaultML
                          )}
                          forceRender={false}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(255, 255, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KCol
                            key="658487"
                            id="658487"
                            editability={this.state.isComp658487Enabled}
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <KRow
                              key="802964"
                              id="802964"
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                } as any
                              }
                            >
                              <KCol
                                key="328563"
                                id="328563"
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderTopLeftRadius: 16,
                                    borderTopRightRadius: 16,
                                    borderBottomRightRadius: 16,
                                    borderBottomLeftRadius: 16,
                                    borderTopWidth: 1,
                                    borderRightWidth: 1,
                                    borderBottomWidth: 1,
                                    borderLeftWidth: 1,
                                    borderColor: "rgba(244, 248, 251, 1)",
                                    borderStyle: "solid",
                                    paddingBottom: 8,
                                  } as any
                                }
                              >
                                <KRow
                                  key="259954"
                                  id="259954"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="706223"
                                    id="706223"
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={24}
                                    xl={24}
                                    xxl={24}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 16,
                                        borderTopRightRadius: 16,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor:
                                          "rgba(244, 248, 251, 1)",
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="593382"
                                      id="593382"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="511026"
                                        id="511026"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 0,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="948923"
                                          id="948923"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            948923,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        ></Label>
                                      </KCol>
                                    </KRow>
                                    <KRow
                                      key="406971"
                                      id="406971"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="872690"
                                        id="872690"
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={3}
                                        xxl={3}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="886731"
                                          id="886731"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            886731,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontSize: "10px",
                                            } as any
                                          }
                                        ></Label>
                                      </KCol>
                                      <KCol
                                        key="843503"
                                        id="843503"
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={3}
                                        xxl={3}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="694168"
                                          id="694168"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            694168,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontSize: "10px",
                                            } as any
                                          }
                                        ></Label>
                                      </KCol>
                                      <KCol
                                        key="959566"
                                        id="959566"
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={3}
                                        xxl={3}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="33629"
                                          id="33629"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            33629,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontSize: "10px",
                                            } as any
                                          }
                                        ></Label>
                                      </KCol>
                                      <KCol
                                        key="393127"
                                        id="393127"
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={3}
                                        xxl={3}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="124075"
                                          id="124075"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            124075,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontSize: "10px",
                                            } as any
                                          }
                                        ></Label>
                                      </KCol>
                                      <KCol
                                        key="88678"
                                        id="88678"
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={2}
                                        xxl={2}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="734770"
                                          id="734770"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            734770,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontSize: "10px",
                                            } as any
                                          }
                                        ></Label>
                                      </KCol>
                                      <KCol
                                        key="446276"
                                        id="446276"
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={2}
                                        xxl={2}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="94301"
                                          id="94301"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            94301,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontSize: "10px",
                                            } as any
                                          }
                                        ></Label>
                                      </KCol>
                                      <KCol
                                        key="812834"
                                        id="812834"
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={2}
                                        xxl={2}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="996647"
                                          id="996647"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            996647,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontSize: "10px",
                                            } as any
                                          }
                                        ></Label>
                                      </KCol>
                                      <KCol
                                        key="937129"
                                        id="937129"
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={2}
                                        xxl={2}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="414859"
                                          id="414859"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            414859,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontSize: "10px",
                                            } as any
                                          }
                                        ></Label>
                                      </KCol>
                                      <KCol
                                        key="47260"
                                        id="47260"
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={2}
                                        xxl={2}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="839311"
                                          id="839311"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            839311,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontSize: "10px",
                                            } as any
                                          }
                                        ></Label>
                                      </KCol>
                                      <KCol
                                        key="574007"
                                        id="574007"
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={2}
                                        xxl={2}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="273002"
                                          id="273002"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            273002,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontSize: "10px",
                                            } as any
                                          }
                                        ></Label>
                                      </KCol>
                                    </KRow>
                                  </KCol>
                                </KRow>
                                <KRow
                                  key="677659"
                                  id="677659"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="325741"
                                    id="325741"
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={24}
                                    xl={24}
                                    xxl={24}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="317402"
                                      id="317402"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="461163"
                                        id="461163"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KTable
                                          key="899735"
                                          id="899735"
                                          kuikaRef={
                                            this
                                              .catigesonsurecler_899735_value_kuikaTableRef
                                          }
                                          form={this.props.form}
                                          dataSource={
                                            this.state.PROFORMA_KALEMLERI_GETIR
                                          }
                                          size="middle"
                                          bordered={true}
                                          loading={false}
                                          rowKey="id"
                                          transformedOnMobileResolution={false}
                                          hideHeaderOnMobileResolution={false}
                                          showHeader={false}
                                          fixedHeader={false}
                                          tableWidthMode="fit"
                                          editable={false}
                                          editableAlwaysActive={false}
                                          insertRowActive={false}
                                          insertRowPosition="top"
                                          globalSearch={false}
                                          searchable={false}
                                          shouldSearchOnChange={true}
                                          searchDelay={200}
                                          sorter={false}
                                          filtering={false}
                                          resizableColumns={false}
                                          pagination={false}
                                          pageSize={10}
                                          showSizeChanger={false}
                                          paginationSelectedTextColor="#246eff"
                                          paginationUnselectedTextColor="#000"
                                          columnChooser={false}
                                          striped={false}
                                          stripedColor="#F5F7FA"
                                          rowHoverBgColor="#fafafa"
                                          showRowNumbers={false}
                                          showNoDataFound={true}
                                          nodatafoundmessage={ReactSystemFunctions.translate(
                                            this.ml,
                                            899735,
                                            "nodatafoundmessage",
                                            this.defaultML
                                          )}
                                          multiSelect={false}
                                          multiSelectScope="page"
                                          export={false}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KTableHeader
                                            key="42954"
                                            id="42954"
                                            hideOnMobileResolution={false}
                                            textDirection="Default"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                                color: "rgba(155, 155, 155, 1)",
                                                lineHeight: "20px",
                                              } as any
                                            }
                                          ></KTableHeader>
                                          <KTableRow
                                            key="649966"
                                            id="649966"
                                            hoverFontColor="red"
                                            hoverBgColor="#F5F5F5"
                                            style={
                                              {
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KTableColumn
                                              key="545201"
                                              id="545201"
                                              title={ReactSystemFunctions.translate(
                                                this.ml,
                                                545201,
                                                "title",
                                                this.defaultML
                                              )}
                                              alwaysVisibleOnMobileResolution={
                                                false
                                              }
                                              hideFiltering={false}
                                              hideSorting={false}
                                              hideSearch={false}
                                              footerOptions="none"
                                              footerFontSize={14}
                                              footerFontColor="rgb(68, 68, 68)"
                                              excludeFromExport={false}
                                              footerFontWeight="Regular"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="651024"
                                                id="651024"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="679372"
                                                  id="679372"
                                                  xs={12}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={3}
                                                  xxl={3}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="226022"
                                                    id="226022"
                                                    value="[datafield:fisno]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "9px",
                                                        color:
                                                          "rgba(44, 62, 80, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KCol>
                                                <KCol
                                                  key="132800"
                                                  id="132800"
                                                  xs={12}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={3}
                                                  xxl={3}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="67710"
                                                    id="67710"
                                                    value="[datafield:stoK_KODU]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "9px",
                                                        color:
                                                          "rgba(44, 62, 80, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KCol>
                                                <KCol
                                                  key="130766"
                                                  id="130766"
                                                  xs={12}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={3}
                                                  xxl={3}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="376378"
                                                    id="376378"
                                                    value="[datafield:stoK_ADI]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "9px",
                                                        color:
                                                          "rgba(44, 62, 80, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KCol>
                                                <KCol
                                                  key="896056"
                                                  id="896056"
                                                  xs={12}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={3}
                                                  xxl={3}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="95308"
                                                    id="95308"
                                                    value="[datafield:sthaR_GCMIK]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "9px",
                                                        color:
                                                          "rgba(44, 62, 80, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KCol>
                                                <KCol
                                                  key="76903"
                                                  id="76903"
                                                  xs={12}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={2}
                                                  xxl={2}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="465686"
                                                    id="465686"
                                                    value="[datafield:sthaR_DOVFIAT]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "9px",
                                                        color:
                                                          "rgba(44, 62, 80, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KCol>
                                                <KCol
                                                  key="810224"
                                                  id="810224"
                                                  xs={12}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={2}
                                                  xxl={2}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign:
                                                        "-webkit-center",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="825226"
                                                    id="825226"
                                                    value="[datafield:parA_BIRIMI]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "9px",
                                                        color:
                                                          "rgba(44, 62, 80, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KCol>
                                                <KCol
                                                  key="619349"
                                                  id="619349"
                                                  xs={12}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={2}
                                                  xxl={2}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="836649"
                                                    id="836649"
                                                    value="[datafield:sthaR_NF]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "9px",
                                                        color:
                                                          "rgba(44, 62, 80, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KCol>
                                                <KCol
                                                  key="305863"
                                                  id="305863"
                                                  xs={12}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={2}
                                                  xxl={2}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="276199"
                                                    id="276199"
                                                    value="[datafield:isK1]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "9px",
                                                        color:
                                                          "rgba(44, 62, 80, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KCol>
                                                <KCol
                                                  key="576219"
                                                  id="576219"
                                                  xs={12}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={2}
                                                  xxl={2}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="254824"
                                                    id="254824"
                                                    value="[datafield:isK2]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "9px",
                                                        color:
                                                          "rgba(44, 62, 80, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KCol>
                                                <KCol
                                                  key="56522"
                                                  id="56522"
                                                  xs={12}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={2}
                                                  xxl={2}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="885723"
                                                    id="885723"
                                                    value="[datafield:doviztut]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "9px",
                                                        color:
                                                          "rgba(44, 62, 80, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KCol>
                                              </KRow>
                                            </KTableColumn>
                                          </KTableRow>
                                        </KTable>
                                      </KCol>
                                    </KRow>
                                  </KCol>
                                </KRow>
                                <KRow
                                  key="320885"
                                  id="320885"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderBottomRightRadius: 8,
                                      borderBottomLeftRadius: 8,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(9, 124, 176, 1)",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="730299"
                                    id="730299"
                                    xs={16}
                                    sm={16}
                                    md={16}
                                    lg={16}
                                    xl={16}
                                    xxl={16}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <Label
                                      key="752985"
                                      id="752985"
                                      value={ReactSystemFunctions.translate(
                                        this.ml,
                                        752985,
                                        "value",
                                        this.defaultML
                                      )}
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(255, 255, 255, 1)",
                                        } as any
                                      }
                                    ></Label>
                                  </KCol>
                                  <KCol
                                    key="534084"
                                    id="534084"
                                    xs={8}
                                    sm={8}
                                    md={8}
                                    lg={8}
                                    xl={8}
                                    xxl={8}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "center",
                                        textAlign: "-webkit-right",
                                      } as any
                                    }
                                  >
                                    <Label
                                      key="751518"
                                      id="751518"
                                      value={
                                        this.state.PROFORMA_KALEMLERI_GETIR?.at?.(
                                          0
                                        )?.geneltoplam ?? undefined
                                      }
                                      formatter="money-tl"
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Poppins",
                                          fontWeight: 600,
                                          fontSize: "14px",
                                          color: "rgba(255, 255, 255, 1)",
                                        } as any
                                      }
                                    ></Label>
                                  </KCol>
                                </KRow>
                              </KCol>
                            </KRow>
                            <KRow
                              key="226036"
                              id="226036"
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                } as any
                              }
                            >
                              <KCol
                                key="467770"
                                id="467770"
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderTopLeftRadius: 16,
                                    borderTopRightRadius: 16,
                                    borderBottomRightRadius: 16,
                                    borderBottomLeftRadius: 16,
                                    borderTopWidth: 1,
                                    borderRightWidth: 1,
                                    borderBottomWidth: 1,
                                    borderLeftWidth: 1,
                                    borderColor: "rgba(244, 248, 251, 1)",
                                    borderStyle: "solid",
                                    paddingBottom: 8,
                                  } as any
                                }
                              >
                                <KRow
                                  key="149966"
                                  id="149966"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="829527"
                                    id="829527"
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={24}
                                    xl={24}
                                    xxl={24}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 16,
                                        borderTopRightRadius: 16,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor:
                                          "rgba(244, 248, 251, 1)",
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="259676"
                                      id="259676"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="38305"
                                        id="38305"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="927461"
                                          id="927461"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            927461,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        ></Label>
                                      </KCol>
                                    </KRow>
                                  </KCol>
                                </KRow>
                                <KRow
                                  key="601009"
                                  id="601009"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="687305"
                                    id="687305"
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={24}
                                    xl={24}
                                    xxl={24}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="388977"
                                      id="388977"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="571077"
                                        id="571077"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderTopLeftRadius: 8,
                                            borderTopRightRadius: 8,
                                            borderBottomRightRadius: 8,
                                            borderBottomLeftRadius: 8,
                                            borderTopWidth: 1,
                                            borderRightWidth: 1,
                                            borderBottomWidth: 1,
                                            borderLeftWidth: 1,
                                            borderColor:
                                              "rgba(217, 217, 217, 1)",
                                            borderStyle: "solid",
                                            backgroundColor:
                                              "rgba(244, 248, 251, 1)",
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 16,
                                            alignItems: "center",
                                            textAlign: "-webkit-center",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="410787"
                                          id="410787"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="415351"
                                            id="415351"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                              } as any
                                            }
                                          >
                                            <KRow
                                              key="855526"
                                              id="855526"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="356759"
                                                id="356759"
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                xl={12}
                                                xxl={12}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="194557"
                                                  id="194557"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    194557,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                              <KCol
                                                key="415745"
                                                id="415745"
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                xl={12}
                                                xxl={12}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    textAlign: "-webkit-right",
                                                  } as any
                                                }
                                              >
                                                <Button
                                                  key="410008"
                                                  id="410008"
                                                  onClick={(e?: any) => {
                                                    if (e && e.stopPropagation)
                                                      e.stopPropagation();
                                                    this.CatiGesOnSureclerComponent_410008_onClick();
                                                  }}
                                                  showCursorPointer
                                                  label={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    410008,
                                                    "label",
                                                    this.defaultML
                                                  )}
                                                  size="middle"
                                                  loading={false}
                                                  ghost={false}
                                                  block={false}
                                                  htmlType="button"
                                                  icon="attach_email"
                                                  iconPosition="left"
                                                  danger={false}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 8,
                                                      borderTopRightRadius: 8,
                                                      borderBottomRightRadius: 8,
                                                      borderBottomLeftRadius: 8,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(13, 150, 212, 0.64)",
                                                      backgroundRepeat:
                                                        "no-repeat",
                                                      backgroundSize: "contain",
                                                      backgroundPosition:
                                                        "left",
                                                      paddingTop: 8,
                                                      paddingRight: 16,
                                                      paddingBottom: 8,
                                                      paddingLeft: 16,
                                                      alignItems: "center",
                                                      textAlign:
                                                        "-webkit-center",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "12px",
                                                      color:
                                                        "rgba(255, 255, 255, 1)",
                                                      lineHeight: "22px",
                                                    } as any
                                                  }
                                                ></Button>
                                              </KCol>
                                            </KRow>
                                          </KCol>
                                          <KCol
                                            key="587631"
                                            id="587631"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                              } as any
                                            }
                                          >
                                            <KTable
                                              key="266261"
                                              id="266261"
                                              kuikaRef={
                                                this
                                                  .catigesonsurecler_266261_value_kuikaTableRef
                                              }
                                              form={this.props.form}
                                              dataSource={
                                                this.state.DosyalariGetir
                                              }
                                              size="middle"
                                              bordered={true}
                                              loading={false}
                                              rowKey="id"
                                              transformedOnMobileResolution={
                                                false
                                              }
                                              hideHeaderOnMobileResolution={
                                                false
                                              }
                                              showHeader={false}
                                              fixedHeader={false}
                                              tableWidthMode="fit"
                                              editable={false}
                                              editableAlwaysActive={false}
                                              insertRowActive={false}
                                              insertRowPosition="top"
                                              globalSearch={false}
                                              searchable={false}
                                              shouldSearchOnChange={true}
                                              searchDelay={200}
                                              sorter={false}
                                              filtering={false}
                                              resizableColumns={false}
                                              pagination={false}
                                              pageSize={10}
                                              showSizeChanger={false}
                                              paginationSelectedTextColor="#246eff"
                                              paginationUnselectedTextColor="#000"
                                              columnChooser={false}
                                              striped={false}
                                              stripedColor="#F5F7FA"
                                              rowHoverBgColor="#fafafa"
                                              showRowNumbers={false}
                                              showNoDataFound={true}
                                              nodatafoundmessage={ReactSystemFunctions.translate(
                                                this.ml,
                                                266261,
                                                "nodatafoundmessage",
                                                this.defaultML
                                              )}
                                              multiSelect={false}
                                              multiSelectScope="page"
                                              export={false}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KTableHeader
                                                key="935485"
                                                id="935485"
                                                hideOnMobileResolution={false}
                                                textDirection="Default"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                    color:
                                                      "rgba(155, 155, 155, 1)",
                                                    lineHeight: "20px",
                                                  } as any
                                                }
                                              ></KTableHeader>
                                              <KTableRow
                                                key="36630"
                                                id="36630"
                                                hoverFontColor="red"
                                                hoverBgColor="#F5F5F5"
                                                style={
                                                  {
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <KTableColumn
                                                  key="319112"
                                                  id="319112"
                                                  title={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    319112,
                                                    "title",
                                                    this.defaultML
                                                  )}
                                                  alwaysVisibleOnMobileResolution={
                                                    false
                                                  }
                                                  hideFiltering={false}
                                                  hideSorting={false}
                                                  hideSearch={false}
                                                  footerOptions="none"
                                                  footerFontSize={14}
                                                  footerFontColor="rgb(68, 68, 68)"
                                                  excludeFromExport={false}
                                                  footerFontWeight="Regular"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <KRow
                                                    key="185377"
                                                    id="185377"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="284403"
                                                      id="284403"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={12}
                                                      xxl={12}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                        } as any
                                                      }
                                                    >
                                                      <HorizontalStack
                                                        key="498521"
                                                        id="498521"
                                                        direction="horizontal"
                                                        size={12}
                                                        overflowX="auto"
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <Icon
                                                          key="423582"
                                                          id="423582"
                                                          iconName="assignment"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "20px",
                                                              color:
                                                                "rgba(155, 155, 155, 1)",
                                                              letterSpacing:
                                                                "1px",
                                                            } as any
                                                          }
                                                        ></Icon>
                                                        <Label
                                                          key="172441"
                                                          id="172441"
                                                          value="[datafield:dosyaAdi]"
                                                          maxLine={20}
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 400,
                                                              fontSize: "10px",
                                                              color:
                                                                "rgba(140, 140, 140, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </HorizontalStack>
                                                    </KCol>
                                                    <KCol
                                                      key="169608"
                                                      id="169608"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={12}
                                                      xxl={12}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          textAlign:
                                                            "-webkit-right",
                                                        } as any
                                                      }
                                                    >
                                                      <HorizontalStack
                                                        key="547954"
                                                        id="547954"
                                                        direction="horizontal"
                                                        size={12}
                                                        overflowX="auto"
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <Icon
                                                          key="931911"
                                                          id="931911"
                                                          onClick={(
                                                            e?: any
                                                          ) => {
                                                            if (
                                                              e &&
                                                              e.stopPropagation
                                                            )
                                                              e.stopPropagation();
                                                            this.CatiGesOnSureclerComponent_931911_onClick();
                                                          }}
                                                          showCursorPointer
                                                          iconName="get_app"
                                                          hoverText="İndir"
                                                          style={
                                                            {
                                                              borderTopLeftRadius: 8,
                                                              borderTopRightRadius: 8,
                                                              borderBottomRightRadius: 8,
                                                              borderBottomLeftRadius: 8,
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              backgroundColor:
                                                                "rgba(13, 150, 212, 0.36)",
                                                              paddingTop: 8,
                                                              paddingRight: 8,
                                                              paddingBottom: 8,
                                                              paddingLeft: 8,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "20px",
                                                              color:
                                                                "rgba(13, 150, 212, 1)",
                                                              letterSpacing:
                                                                "1px",
                                                            } as any
                                                          }
                                                        ></Icon>
                                                        <Icon
                                                          key="117547"
                                                          id="117547"
                                                          onClick={(
                                                            e?: any
                                                          ) => {
                                                            if (
                                                              e &&
                                                              e.stopPropagation
                                                            )
                                                              e.stopPropagation();
                                                            this.CatiGesOnSureclerComponent_117547_onClick();
                                                          }}
                                                          showCursorPointer
                                                          iconName="delete"
                                                          hoverText="Sil"
                                                          style={
                                                            {
                                                              borderTopLeftRadius: 8,
                                                              borderTopRightRadius: 8,
                                                              borderBottomRightRadius: 8,
                                                              borderBottomLeftRadius: 8,
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              backgroundColor:
                                                                "rgba(225, 60, 57, 0.36)",
                                                              paddingTop: 8,
                                                              paddingRight: 8,
                                                              paddingBottom: 8,
                                                              paddingLeft: 8,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "20px",
                                                              color:
                                                                "rgba(218, 84, 82, 1)",
                                                              letterSpacing:
                                                                "1px",
                                                            } as any
                                                          }
                                                        ></Icon>
                                                      </HorizontalStack>
                                                    </KCol>
                                                  </KRow>
                                                </KTableColumn>
                                              </KTableRow>
                                            </KTable>
                                          </KCol>
                                        </KRow>
                                      </KCol>
                                    </KRow>
                                  </KCol>
                                </KRow>
                              </KCol>
                            </KRow>
                            <KRow
                              key="759653"
                              id="759653"
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                } as any
                              }
                            >
                              <KCol
                                key="13732"
                                id="13732"
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderTopLeftRadius: 16,
                                    borderTopRightRadius: 16,
                                    borderBottomRightRadius: 16,
                                    borderBottomLeftRadius: 16,
                                    borderTopWidth: 1,
                                    borderRightWidth: 1,
                                    borderBottomWidth: 1,
                                    borderLeftWidth: 1,
                                    borderColor: "rgba(244, 248, 251, 1)",
                                    borderStyle: "solid",
                                    paddingBottom: 8,
                                  } as any
                                }
                              >
                                <KRow
                                  key="495402"
                                  id="495402"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="356726"
                                    id="356726"
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={24}
                                    xl={24}
                                    xxl={24}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 16,
                                        borderTopRightRadius: 16,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor:
                                          "rgba(244, 248, 251, 1)",
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="726778"
                                      id="726778"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="248780"
                                        id="248780"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="673242"
                                          id="673242"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            673242,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        ></Label>
                                      </KCol>
                                    </KRow>
                                  </KCol>
                                </KRow>
                                <KRow
                                  key="871150"
                                  id="871150"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="57694"
                                    id="57694"
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={24}
                                    xl={24}
                                    xxl={24}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="289176"
                                      id="289176"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="291282"
                                        id="291282"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={12}
                                        xxl={12}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <VerticalStack
                                          key="928197"
                                          id="928197"
                                          direction="vertical"
                                          size={2}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="700575"
                                            id="700575"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              700575,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(140, 140, 140, 1)",
                                              } as any
                                            }
                                          ></Label>
                                          <Form.Item
                                            className="kFormItem"
                                            name="catigesonsurecler_505390_value"
                                          >
                                            <NumberInput
                                              key="505390"
                                              id="505390"
                                              decimalSeparator="."
                                              decimalScale={2}
                                              disabled={false}
                                              placeholder={
                                                this.state.KalemleriGetir?.at?.(
                                                  0
                                                )?.genelToplam ?? undefined
                                              }
                                              fixedDecimalScale={false}
                                              allowNegative={false}
                                              allowEmptyFormatting={false}
                                              isThousandSeperatorOn={true}
                                              style={
                                                {
                                                  borderTopLeftRadius: 8,
                                                  borderTopRightRadius: 8,
                                                  borderBottomRightRadius: 8,
                                                  borderBottomLeftRadius: 8,
                                                  borderTopWidth: 1,
                                                  borderRightWidth: 1,
                                                  borderBottomWidth: 1,
                                                  borderLeftWidth: 1,
                                                  borderColor:
                                                    "rgba(218, 218, 218, 1)",
                                                  borderStyle: "solid",
                                                  backgroundColor:
                                                    "rgba(255, 255, 255, 1)",
                                                  backgroundRepeat: "no-repeat",
                                                  backgroundSize: "contain",
                                                  backgroundPosition: "left",
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  height: "35px",
                                                  maxWidth: "250px",
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "block",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            ></NumberInput>
                                          </Form.Item>
                                        </VerticalStack>
                                      </KCol>
                                      <KCol
                                        key="162208"
                                        id="162208"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={12}
                                        xxl={12}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <VerticalStack
                                          key="355231"
                                          id="355231"
                                          direction="vertical"
                                          size={2}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="95182"
                                            id="95182"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              95182,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(140, 140, 140, 1)",
                                              } as any
                                            }
                                          ></Label>
                                          <Form.Item
                                            className="kFormItem"
                                            name="catigesonsurecler_169821_value"
                                          >
                                            <TextArea
                                              key="169821"
                                              id="169821"
                                              placeholder={ReactSystemFunctions.translate(
                                                this.ml,
                                                169821,
                                                "placeholder",
                                                this.defaultML
                                              )}
                                              allowClear={false}
                                              autoSize={false}
                                              showCount={false}
                                              formatter="None"
                                              readOnly={false}
                                              speechToText={false}
                                              style={
                                                {
                                                  borderTopLeftRadius: 8,
                                                  borderTopRightRadius: 8,
                                                  borderBottomRightRadius: 8,
                                                  borderBottomLeftRadius: 8,
                                                  borderTopWidth: 1,
                                                  borderRightWidth: 1,
                                                  borderBottomWidth: 1,
                                                  borderLeftWidth: 1,
                                                  borderColor:
                                                    "rgba(218, 218, 218, 1)",
                                                  borderStyle: "solid",
                                                  backgroundColor:
                                                    "rgba(255, 255, 255, 1)",
                                                  backgroundRepeat: "no-repeat",
                                                  backgroundSize: "contain",
                                                  backgroundPosition: "left",
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "block",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            ></TextArea>
                                          </Form.Item>
                                        </VerticalStack>
                                      </KCol>
                                    </KRow>
                                  </KCol>
                                </KRow>
                              </KCol>
                            </KRow>
                            <KRow
                              key="611930"
                              id="611930"
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                } as any
                              }
                            >
                              <KCol
                                key="891008"
                                id="891008"
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-right",
                                  } as any
                                }
                              >
                                <HorizontalStack
                                  key="549099"
                                  id="549099"
                                  direction="horizontal"
                                  size={12}
                                  overflowX="auto"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <Button
                                    key="641491"
                                    id="641491"
                                    onClick={(e?: any) => {
                                      if (e && e.stopPropagation)
                                        e.stopPropagation();
                                      this.CatiGesOnSureclerComponent_641491_onClick();
                                    }}
                                    showCursorPointer
                                    editability={this.state.isComp641491Enabled}
                                    label={ReactSystemFunctions.translate(
                                      this.ml,
                                      641491,
                                      "label",
                                      this.defaultML
                                    )}
                                    size="middle"
                                    loading={false}
                                    ghost={false}
                                    block={false}
                                    htmlType="button"
                                    icon="save"
                                    iconPosition="left"
                                    danger={false}
                                    style={
                                      {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        borderBottomRightRadius: 8,
                                        borderBottomLeftRadius: 8,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor:
                                          "rgba(13, 150, 212, 1)",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        backgroundPosition: "left",
                                        paddingTop: 8,
                                        paddingRight: 16,
                                        paddingBottom: 8,
                                        paddingLeft: 16,
                                        alignItems: "center",
                                        textAlign: "-webkit-center",
                                        display: "inline",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "12px",
                                        color: "rgba(255, 255, 255, 1)",
                                        lineHeight: "22px",
                                      } as any
                                    }
                                  ></Button>
                                </HorizontalStack>
                              </KCol>
                            </KRow>
                          </KCol>
                        </KTabItem>
                        <KRow
                          key="615511"
                          id="615511"
                          visibility={this.state.isComp615511Visible}
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                            } as any
                          }
                        >
                          <KCol
                            key="949374"
                            id="949374"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                              } as any
                            }
                          >
                            <KRow
                              key="648652"
                              id="648652"
                              visibility={
                                this.state
                                  .isCompcatigesonsurecler_648652AuthorizationVisible
                              }
                              visibilityByAuthorization={
                                this.state
                                  .isCompcatigesonsurecler_648652AuthorizationVisible
                              }
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                } as any
                              }
                            >
                              <KCol
                                key="655209"
                                id="655209"
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderTopLeftRadius: 16,
                                    borderTopRightRadius: 16,
                                    borderBottomRightRadius: 16,
                                    borderBottomLeftRadius: 16,
                                    borderTopWidth: 1,
                                    borderRightWidth: 1,
                                    borderBottomWidth: 1,
                                    borderLeftWidth: 1,
                                    borderColor: "rgba(244, 248, 251, 1)",
                                    borderStyle: "solid",
                                    paddingBottom: 8,
                                  } as any
                                }
                              >
                                <KRow
                                  key="317931"
                                  id="317931"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="899452"
                                    id="899452"
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={24}
                                    xl={24}
                                    xxl={24}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 16,
                                        borderTopRightRadius: 16,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor:
                                          "rgba(244, 248, 251, 1)",
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="408204"
                                      id="408204"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="946287"
                                        id="946287"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="972066"
                                          id="972066"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            972066,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        ></Label>
                                      </KCol>
                                    </KRow>
                                  </KCol>
                                </KRow>
                                <KRow
                                  key="300957"
                                  id="300957"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="140498"
                                    id="140498"
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={24}
                                    xl={24}
                                    xxl={24}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="893492"
                                      id="893492"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="273109"
                                        id="273109"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={16}
                                        xxl={16}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <VerticalStack
                                          key="369268"
                                          id="369268"
                                          direction="vertical"
                                          size={2}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="31452"
                                            id="31452"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              31452,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(140, 140, 140, 1)",
                                              } as any
                                            }
                                          ></Label>
                                        </VerticalStack>
                                      </KCol>
                                      <KCol
                                        key="989370"
                                        id="989370"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={8}
                                        xxl={8}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-right",
                                          } as any
                                        }
                                      >
                                        <HorizontalStack
                                          key="974335"
                                          id="974335"
                                          direction="horizontal"
                                          size={12}
                                          overflowX="auto"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <Button
                                            key="237140"
                                            id="237140"
                                            onClick={(e?: any) => {
                                              if (e && e.stopPropagation)
                                                e.stopPropagation();
                                              this.CatiGesOnSureclerComponent_237140_onClick();
                                            }}
                                            showCursorPointer
                                            label={ReactSystemFunctions.translate(
                                              this.ml,
                                              237140,
                                              "label",
                                              this.defaultML
                                            )}
                                            size="middle"
                                            loading={false}
                                            ghost={false}
                                            block={false}
                                            htmlType="button"
                                            icon="done_outline"
                                            iconPosition="left"
                                            danger={false}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                backgroundColor:
                                                  "rgba(13, 150, 212, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 16,
                                                paddingBottom: 8,
                                                paddingLeft: 16,
                                                alignItems: "center",
                                                textAlign: "-webkit-center",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "12px",
                                                color: "rgba(255, 255, 255, 1)",
                                                lineHeight: "22px",
                                              } as any
                                            }
                                          ></Button>
                                          <Button
                                            key="417687"
                                            id="417687"
                                            onClick={(e?: any) => {
                                              if (e && e.stopPropagation)
                                                e.stopPropagation();
                                              this.CatiGesOnSureclerComponent_417687_onClick();
                                            }}
                                            showCursorPointer
                                            label={ReactSystemFunctions.translate(
                                              this.ml,
                                              417687,
                                              "label",
                                              this.defaultML
                                            )}
                                            size="middle"
                                            loading={false}
                                            ghost={false}
                                            block={false}
                                            htmlType="button"
                                            icon="highlight_off"
                                            iconPosition="left"
                                            danger={false}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                backgroundColor:
                                                  "rgba(225, 60, 57, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 16,
                                                paddingBottom: 8,
                                                paddingLeft: 16,
                                                alignItems: "center",
                                                textAlign: "-webkit-center",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "12px",
                                                color: "rgba(255, 255, 255, 1)",
                                                lineHeight: "22px",
                                              } as any
                                            }
                                          ></Button>
                                        </HorizontalStack>
                                      </KCol>
                                    </KRow>
                                  </KCol>
                                </KRow>
                              </KCol>
                            </KRow>
                          </KCol>
                        </KRow>
                        <KTabItem
                          key={899938}
                          id="899938"
                          onActive={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.CatiGesOnSureclerComponent_899938_onActive();
                          }}
                          visibility={
                            this.state
                              .isCompcatigesonsurecler_899938AuthorizationVisible
                          }
                          visibilityByAuthorization={
                            this.state
                              .isCompcatigesonsurecler_899938AuthorizationVisible
                          }
                          tab={ReactSystemFunctions.translate(
                            this.ml,
                            899938,
                            "tab",
                            this.defaultML
                          )}
                          forceRender={false}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(255, 255, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KRow
                            key="864664"
                            id="864664"
                            editability={this.state.isComp864664Enabled}
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                              } as any
                            }
                          >
                            <KCol
                              key="800887"
                              id="800887"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                } as any
                              }
                            >
                              <KRow
                                key="957370"
                                id="957370"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                  } as any
                                }
                              >
                                <KCol
                                  key="629725"
                                  id="629725"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 16,
                                      borderTopRightRadius: 16,
                                      borderBottomRightRadius: 16,
                                      borderBottomLeftRadius: 16,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "rgba(244, 248, 251, 1)",
                                      borderStyle: "solid",
                                      paddingBottom: 8,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="333436"
                                    id="333436"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="305824"
                                      id="305824"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 16,
                                          borderTopRightRadius: 16,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          backgroundColor:
                                            "rgba(244, 248, 251, 1)",
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="294599"
                                        id="294599"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="69463"
                                          id="69463"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="640220"
                                            id="640220"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              640220,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                  <KRow
                                    key="26479"
                                    id="26479"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="163519"
                                      id="163519"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="26155"
                                        id="26155"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="857956"
                                          id="857956"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="917191"
                                            id="917191"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="589859"
                                              id="589859"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                589859,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_990822_value"
                                            >
                                              <KDatePicker
                                                key="990822"
                                                id="990822"
                                                kuikaRef={
                                                  this
                                                    .catigesonsurecler_990822_value_kuikaDateRef
                                                }
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  990822,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                allowClear={true}
                                                format="DD/MM/YYYY"
                                                displayType="date"
                                                returnDisplayValue={false}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></KDatePicker>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="387499"
                                          id="387499"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="540164"
                                            id="540164"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="359978"
                                              id="359978"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                359978,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_864033_value"
                                            >
                                              <KSelectBox
                                                key="864033"
                                                id="864033"
                                                kuikaRef={
                                                  this
                                                    .catigesonsurecler_864033_value_kuikaSelectBoxRef
                                                }
                                                options={
                                                  this.state
                                                    .GET_PROJEYONETICI_USERS
                                                }
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  864033,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                allowClear={false}
                                                autoClearSearchValue={true}
                                                showSearch={false}
                                                widthType="fill"
                                                containsNullItem={false}
                                                sortBy="none"
                                                datavaluefield="kuserid"
                                                datatextfield="firstname"
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></KSelectBox>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="408012"
                                          id="408012"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="927637"
                                            id="927637"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="143152"
                                              id="143152"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                143152,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_784281_value"
                                            >
                                              <TextInput
                                                key="784281"
                                                id="784281"
                                                kuikaRef={
                                                  this
                                                    .catigesonsurecler_784281_value_kuikaTextInputRef
                                                }
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  784281,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                allowClear={false}
                                                bordered={true}
                                                disabled={false}
                                                type="text"
                                                iconColor="rgba(0, 0, 0, 1)"
                                                formatter="None"
                                                isCharOnly={false}
                                                autoComplete={true}
                                                inputMode="all"
                                                speechToText={false}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></TextInput>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                              <KRow
                                key="21746"
                                id="21746"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                  } as any
                                }
                              >
                                <KCol
                                  key="653582"
                                  id="653582"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 16,
                                      borderTopRightRadius: 16,
                                      borderBottomRightRadius: 16,
                                      borderBottomLeftRadius: 16,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "rgba(244, 248, 251, 1)",
                                      borderStyle: "solid",
                                      paddingBottom: 8,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="161150"
                                    id="161150"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="736814"
                                      id="736814"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 16,
                                          borderTopRightRadius: 16,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          backgroundColor:
                                            "rgba(244, 248, 251, 1)",
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="84143"
                                        id="84143"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="599484"
                                          id="599484"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="896075"
                                            id="896075"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              896075,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                  <KRow
                                    key="296340"
                                    id="296340"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="134171"
                                      id="134171"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="112926"
                                        id="112926"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="671164"
                                          id="671164"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="807436"
                                            id="807436"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="717848"
                                              id="717848"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                717848,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_798603_value"
                                            >
                                              <NumberInput
                                                key="798603"
                                                id="798603"
                                                decimalSeparator=","
                                                decimalScale={2}
                                                disabled={false}
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  798603,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                fixedDecimalScale={false}
                                                allowNegative={true}
                                                allowEmptyFormatting={false}
                                                isThousandSeperatorOn={true}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></NumberInput>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="442921"
                                          id="442921"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="781156"
                                            id="781156"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="248620"
                                              id="248620"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                248620,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_569086_value"
                                            >
                                              <KSelectBox
                                                key="569086"
                                                id="569086"
                                                kuikaRef={
                                                  this
                                                    .catigesonsurecler_569086_value_kuikaSelectBoxRef
                                                }
                                                options={
                                                  this.state.dataSource_569086
                                                }
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  569086,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                allowClear={false}
                                                autoClearSearchValue={true}
                                                showSearch={false}
                                                widthType="fill"
                                                containsNullItem={false}
                                                sortBy="none"
                                                datavaluefield="key"
                                                datatextfield="text"
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></KSelectBox>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="215985"
                                          id="215985"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="629773"
                                            id="629773"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="946381"
                                              id="946381"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                946381,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_865048_value"
                                            >
                                              <NumberInput
                                                key="865048"
                                                id="865048"
                                                decimalSeparator=","
                                                decimalScale={2}
                                                disabled={false}
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  865048,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                fixedDecimalScale={false}
                                                allowNegative={true}
                                                allowEmptyFormatting={false}
                                                isThousandSeperatorOn={true}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></NumberInput>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="104629"
                                          id="104629"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="26368"
                                            id="26368"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="473868"
                                              id="473868"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                473868,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_907314_value"
                                            >
                                              <NumberInput
                                                key="907314"
                                                id="907314"
                                                decimalSeparator=","
                                                decimalScale={2}
                                                disabled={false}
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  907314,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                fixedDecimalScale={false}
                                                allowNegative={true}
                                                allowEmptyFormatting={false}
                                                isThousandSeperatorOn={true}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></NumberInput>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="801366"
                                          id="801366"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="153290"
                                            id="153290"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="456763"
                                              id="456763"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                456763,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_320637_value"
                                            >
                                              <NumberInput
                                                key="320637"
                                                id="320637"
                                                decimalSeparator=","
                                                decimalScale={2}
                                                disabled={false}
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  320637,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                fixedDecimalScale={false}
                                                allowNegative={true}
                                                allowEmptyFormatting={false}
                                                isThousandSeperatorOn={true}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></NumberInput>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                              <KRow
                                key="915976"
                                id="915976"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                  } as any
                                }
                              >
                                <KCol
                                  key="181019"
                                  id="181019"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 16,
                                      borderTopRightRadius: 16,
                                      borderBottomRightRadius: 16,
                                      borderBottomLeftRadius: 16,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "rgba(244, 248, 251, 1)",
                                      borderStyle: "solid",
                                      paddingBottom: 8,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="703771"
                                    id="703771"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="886440"
                                      id="886440"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 16,
                                          borderTopRightRadius: 16,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          backgroundColor:
                                            "rgba(244, 248, 251, 1)",
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="484588"
                                        id="484588"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="689401"
                                          id="689401"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="77246"
                                            id="77246"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              77246,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                  <KRow
                                    key="14500"
                                    id="14500"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="554103"
                                      id="554103"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="627432"
                                        id="627432"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="564095"
                                          id="564095"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="90907"
                                            id="90907"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="941542"
                                              id="941542"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                941542,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_940300_value"
                                            >
                                              <KSelectBox
                                                key="940300"
                                                id="940300"
                                                kuikaRef={
                                                  this
                                                    .catigesonsurecler_940300_value_kuikaSelectBoxRef
                                                }
                                                options={
                                                  this.state.dataSource_940300
                                                }
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  940300,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                allowClear={false}
                                                autoClearSearchValue={true}
                                                showSearch={false}
                                                widthType="fill"
                                                containsNullItem={false}
                                                sortBy="none"
                                                datavaluefield="key"
                                                datatextfield="text"
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></KSelectBox>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="700473"
                                          id="700473"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="962508"
                                            id="962508"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="990724"
                                              id="990724"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                990724,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_967785_value"
                                            >
                                              <NumberInput
                                                key="967785"
                                                id="967785"
                                                decimalSeparator=","
                                                decimalScale={2}
                                                disabled={false}
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  967785,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                fixedDecimalScale={false}
                                                allowNegative={true}
                                                allowEmptyFormatting={false}
                                                isThousandSeperatorOn={true}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></NumberInput>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="156799"
                                          id="156799"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="468699"
                                            id="468699"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="573951"
                                              id="573951"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                573951,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_775375_value"
                                            >
                                              <KSelectBox
                                                key="775375"
                                                id="775375"
                                                kuikaRef={
                                                  this
                                                    .catigesonsurecler_775375_value_kuikaSelectBoxRef
                                                }
                                                options={
                                                  this.state.dataSource_775375
                                                }
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  775375,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                allowClear={false}
                                                autoClearSearchValue={true}
                                                showSearch={false}
                                                widthType="fill"
                                                containsNullItem={false}
                                                sortBy="none"
                                                datavaluefield="key"
                                                datatextfield="text"
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></KSelectBox>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="949025"
                                          id="949025"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="729029"
                                            id="729029"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="925707"
                                              id="925707"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                925707,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_257886_value"
                                            >
                                              <NumberInput
                                                key="257886"
                                                id="257886"
                                                decimalSeparator=","
                                                decimalScale={2}
                                                disabled={false}
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  257886,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                fixedDecimalScale={false}
                                                allowNegative={true}
                                                allowEmptyFormatting={false}
                                                isThousandSeperatorOn={true}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></NumberInput>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="199348"
                                          id="199348"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="600050"
                                            id="600050"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="10747"
                                              id="10747"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                10747,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_672009_value"
                                            >
                                              <NumberInput
                                                key="672009"
                                                id="672009"
                                                decimalSeparator=","
                                                decimalScale={2}
                                                disabled={false}
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  672009,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                fixedDecimalScale={false}
                                                allowNegative={true}
                                                allowEmptyFormatting={false}
                                                isThousandSeperatorOn={true}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></NumberInput>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="692847"
                                          id="692847"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="765818"
                                            id="765818"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="312596"
                                              id="312596"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                312596,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_235750_value"
                                            >
                                              <NumberInput
                                                key="235750"
                                                id="235750"
                                                decimalSeparator=","
                                                decimalScale={2}
                                                disabled={false}
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  235750,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                fixedDecimalScale={false}
                                                allowNegative={true}
                                                allowEmptyFormatting={false}
                                                isThousandSeperatorOn={true}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></NumberInput>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="728334"
                                        id="728334"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="661354"
                                          id="661354"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 16,
                                              paddingBottom: 0,
                                              paddingLeft: 16,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="280874"
                                            id="280874"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="975867"
                                              id="975867"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                975867,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_568262_value"
                                            >
                                              <TextArea
                                                key="568262"
                                                id="568262"
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  568262,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                allowClear={false}
                                                autoSize={false}
                                                showCount={false}
                                                formatter="None"
                                                readOnly={false}
                                                speechToText={false}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></TextArea>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                              <KRow
                                key="89802"
                                id="89802"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                  } as any
                                }
                              >
                                <KCol
                                  key="313558"
                                  id="313558"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 16,
                                      borderTopRightRadius: 16,
                                      borderBottomRightRadius: 16,
                                      borderBottomLeftRadius: 16,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "rgba(244, 248, 251, 1)",
                                      borderStyle: "solid",
                                      paddingBottom: 8,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="824692"
                                    id="824692"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="381411"
                                      id="381411"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 16,
                                          borderTopRightRadius: 16,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          backgroundColor:
                                            "rgba(244, 248, 251, 1)",
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="506148"
                                        id="506148"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="217349"
                                          id="217349"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="830446"
                                            id="830446"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              830446,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                  <KRow
                                    key="794621"
                                    id="794621"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="188041"
                                      id="188041"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="220185"
                                        id="220185"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="996705"
                                          id="996705"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="19836"
                                            id="19836"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="829156"
                                              id="829156"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                829156,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_868333_value"
                                            >
                                              <KSelectBox
                                                key="868333"
                                                id="868333"
                                                kuikaRef={
                                                  this
                                                    .catigesonsurecler_868333_value_kuikaSelectBoxRef
                                                }
                                                options={
                                                  this.state.dataSource_868333
                                                }
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  868333,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                allowClear={false}
                                                autoClearSearchValue={true}
                                                showSearch={false}
                                                widthType="fill"
                                                containsNullItem={false}
                                                sortBy="none"
                                                datavaluefield="key"
                                                datatextfield="text"
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></KSelectBox>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="109409"
                                          id="109409"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="941258"
                                            id="941258"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="343939"
                                              id="343939"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                343939,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_219090_value"
                                            >
                                              <TextInput
                                                key="219090"
                                                id="219090"
                                                kuikaRef={
                                                  this
                                                    .catigesonsurecler_219090_value_kuikaTextInputRef
                                                }
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  219090,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                allowClear={false}
                                                bordered={true}
                                                disabled={false}
                                                type="text"
                                                iconColor="rgba(0, 0, 0, 1)"
                                                formatter="None"
                                                isCharOnly={false}
                                                autoComplete={true}
                                                inputMode="all"
                                                speechToText={false}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></TextInput>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="135579"
                                          id="135579"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="108061"
                                            id="108061"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="128675"
                                              id="128675"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                128675,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_328449_value"
                                            >
                                              <TextInput
                                                key="328449"
                                                id="328449"
                                                kuikaRef={
                                                  this
                                                    .catigesonsurecler_328449_value_kuikaTextInputRef
                                                }
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  328449,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                allowClear={false}
                                                bordered={true}
                                                disabled={false}
                                                type="text"
                                                iconColor="rgba(0, 0, 0, 1)"
                                                formatter="None"
                                                isCharOnly={false}
                                                autoComplete={true}
                                                inputMode="all"
                                                speechToText={false}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></TextInput>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                              <KRow
                                key="431358"
                                id="431358"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                  } as any
                                }
                              >
                                <KCol
                                  key="178232"
                                  id="178232"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 16,
                                      borderTopRightRadius: 16,
                                      borderBottomRightRadius: 16,
                                      borderBottomLeftRadius: 16,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "rgba(244, 248, 251, 1)",
                                      borderStyle: "solid",
                                      paddingBottom: 8,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="999459"
                                    id="999459"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="492780"
                                      id="492780"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 16,
                                          borderTopRightRadius: 16,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          backgroundColor:
                                            "rgba(244, 248, 251, 1)",
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="614531"
                                        id="614531"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="467415"
                                          id="467415"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="118669"
                                            id="118669"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              118669,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                  <KRow
                                    key="100238"
                                    id="100238"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="486494"
                                      id="486494"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="988662"
                                        id="988662"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="965074"
                                          id="965074"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="985945"
                                            id="985945"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="448593"
                                              id="448593"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                448593,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_4244_value"
                                            >
                                              <TextInput
                                                key="4244"
                                                id="4244"
                                                kuikaRef={
                                                  this
                                                    .catigesonsurecler_4244_value_kuikaTextInputRef
                                                }
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  4244,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                allowClear={false}
                                                bordered={true}
                                                disabled={false}
                                                type="text"
                                                iconColor="rgba(0, 0, 0, 1)"
                                                formatter="None"
                                                isCharOnly={false}
                                                autoComplete={true}
                                                inputMode="all"
                                                speechToText={false}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></TextInput>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="544359"
                                          id="544359"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="168975"
                                            id="168975"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="402963"
                                              id="402963"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                402963,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_494854_value"
                                            >
                                              <TextInput
                                                key="494854"
                                                id="494854"
                                                kuikaRef={
                                                  this
                                                    .catigesonsurecler_494854_value_kuikaTextInputRef
                                                }
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  494854,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                allowClear={false}
                                                bordered={true}
                                                disabled={false}
                                                type="text"
                                                iconColor="rgba(0, 0, 0, 1)"
                                                formatter="None"
                                                isCharOnly={false}
                                                autoComplete={true}
                                                inputMode="all"
                                                speechToText={false}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></TextInput>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="226381"
                                          id="226381"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="836449"
                                            id="836449"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="896889"
                                              id="896889"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                896889,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_592482_value"
                                            >
                                              <TextInput
                                                key="592482"
                                                id="592482"
                                                kuikaRef={
                                                  this
                                                    .catigesonsurecler_592482_value_kuikaTextInputRef
                                                }
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  592482,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                allowClear={false}
                                                bordered={true}
                                                disabled={false}
                                                type="text"
                                                iconColor="rgba(0, 0, 0, 1)"
                                                formatter="None"
                                                isCharOnly={false}
                                                autoComplete={true}
                                                inputMode="all"
                                                speechToText={false}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    height: "35px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></TextInput>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                              <KRow
                                key="140224"
                                id="140224"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                  } as any
                                }
                              >
                                <KCol
                                  key="7261"
                                  id="7261"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 16,
                                      borderTopRightRadius: 16,
                                      borderBottomRightRadius: 16,
                                      borderBottomLeftRadius: 16,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "rgba(244, 248, 251, 1)",
                                      borderStyle: "solid",
                                      paddingBottom: 8,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="349240"
                                    id="349240"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="917516"
                                      id="917516"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 16,
                                          borderTopRightRadius: 16,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          backgroundColor:
                                            "rgba(244, 248, 251, 1)",
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="828204"
                                        id="828204"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="563863"
                                          id="563863"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="383525"
                                            id="383525"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              383525,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                  <KRow
                                    key="567744"
                                    id="567744"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="118807"
                                      id="118807"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="41933"
                                        id="41933"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="397784"
                                          id="397784"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <KTable
                                            key="944389"
                                            id="944389"
                                            kuikaRef={
                                              this
                                                .catigesonsurecler_944389_value_kuikaTableRef
                                            }
                                            form={this.props.form}
                                            dataSource={
                                              this.state.KalemleriGetir
                                            }
                                            size="middle"
                                            bordered={true}
                                            loading={false}
                                            rowKey="id"
                                            transformedOnMobileResolution={
                                              false
                                            }
                                            hideHeaderOnMobileResolution={false}
                                            showHeader={false}
                                            fixedHeader={false}
                                            tableWidthMode="fit"
                                            editable={false}
                                            editableAlwaysActive={false}
                                            insertRowActive={false}
                                            insertRowPosition="top"
                                            globalSearch={false}
                                            searchable={false}
                                            shouldSearchOnChange={true}
                                            searchDelay={200}
                                            sorter={false}
                                            filtering={false}
                                            resizableColumns={false}
                                            pagination={false}
                                            pageSize={10}
                                            showSizeChanger={false}
                                            paginationSelectedTextColor="#246eff"
                                            paginationUnselectedTextColor="#000"
                                            columnChooser={false}
                                            striped={false}
                                            stripedColor="#F5F7FA"
                                            rowHoverBgColor="#fafafa"
                                            showRowNumbers={false}
                                            showNoDataFound={true}
                                            nodatafoundmessage={ReactSystemFunctions.translate(
                                              this.ml,
                                              944389,
                                              "nodatafoundmessage",
                                              this.defaultML
                                            )}
                                            multiSelect={false}
                                            multiSelectScope="page"
                                            export={false}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KTableHeader
                                              key="768696"
                                              id="768696"
                                              hideOnMobileResolution={false}
                                              textDirection="Default"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                  color:
                                                    "rgba(155, 155, 155, 1)",
                                                  lineHeight: "20px",
                                                } as any
                                              }
                                            ></KTableHeader>
                                            <KTableRow
                                              key="139316"
                                              id="139316"
                                              hoverFontColor="red"
                                              hoverBgColor="#F5F5F5"
                                              style={
                                                {
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KTableColumn
                                                key="264526"
                                                id="264526"
                                                title={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  264526,
                                                  "title",
                                                  this.defaultML
                                                )}
                                                alwaysVisibleOnMobileResolution={
                                                  false
                                                }
                                                hideFiltering={false}
                                                hideSorting={false}
                                                hideSearch={false}
                                                footerOptions="none"
                                                footerFontSize={14}
                                                footerFontColor="rgb(68, 68, 68)"
                                                excludeFromExport={false}
                                                footerFontWeight="Regular"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <KRow
                                                  key="633074"
                                                  id="633074"
                                                  align="top"
                                                  justify="start"
                                                  horizontalGutter={0}
                                                  verticalGutter={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                    } as any
                                                  }
                                                >
                                                  <KCol
                                                    key="996524"
                                                    id="996524"
                                                    xs={24}
                                                    sm={24}
                                                    md={24}
                                                    lg={24}
                                                    xl={4}
                                                    xxl={4}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="463396"
                                                      id="463396"
                                                      value="[datafield:stokKodu]"
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "12px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </KCol>
                                                  <KCol
                                                    key="132875"
                                                    id="132875"
                                                    xs={24}
                                                    sm={24}
                                                    md={24}
                                                    lg={24}
                                                    xl={4}
                                                    xxl={4}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="517175"
                                                      id="517175"
                                                      value="[datafield:stokAdi]"
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "12px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </KCol>
                                                  <KCol
                                                    key="956653"
                                                    id="956653"
                                                    xs={24}
                                                    sm={24}
                                                    md={24}
                                                    lg={24}
                                                    xl={4}
                                                    xxl={4}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="6372"
                                                      id="6372"
                                                      value="[datafield:birimFiyat]"
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "12px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </KCol>
                                                  <KCol
                                                    key="939949"
                                                    id="939949"
                                                    xs={24}
                                                    sm={24}
                                                    md={24}
                                                    lg={24}
                                                    xl={4}
                                                    xxl={4}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="511664"
                                                      id="511664"
                                                      value="[datafield:miktar]"
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "12px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </KCol>
                                                  <KCol
                                                    key="982771"
                                                    id="982771"
                                                    xs={24}
                                                    sm={24}
                                                    md={24}
                                                    lg={24}
                                                    xl={4}
                                                    xxl={4}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="396373"
                                                      id="396373"
                                                      value="[datafield:satırToplam]"
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "12px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </KCol>
                                                  <KCol
                                                    key="409890"
                                                    id="409890"
                                                    xs={24}
                                                    sm={24}
                                                    md={24}
                                                    lg={24}
                                                    xl={4}
                                                    xxl={4}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-center",
                                                      } as any
                                                    }
                                                  >
                                                    <HorizontalStack
                                                      key="555654"
                                                      id="555654"
                                                      direction="horizontal"
                                                      size={12}
                                                      overflowX="auto"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Icon
                                                        key="340168"
                                                        id="340168"
                                                        visibility={
                                                          this.state
                                                            .isComp340168Visible
                                                        }
                                                        iconName="mode_edit_outline"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 8,
                                                            borderTopRightRadius: 8,
                                                            borderBottomRightRadius: 8,
                                                            borderBottomLeftRadius: 8,
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            backgroundColor:
                                                              "rgba(13, 150, 212, 0.36)",
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "20px",
                                                            color:
                                                              "rgba(13, 150, 212, 1)",
                                                            letterSpacing:
                                                              "1px",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                      <Icon
                                                        key="600161"
                                                        id="600161"
                                                        onClick={(e?: any) => {
                                                          if (
                                                            e &&
                                                            e.stopPropagation
                                                          )
                                                            e.stopPropagation();
                                                          this.CatiGesOnSureclerComponent_600161_onClick();
                                                        }}
                                                        showCursorPointer
                                                        iconName="delete"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 8,
                                                            borderTopRightRadius: 8,
                                                            borderBottomRightRadius: 8,
                                                            borderBottomLeftRadius: 8,
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            backgroundColor:
                                                              "rgba(225, 60, 57, 0.36)",
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "20px",
                                                            color:
                                                              "rgba(218, 84, 82, 1)",
                                                            letterSpacing:
                                                              "1px",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                    </HorizontalStack>
                                                  </KCol>
                                                </KRow>
                                              </KTableColumn>
                                            </KTableRow>
                                          </KTable>
                                          <KRow
                                            key="425935"
                                            id="425935"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="413489"
                                              id="413489"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <VerticalStack
                                                key="586400"
                                                id="586400"
                                                direction="vertical"
                                                size={2}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="252830"
                                                  id="252830"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    252830,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(140, 140, 140, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Form.Item
                                                  className="kFormItem"
                                                  name="catigesonsurecler_600320_value"
                                                >
                                                  <AutoComplete
                                                    key="600320"
                                                    id="600320"
                                                    onSearch={(e?: any) => {
                                                      if (
                                                        e &&
                                                        e.stopPropagation
                                                      )
                                                        e.stopPropagation();
                                                      this.CatiGesOnSureclerComponent_600320_onSearch();
                                                    }}
                                                    onChange={(e?: any) => {
                                                      if (
                                                        e &&
                                                        e.stopPropagation
                                                      )
                                                        e.stopPropagation();
                                                      this.CatiGesOnSureclerComponent_600320_onChange();
                                                    }}
                                                    kuikaRef={
                                                      this
                                                        .catigesonsurecler_600320_value_kuikaAutoCompleteRef
                                                    }
                                                    options={
                                                      this.state
                                                        .GET_NETSIS_STOK_LISTESI
                                                    }
                                                    placeholder={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      600320,
                                                      "placeholder",
                                                      this.defaultML
                                                    )}
                                                    allowClear={false}
                                                    searchable={true}
                                                    datavaluefield="stoK_KODU"
                                                    datatextfield="stoK_ADI"
                                                    style={
                                                      {
                                                        borderTopLeftRadius: 8,
                                                        borderTopRightRadius: 8,
                                                        borderBottomRightRadius: 8,
                                                        borderBottomLeftRadius: 8,
                                                        borderTopWidth: 1,
                                                        borderRightWidth: 1,
                                                        borderBottomWidth: 1,
                                                        borderLeftWidth: 1,
                                                        borderColor:
                                                          "rgba(218, 218, 218, 1)",
                                                        borderStyle: "solid",
                                                        backgroundColor:
                                                          "rgba(255, 255, 255, 1)",
                                                        backgroundRepeat:
                                                          "no-repeat",
                                                        backgroundSize:
                                                          "contain",
                                                        backgroundPosition:
                                                          "left",
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        height: "35px",
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "block",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></AutoComplete>
                                                </Form.Item>
                                              </VerticalStack>
                                            </KCol>
                                            <KCol
                                              key="646190"
                                              id="646190"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={3}
                                              xxl={3}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <VerticalStack
                                                key="132436"
                                                id="132436"
                                                direction="vertical"
                                                size={2}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="605417"
                                                  id="605417"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    605417,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(140, 140, 140, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Form.Item
                                                  className="kFormItem"
                                                  name="catigesonsurecler_102756_value"
                                                >
                                                  <NumberInput
                                                    key="102756"
                                                    id="102756"
                                                    onChange={(e?: any) => {
                                                      if (
                                                        e &&
                                                        e.stopPropagation
                                                      )
                                                        e.stopPropagation();
                                                      this.CatiGesOnSureclerComponent_102756_onChange();
                                                    }}
                                                    decimalSeparator=","
                                                    decimalScale={2}
                                                    disabled={false}
                                                    placeholder={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      102756,
                                                      "placeholder",
                                                      this.defaultML
                                                    )}
                                                    fixedDecimalScale={false}
                                                    allowNegative={true}
                                                    allowEmptyFormatting={false}
                                                    isThousandSeperatorOn={true}
                                                    style={
                                                      {
                                                        borderTopLeftRadius: 8,
                                                        borderTopRightRadius: 8,
                                                        borderBottomRightRadius: 8,
                                                        borderBottomLeftRadius: 8,
                                                        borderTopWidth: 1,
                                                        borderRightWidth: 1,
                                                        borderBottomWidth: 1,
                                                        borderLeftWidth: 1,
                                                        borderColor:
                                                          "rgba(218, 218, 218, 1)",
                                                        borderStyle: "solid",
                                                        backgroundColor:
                                                          "rgba(255, 255, 255, 1)",
                                                        backgroundRepeat:
                                                          "no-repeat",
                                                        backgroundSize:
                                                          "contain",
                                                        backgroundPosition:
                                                          "left",
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        height: "35px",
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "block",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></NumberInput>
                                                </Form.Item>
                                              </VerticalStack>
                                            </KCol>
                                            <KCol
                                              key="468984"
                                              id="468984"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={3}
                                              xxl={3}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <VerticalStack
                                                key="841174"
                                                id="841174"
                                                direction="vertical"
                                                size={2}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="328532"
                                                  id="328532"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    328532,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(140, 140, 140, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Form.Item
                                                  className="kFormItem"
                                                  name="catigesonsurecler_372323_value"
                                                >
                                                  <TextInput
                                                    key="372323"
                                                    id="372323"
                                                    kuikaRef={
                                                      this
                                                        .catigesonsurecler_372323_value_kuikaTextInputRef
                                                    }
                                                    placeholder={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      372323,
                                                      "placeholder",
                                                      this.defaultML
                                                    )}
                                                    allowClear={false}
                                                    bordered={true}
                                                    disabled={false}
                                                    type="text"
                                                    iconColor="rgba(0, 0, 0, 1)"
                                                    formatter="None"
                                                    isCharOnly={false}
                                                    autoComplete={true}
                                                    inputMode="all"
                                                    speechToText={false}
                                                    style={
                                                      {
                                                        borderTopLeftRadius: 8,
                                                        borderTopRightRadius: 8,
                                                        borderBottomRightRadius: 8,
                                                        borderBottomLeftRadius: 8,
                                                        borderTopWidth: 1,
                                                        borderRightWidth: 1,
                                                        borderBottomWidth: 1,
                                                        borderLeftWidth: 1,
                                                        borderColor:
                                                          "rgba(218, 218, 218, 1)",
                                                        borderStyle: "solid",
                                                        backgroundColor:
                                                          "rgba(255, 255, 255, 1)",
                                                        backgroundRepeat:
                                                          "no-repeat",
                                                        backgroundSize:
                                                          "contain",
                                                        backgroundPosition:
                                                          "left",
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        height: "35px",
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "block",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></TextInput>
                                                </Form.Item>
                                              </VerticalStack>
                                            </KCol>
                                            <KCol
                                              key="779621"
                                              id="779621"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={4}
                                              xxl={4}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <VerticalStack
                                                key="58194"
                                                id="58194"
                                                direction="vertical"
                                                size={2}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="549833"
                                                  id="549833"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    549833,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(140, 140, 140, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Form.Item
                                                  className="kFormItem"
                                                  name="catigesonsurecler_180639_value"
                                                >
                                                  <NumberInput
                                                    key="180639"
                                                    id="180639"
                                                    editability={
                                                      this.state
                                                        .isComp180639Enabled
                                                    }
                                                    decimalSeparator=","
                                                    decimalScale={2}
                                                    disabled={false}
                                                    placeholder={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      180639,
                                                      "placeholder",
                                                      this.defaultML
                                                    )}
                                                    fixedDecimalScale={false}
                                                    allowNegative={true}
                                                    allowEmptyFormatting={false}
                                                    isThousandSeperatorOn={true}
                                                    style={
                                                      {
                                                        borderTopLeftRadius: 8,
                                                        borderTopRightRadius: 8,
                                                        borderBottomRightRadius: 8,
                                                        borderBottomLeftRadius: 8,
                                                        borderTopWidth: 1,
                                                        borderRightWidth: 1,
                                                        borderBottomWidth: 1,
                                                        borderLeftWidth: 1,
                                                        borderColor:
                                                          "rgba(218, 218, 218, 1)",
                                                        borderStyle: "solid",
                                                        backgroundColor:
                                                          "rgba(255, 255, 255, 1)",
                                                        backgroundRepeat:
                                                          "no-repeat",
                                                        backgroundSize:
                                                          "contain",
                                                        backgroundPosition:
                                                          "left",
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        height: "35px",
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "block",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></NumberInput>
                                                </Form.Item>
                                              </VerticalStack>
                                            </KCol>
                                            <KCol
                                              key="272427"
                                              id="272427"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={4}
                                              xxl={4}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <VerticalStack
                                                key="749467"
                                                id="749467"
                                                direction="vertical"
                                                size={2}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="101095"
                                                  id="101095"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    101095,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(140, 140, 140, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Form.Item
                                                  className="kFormItem"
                                                  name="catigesonsurecler_153946_value"
                                                >
                                                  <NumberInput
                                                    key="153946"
                                                    id="153946"
                                                    editability={
                                                      this.state
                                                        .isComp153946Enabled
                                                    }
                                                    decimalSeparator=","
                                                    decimalScale={2}
                                                    disabled={false}
                                                    placeholder={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      153946,
                                                      "placeholder",
                                                      this.defaultML
                                                    )}
                                                    fixedDecimalScale={false}
                                                    allowNegative={true}
                                                    allowEmptyFormatting={false}
                                                    isThousandSeperatorOn={true}
                                                    style={
                                                      {
                                                        borderTopLeftRadius: 8,
                                                        borderTopRightRadius: 8,
                                                        borderBottomRightRadius: 8,
                                                        borderBottomLeftRadius: 8,
                                                        borderTopWidth: 1,
                                                        borderRightWidth: 1,
                                                        borderBottomWidth: 1,
                                                        borderLeftWidth: 1,
                                                        borderColor:
                                                          "rgba(218, 218, 218, 1)",
                                                        borderStyle: "solid",
                                                        backgroundColor:
                                                          "rgba(255, 255, 255, 1)",
                                                        backgroundRepeat:
                                                          "no-repeat",
                                                        backgroundSize:
                                                          "contain",
                                                        backgroundPosition:
                                                          "left",
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        height: "35px",
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "block",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></NumberInput>
                                                </Form.Item>
                                              </VerticalStack>
                                            </KCol>
                                            <KCol
                                              key="785366"
                                              id="785366"
                                              xs={24}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={2}
                                              xxl={2}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-end",
                                                  textAlign: "-webkit-center",
                                                } as any
                                              }
                                            >
                                              <Button
                                                key="978224"
                                                id="978224"
                                                onClick={(e?: any) => {
                                                  if (e && e.stopPropagation)
                                                    e.stopPropagation();
                                                  this.CatiGesOnSureclerComponent_978224_onClick();
                                                }}
                                                showCursorPointer
                                                label={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  978224,
                                                  "label",
                                                  this.defaultML
                                                )}
                                                size="middle"
                                                loading={false}
                                                ghost={false}
                                                block={false}
                                                htmlType="button"
                                                icon="add"
                                                iconPosition="left"
                                                danger={false}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    backgroundColor:
                                                      "rgba(13, 150, 212, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 16,
                                                    paddingBottom: 8,
                                                    paddingLeft: 16,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-center",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "12px",
                                                    color:
                                                      "rgba(255, 255, 255, 1)",
                                                    lineHeight: "22px",
                                                  } as any
                                                }
                                              ></Button>
                                            </KCol>
                                          </KRow>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                              <KRow
                                key="43035"
                                id="43035"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                  } as any
                                }
                              >
                                <KCol
                                  key="881224"
                                  id="881224"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 16,
                                      borderTopRightRadius: 16,
                                      borderBottomRightRadius: 16,
                                      borderBottomLeftRadius: 16,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "rgba(244, 248, 251, 1)",
                                      borderStyle: "solid",
                                      paddingBottom: 8,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="51038"
                                    id="51038"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="421291"
                                      id="421291"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 16,
                                          borderTopRightRadius: 16,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          backgroundColor:
                                            "rgba(244, 248, 251, 1)",
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="822980"
                                        id="822980"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="878342"
                                          id="878342"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="803496"
                                            id="803496"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              803496,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                  <KRow
                                    key="573935"
                                    id="573935"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="153496"
                                      id="153496"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="213049"
                                        id="213049"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="865369"
                                          id="865369"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 16,
                                              paddingRight: 16,
                                              paddingBottom: 16,
                                              paddingLeft: 16,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="249865"
                                            id="249865"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="471386"
                                              id="471386"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                471386,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_490847_value"
                                            >
                                              <TextArea
                                                key="490847"
                                                id="490847"
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  490847,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                allowClear={false}
                                                autoSize={false}
                                                showCount={false}
                                                formatter="None"
                                                readOnly={false}
                                                speechToText={false}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></TextArea>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="538600"
                                          id="538600"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 12,
                                              paddingRight: 16,
                                              paddingBottom: 12,
                                              paddingLeft: 16,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="30952"
                                            id="30952"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="731438"
                                              id="731438"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                731438,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_668639_value"
                                            >
                                              <TextArea
                                                key="668639"
                                                id="668639"
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  668639,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                allowClear={false}
                                                autoSize={false}
                                                showCount={false}
                                                formatter="None"
                                                readOnly={false}
                                                speechToText={false}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></TextArea>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                        <KCol
                                          key="979318"
                                          id="979318"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 12,
                                              paddingRight: 16,
                                              paddingBottom: 12,
                                              paddingLeft: 16,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <VerticalStack
                                            key="97728"
                                            id="97728"
                                            direction="vertical"
                                            size={2}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="586255"
                                              id="586255"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                586255,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color:
                                                    "rgba(140, 140, 140, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Form.Item
                                              className="kFormItem"
                                              name="catigesonsurecler_91916_value"
                                            >
                                              <TextArea
                                                key="91916"
                                                id="91916"
                                                placeholder={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  91916,
                                                  "placeholder",
                                                  this.defaultML
                                                )}
                                                allowClear={false}
                                                autoSize={false}
                                                showCount={false}
                                                formatter="None"
                                                readOnly={false}
                                                speechToText={false}
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(218, 218, 218, 1)",
                                                    borderStyle: "solid",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "left",
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "block",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></TextArea>
                                            </Form.Item>
                                          </VerticalStack>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                              <KRow
                                key="958446"
                                id="958446"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                  } as any
                                }
                              >
                                <KCol
                                  key="571805"
                                  id="571805"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 16,
                                      borderTopRightRadius: 16,
                                      borderBottomRightRadius: 16,
                                      borderBottomLeftRadius: 16,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "rgba(244, 248, 251, 1)",
                                      borderStyle: "solid",
                                      paddingBottom: 8,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="539226"
                                    id="539226"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="958945"
                                      id="958945"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 16,
                                          borderTopRightRadius: 16,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          backgroundColor:
                                            "rgba(244, 248, 251, 1)",
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="979996"
                                        id="979996"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="737393"
                                          id="737393"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="268525"
                                            id="268525"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              268525,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                  <KRow
                                    key="729168"
                                    id="729168"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="104434"
                                      id="104434"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="768249"
                                        id="768249"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="486361"
                                          id="486361"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderTopLeftRadius: 8,
                                              borderTopRightRadius: 8,
                                              borderBottomRightRadius: 8,
                                              borderBottomLeftRadius: 8,
                                              borderTopWidth: 1,
                                              borderRightWidth: 1,
                                              borderBottomWidth: 1,
                                              borderLeftWidth: 1,
                                              borderColor:
                                                "rgba(217, 217, 217, 1)",
                                              borderStyle: "solid",
                                              backgroundColor:
                                                "rgba(244, 248, 251, 1)",
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 16,
                                              alignItems: "center",
                                              textAlign: "-webkit-center",
                                            } as any
                                          }
                                        >
                                          <KRow
                                            key="584545"
                                            id="584545"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="511441"
                                              id="511441"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={24}
                                              xxl={24}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="74609"
                                                id="74609"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="619935"
                                                  id="619935"
                                                  xs={12}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={12}
                                                  xxl={12}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="885261"
                                                    id="885261"
                                                    value={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      885261,
                                                      "value",
                                                      this.defaultML
                                                    )}
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KCol>
                                                <KCol
                                                  key="108406"
                                                  id="108406"
                                                  xs={12}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={12}
                                                  xxl={12}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      textAlign:
                                                        "-webkit-right",
                                                    } as any
                                                  }
                                                >
                                                  <Button
                                                    key="414931"
                                                    id="414931"
                                                    onClick={(e?: any) => {
                                                      if (
                                                        e &&
                                                        e.stopPropagation
                                                      )
                                                        e.stopPropagation();
                                                      this.CatiGesOnSureclerComponent_414931_onClick();
                                                    }}
                                                    showCursorPointer
                                                    label={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      414931,
                                                      "label",
                                                      this.defaultML
                                                    )}
                                                    size="middle"
                                                    loading={false}
                                                    ghost={false}
                                                    block={false}
                                                    htmlType="button"
                                                    icon="attach_email"
                                                    iconPosition="left"
                                                    danger={false}
                                                    style={
                                                      {
                                                        borderTopLeftRadius: 8,
                                                        borderTopRightRadius: 8,
                                                        borderBottomRightRadius: 8,
                                                        borderBottomLeftRadius: 8,
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        backgroundColor:
                                                          "rgba(13, 150, 212, 0.64)",
                                                        backgroundRepeat:
                                                          "no-repeat",
                                                        backgroundSize:
                                                          "contain",
                                                        backgroundPosition:
                                                          "left",
                                                        paddingTop: 8,
                                                        paddingRight: 16,
                                                        paddingBottom: 8,
                                                        paddingLeft: 16,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-center",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(255, 255, 255, 1)",
                                                        lineHeight: "22px",
                                                      } as any
                                                    }
                                                  ></Button>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                            <KCol
                                              key="605224"
                                              id="605224"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={24}
                                              xxl={24}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <KTable
                                                key="775136"
                                                id="775136"
                                                kuikaRef={
                                                  this
                                                    .catigesonsurecler_775136_value_kuikaTableRef
                                                }
                                                form={this.props.form}
                                                dataSource={
                                                  this.state.DosyalariGetir
                                                }
                                                size="middle"
                                                bordered={true}
                                                loading={false}
                                                rowKey="id"
                                                transformedOnMobileResolution={
                                                  false
                                                }
                                                hideHeaderOnMobileResolution={
                                                  false
                                                }
                                                showHeader={false}
                                                fixedHeader={false}
                                                tableWidthMode="fit"
                                                editable={false}
                                                editableAlwaysActive={false}
                                                insertRowActive={false}
                                                insertRowPosition="top"
                                                globalSearch={false}
                                                searchable={false}
                                                shouldSearchOnChange={true}
                                                searchDelay={200}
                                                sorter={false}
                                                filtering={false}
                                                resizableColumns={false}
                                                pagination={false}
                                                pageSize={10}
                                                showSizeChanger={false}
                                                paginationSelectedTextColor="#246eff"
                                                paginationUnselectedTextColor="#000"
                                                columnChooser={false}
                                                striped={false}
                                                stripedColor="#F5F7FA"
                                                rowHoverBgColor="#fafafa"
                                                showRowNumbers={false}
                                                showNoDataFound={true}
                                                nodatafoundmessage={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  775136,
                                                  "nodatafoundmessage",
                                                  this.defaultML
                                                )}
                                                multiSelect={false}
                                                multiSelectScope="page"
                                                export={false}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <KTableHeader
                                                  key="727876"
                                                  id="727876"
                                                  hideOnMobileResolution={false}
                                                  textDirection="Default"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                      color:
                                                        "rgba(155, 155, 155, 1)",
                                                      lineHeight: "20px",
                                                    } as any
                                                  }
                                                ></KTableHeader>
                                                <KTableRow
                                                  key="840636"
                                                  id="840636"
                                                  hoverFontColor="red"
                                                  hoverBgColor="#F5F5F5"
                                                  style={
                                                    {
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <KTableColumn
                                                    key="141187"
                                                    id="141187"
                                                    title={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      141187,
                                                      "title",
                                                      this.defaultML
                                                    )}
                                                    alwaysVisibleOnMobileResolution={
                                                      false
                                                    }
                                                    hideFiltering={false}
                                                    hideSorting={false}
                                                    hideSearch={false}
                                                    footerOptions="none"
                                                    footerFontSize={14}
                                                    footerFontColor="rgb(68, 68, 68)"
                                                    excludeFromExport={false}
                                                    footerFontWeight="Regular"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <KRow
                                                      key="553633"
                                                      id="553633"
                                                      align="top"
                                                      justify="start"
                                                      horizontalGutter={0}
                                                      verticalGutter={0}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                        } as any
                                                      }
                                                    >
                                                      <KCol
                                                        key="539353"
                                                        id="539353"
                                                        xs={24}
                                                        sm={24}
                                                        md={24}
                                                        lg={24}
                                                        xl={12}
                                                        xxl={12}
                                                        order={0}
                                                        pull={0}
                                                        push={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                          } as any
                                                        }
                                                      >
                                                        <HorizontalStack
                                                          key="607315"
                                                          id="607315"
                                                          direction="horizontal"
                                                          size={12}
                                                          overflowX="auto"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Icon
                                                            key="536733"
                                                            id="536733"
                                                            iconName="assignment"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "20px",
                                                                color:
                                                                  "rgba(155, 155, 155, 1)",
                                                                letterSpacing:
                                                                  "1px",
                                                              } as any
                                                            }
                                                          ></Icon>
                                                          <Label
                                                            key="735119"
                                                            id="735119"
                                                            value="[datafield:dosyaAdi]"
                                                            maxLine={20}
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 400,
                                                                fontSize:
                                                                  "10px",
                                                                color:
                                                                  "rgba(140, 140, 140, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                        </HorizontalStack>
                                                      </KCol>
                                                      <KCol
                                                        key="879409"
                                                        id="879409"
                                                        xs={24}
                                                        sm={24}
                                                        md={24}
                                                        lg={24}
                                                        xl={12}
                                                        xxl={12}
                                                        order={0}
                                                        pull={0}
                                                        push={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            textAlign:
                                                              "-webkit-right",
                                                          } as any
                                                        }
                                                      >
                                                        <HorizontalStack
                                                          key="698919"
                                                          id="698919"
                                                          direction="horizontal"
                                                          size={12}
                                                          overflowX="auto"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Icon
                                                            key="684853"
                                                            id="684853"
                                                            onClick={(
                                                              e?: any
                                                            ) => {
                                                              if (
                                                                e &&
                                                                e.stopPropagation
                                                              )
                                                                e.stopPropagation();
                                                              this.CatiGesOnSureclerComponent_684853_onClick();
                                                            }}
                                                            showCursorPointer
                                                            iconName="get_app"
                                                            hoverText="İndir"
                                                            style={
                                                              {
                                                                borderTopLeftRadius: 8,
                                                                borderTopRightRadius: 8,
                                                                borderBottomRightRadius: 8,
                                                                borderBottomLeftRadius: 8,
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                backgroundColor:
                                                                  "rgba(13, 150, 212, 0.36)",
                                                                paddingTop: 8,
                                                                paddingRight: 8,
                                                                paddingBottom: 8,
                                                                paddingLeft: 8,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "20px",
                                                                color:
                                                                  "rgba(13, 150, 212, 1)",
                                                                letterSpacing:
                                                                  "1px",
                                                              } as any
                                                            }
                                                          ></Icon>
                                                          <Icon
                                                            key="67793"
                                                            id="67793"
                                                            onClick={(
                                                              e?: any
                                                            ) => {
                                                              if (
                                                                e &&
                                                                e.stopPropagation
                                                              )
                                                                e.stopPropagation();
                                                              this.CatiGesOnSureclerComponent_67793_onClick();
                                                            }}
                                                            showCursorPointer
                                                            iconName="delete"
                                                            hoverText="Sil"
                                                            style={
                                                              {
                                                                borderTopLeftRadius: 8,
                                                                borderTopRightRadius: 8,
                                                                borderBottomRightRadius: 8,
                                                                borderBottomLeftRadius: 8,
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                backgroundColor:
                                                                  "rgba(225, 60, 57, 0.36)",
                                                                paddingTop: 8,
                                                                paddingRight: 8,
                                                                paddingBottom: 8,
                                                                paddingLeft: 8,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "20px",
                                                                color:
                                                                  "rgba(218, 84, 82, 1)",
                                                                letterSpacing:
                                                                  "1px",
                                                              } as any
                                                            }
                                                          ></Icon>
                                                        </HorizontalStack>
                                                      </KCol>
                                                    </KRow>
                                                  </KTableColumn>
                                                </KTableRow>
                                              </KTable>
                                            </KCol>
                                          </KRow>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="921136"
                                        id="921136"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderTopLeftRadius: 8,
                                            borderTopRightRadius: 8,
                                            borderBottomRightRadius: 8,
                                            borderBottomLeftRadius: 8,
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            backgroundColor:
                                              "rgba(9, 124, 176, 1)",
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="139256"
                                          id="139256"
                                          xs={16}
                                          sm={16}
                                          md={16}
                                          lg={16}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="639072"
                                            id="639072"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              639072,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(255, 255, 255, 1)",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="56336"
                                          id="56336"
                                          xs={8}
                                          sm={8}
                                          md={8}
                                          lg={8}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="806020"
                                            id="806020"
                                            value={
                                              this.state.KalemleriGetir?.at?.(0)
                                                ?.genelToplam ?? undefined
                                            }
                                            formatter="money-tl-4-decimal"
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 600,
                                                fontSize: "14px",
                                                color: "rgba(255, 255, 255, 1)",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="492871"
                                        id="492871"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="362494"
                                          id="362494"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 30,
                                              paddingRight: 0,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <HorizontalStack
                                            key="393811"
                                            id="393811"
                                            direction="horizontal"
                                            size={12}
                                            overflowX="auto"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Button
                                              key="596085"
                                              id="596085"
                                              onClick={(e?: any) => {
                                                if (e && e.stopPropagation)
                                                  e.stopPropagation();
                                                this.CatiGesOnSureclerComponent_596085_onClick();
                                              }}
                                              showCursorPointer
                                              editability={
                                                this.state.isComp596085Enabled
                                              }
                                              label={ReactSystemFunctions.translate(
                                                this.ml,
                                                596085,
                                                "label",
                                                this.defaultML
                                              )}
                                              size="middle"
                                              loading={false}
                                              ghost={false}
                                              block={false}
                                              htmlType="button"
                                              icon="save"
                                              iconPosition="left"
                                              danger={false}
                                              style={
                                                {
                                                  borderTopLeftRadius: 8,
                                                  borderTopRightRadius: 8,
                                                  borderBottomRightRadius: 8,
                                                  borderBottomLeftRadius: 8,
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  backgroundColor:
                                                    "rgba(13, 150, 212, 1)",
                                                  backgroundRepeat: "no-repeat",
                                                  backgroundSize: "contain",
                                                  backgroundPosition: "left",
                                                  paddingTop: 8,
                                                  paddingRight: 16,
                                                  paddingBottom: 8,
                                                  paddingLeft: 16,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-center",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "12px",
                                                  color:
                                                    "rgba(255, 255, 255, 1)",
                                                  lineHeight: "22px",
                                                } as any
                                              }
                                            ></Button>
                                          </HorizontalStack>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                        </KTabItem>
                        <KTabItem
                          key={442005}
                          id="442005"
                          onActive={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.CatiGesOnSureclerComponent_442005_onActive();
                          }}
                          visibility={
                            this.state
                              .isCompcatigesonsurecler_442005AuthorizationVisible
                          }
                          visibilityByAuthorization={
                            this.state
                              .isCompcatigesonsurecler_442005AuthorizationVisible
                          }
                          tab={ReactSystemFunctions.translate(
                            this.ml,
                            442005,
                            "tab",
                            this.defaultML
                          )}
                          forceRender={false}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(255, 255, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KRow
                            key="843199"
                            id="843199"
                            visibility={this.state.isComp843199Visible}
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <KCol
                              key="179635"
                              id="179635"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                } as any
                              }
                            >
                              <KRow
                                key="103719"
                                id="103719"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                  } as any
                                }
                              >
                                <KCol
                                  key="744617"
                                  id="744617"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 16,
                                      borderTopRightRadius: 16,
                                      borderBottomRightRadius: 16,
                                      borderBottomLeftRadius: 16,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "rgba(244, 248, 251, 1)",
                                      borderStyle: "solid",
                                      paddingBottom: 8,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="909540"
                                    id="909540"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="104158"
                                      id="104158"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 16,
                                          borderTopRightRadius: 16,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          backgroundColor:
                                            "rgba(244, 248, 251, 1)",
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="70817"
                                        id="70817"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="257417"
                                          id="257417"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 0,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="492374"
                                            id="492374"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              492374,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="538937"
                                        id="538937"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="383283"
                                          id="383283"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={3}
                                          xxl={3}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="761485"
                                            id="761485"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              761485,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontSize: "10px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="767704"
                                          id="767704"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={3}
                                          xxl={3}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="503052"
                                            id="503052"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              503052,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontSize: "10px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="472213"
                                          id="472213"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={3}
                                          xxl={3}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="923873"
                                            id="923873"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              923873,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontSize: "10px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="953174"
                                          id="953174"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={3}
                                          xxl={3}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="727190"
                                            id="727190"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              727190,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontSize: "10px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="482827"
                                          id="482827"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={2}
                                          xxl={2}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="927767"
                                            id="927767"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              927767,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontSize: "10px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="563225"
                                          id="563225"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={2}
                                          xxl={2}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="361335"
                                            id="361335"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              361335,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontSize: "10px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="804776"
                                          id="804776"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={2}
                                          xxl={2}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="108137"
                                            id="108137"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              108137,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontSize: "10px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="683202"
                                          id="683202"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={2}
                                          xxl={2}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="252489"
                                            id="252489"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              252489,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontSize: "10px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="535810"
                                          id="535810"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={2}
                                          xxl={2}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="68685"
                                            id="68685"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              68685,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontSize: "10px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="462370"
                                          id="462370"
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={2}
                                          xxl={2}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="91880"
                                            id="91880"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              91880,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontSize: "10px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                  <KRow
                                    key="420506"
                                    id="420506"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="514610"
                                      id="514610"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="36532"
                                        id="36532"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="418238"
                                          id="418238"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <KTable
                                            key="467193"
                                            id="467193"
                                            kuikaRef={
                                              this
                                                .catigesonsurecler_467193_value_kuikaTableRef
                                            }
                                            form={this.props.form}
                                            dataSource={
                                              this.state
                                                .PROFORMA_KALEMLERI_GETIR
                                            }
                                            size="middle"
                                            bordered={true}
                                            loading={false}
                                            rowKey="id"
                                            transformedOnMobileResolution={
                                              false
                                            }
                                            hideHeaderOnMobileResolution={false}
                                            showHeader={false}
                                            fixedHeader={false}
                                            tableWidthMode="fit"
                                            editable={false}
                                            editableAlwaysActive={false}
                                            insertRowActive={false}
                                            insertRowPosition="top"
                                            globalSearch={false}
                                            searchable={false}
                                            shouldSearchOnChange={true}
                                            searchDelay={200}
                                            sorter={false}
                                            filtering={false}
                                            resizableColumns={false}
                                            pagination={false}
                                            pageSize={10}
                                            showSizeChanger={false}
                                            paginationSelectedTextColor="#246eff"
                                            paginationUnselectedTextColor="#000"
                                            columnChooser={false}
                                            striped={false}
                                            stripedColor="#F5F7FA"
                                            rowHoverBgColor="#fafafa"
                                            showRowNumbers={false}
                                            showNoDataFound={true}
                                            nodatafoundmessage={ReactSystemFunctions.translate(
                                              this.ml,
                                              467193,
                                              "nodatafoundmessage",
                                              this.defaultML
                                            )}
                                            multiSelect={false}
                                            multiSelectScope="page"
                                            export={false}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KTableHeader
                                              key="18307"
                                              id="18307"
                                              hideOnMobileResolution={false}
                                              textDirection="Default"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "12px",
                                                  color:
                                                    "rgba(155, 155, 155, 1)",
                                                  lineHeight: "20px",
                                                } as any
                                              }
                                            ></KTableHeader>
                                            <KTableRow
                                              key="976833"
                                              id="976833"
                                              hoverFontColor="red"
                                              hoverBgColor="#F5F5F5"
                                              style={
                                                {
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KTableColumn
                                                key="546814"
                                                id="546814"
                                                title={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  546814,
                                                  "title",
                                                  this.defaultML
                                                )}
                                                alwaysVisibleOnMobileResolution={
                                                  false
                                                }
                                                hideFiltering={false}
                                                hideSorting={false}
                                                hideSearch={false}
                                                footerOptions="none"
                                                footerFontSize={14}
                                                footerFontColor="rgb(68, 68, 68)"
                                                excludeFromExport={false}
                                                footerFontWeight="Regular"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <KRow
                                                  key="575157"
                                                  id="575157"
                                                  align="top"
                                                  justify="start"
                                                  horizontalGutter={0}
                                                  verticalGutter={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                    } as any
                                                  }
                                                >
                                                  <KCol
                                                    key="755241"
                                                    id="755241"
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={3}
                                                    xxl={3}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="217098"
                                                      id="217098"
                                                      value="[datafield:fisno]"
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "9px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </KCol>
                                                  <KCol
                                                    key="124054"
                                                    id="124054"
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={3}
                                                    xxl={3}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="485116"
                                                      id="485116"
                                                      value="[datafield:stoK_KODU]"
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "9px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </KCol>
                                                  <KCol
                                                    key="315126"
                                                    id="315126"
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={3}
                                                    xxl={3}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="267925"
                                                      id="267925"
                                                      value="[datafield:stoK_ADI]"
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "9px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </KCol>
                                                  <KCol
                                                    key="959674"
                                                    id="959674"
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={3}
                                                    xxl={3}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="249797"
                                                      id="249797"
                                                      value="[datafield:sthaR_GCMIK]"
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "9px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </KCol>
                                                  <KCol
                                                    key="454292"
                                                    id="454292"
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={2}
                                                    xxl={2}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="748643"
                                                      id="748643"
                                                      value="[datafield:sthaR_DOVFIAT]"
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "9px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </KCol>
                                                  <KCol
                                                    key="760784"
                                                    id="760784"
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={2}
                                                    xxl={2}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-center",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="481954"
                                                      id="481954"
                                                      value="[datafield:parA_BIRIMI]"
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "9px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </KCol>
                                                  <KCol
                                                    key="986420"
                                                    id="986420"
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={2}
                                                    xxl={2}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="541041"
                                                      id="541041"
                                                      value="[datafield:sthaR_NF]"
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "9px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </KCol>
                                                  <KCol
                                                    key="282442"
                                                    id="282442"
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={2}
                                                    xxl={2}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="855537"
                                                      id="855537"
                                                      value="[datafield:isK1]"
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "9px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </KCol>
                                                  <KCol
                                                    key="400567"
                                                    id="400567"
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={2}
                                                    xxl={2}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="812402"
                                                      id="812402"
                                                      value="[datafield:isK2]"
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "9px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </KCol>
                                                  <KCol
                                                    key="341736"
                                                    id="341736"
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={2}
                                                    xxl={2}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="92500"
                                                      id="92500"
                                                      value="[datafield:doviztut]"
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "9px",
                                                          color:
                                                            "rgba(44, 62, 80, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </KCol>
                                                </KRow>
                                              </KTableColumn>
                                            </KTableRow>
                                          </KTable>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                  <KRow
                                    key="658025"
                                    id="658025"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        borderBottomRightRadius: 8,
                                        borderBottomLeftRadius: 8,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor: "rgba(9, 124, 176, 1)",
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="503881"
                                      id="503881"
                                      xs={16}
                                      sm={16}
                                      md={16}
                                      lg={16}
                                      xl={16}
                                      xxl={16}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <Label
                                        key="117363"
                                        id="117363"
                                        value={ReactSystemFunctions.translate(
                                          this.ml,
                                          117363,
                                          "value",
                                          this.defaultML
                                        )}
                                        writingMode="horizontal"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(255, 255, 255, 1)",
                                          } as any
                                        }
                                      ></Label>
                                    </KCol>
                                    <KCol
                                      key="782837"
                                      id="782837"
                                      xs={8}
                                      sm={8}
                                      md={8}
                                      lg={8}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "center",
                                          textAlign: "-webkit-right",
                                        } as any
                                      }
                                    >
                                      <Label
                                        key="968343"
                                        id="968343"
                                        value={
                                          this.state.PROFORMA_KALEMLERI_GETIR?.at?.(
                                            0
                                          )?.geneltoplam ?? undefined
                                        }
                                        formatter="money-tl"
                                        writingMode="horizontal"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 600,
                                            fontSize: "14px",
                                            color: "rgba(255, 255, 255, 1)",
                                          } as any
                                        }
                                      ></Label>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                              <KRow
                                key="695893"
                                id="695893"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="812942"
                                  id="812942"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="616944"
                                    id="616944"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingBottom: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="899204"
                                      id="899204"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={12}
                                      xxl={12}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 0,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="448469"
                                        id="448469"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderTopLeftRadius: 12,
                                            borderTopRightRadius: 12,
                                            borderBottomRightRadius: 12,
                                            borderBottomLeftRadius: 12,
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            backgroundColor:
                                              "rgba(244, 248, 251, 1)",
                                            paddingTop: 0,
                                            paddingRight: 8,
                                            paddingBottom: 0,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="103486"
                                          id="103486"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <KRow
                                            key="490605"
                                            id="490605"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="623243"
                                              id="623243"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="377392"
                                                id="377392"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  377392,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 600,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="536024"
                                              id="536024"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            ></KCol>
                                          </KRow>
                                          <KRow
                                            key="782602"
                                            id="782602"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="771856"
                                              id="771856"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="36005"
                                                id="36005"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  36005,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="773067"
                                              id="773067"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="357016"
                                                id="357016"
                                                value={
                                                  this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                    0
                                                  )?.kategoriAdi ?? undefined
                                                }
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="442358"
                                            id="442358"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="967737"
                                              id="967737"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="467975"
                                                id="467975"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  467975,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="481212"
                                              id="481212"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="455222"
                                                id="455222"
                                                value={
                                                  this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                    0
                                                  )?.netsisProjKodu ?? undefined
                                                }
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="979231"
                                            id="979231"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="777225"
                                              id="777225"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="343483"
                                                id="343483"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  343483,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="613326"
                                              id="613326"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="402895"
                                                id="402895"
                                                value={
                                                  this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                    0
                                                  )?.musteriAdi ?? undefined
                                                }
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="621378"
                                            id="621378"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="898861"
                                              id="898861"
                                              xs={8}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="390610"
                                                id="390610"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  390610,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="463436"
                                              id="463436"
                                              xs={16}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="625966"
                                                id="625966"
                                                value={
                                                  this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                    0
                                                  )?.iletisimKisi ?? undefined
                                                }
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="873799"
                                            id="873799"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="448084"
                                              id="448084"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="391696"
                                                id="391696"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  391696,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="150914"
                                              id="150914"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="514278"
                                                id="514278"
                                                value={
                                                  this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                    0
                                                  )?.telefon ?? undefined
                                                }
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                          </KRow>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                    <KCol
                                      key="162204"
                                      id="162204"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={12}
                                      xxl={12}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 0,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="758954"
                                        id="758954"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderTopLeftRadius: 12,
                                            borderTopRightRadius: 12,
                                            borderBottomRightRadius: 12,
                                            borderBottomLeftRadius: 12,
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            backgroundColor:
                                              "rgba(244, 248, 251, 1)",
                                            paddingTop: 0,
                                            paddingRight: 8,
                                            paddingBottom: 0,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="950504"
                                          id="950504"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <KRow
                                            key="993521"
                                            id="993521"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="163586"
                                              id="163586"
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={12}
                                              xxl={12}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="359594"
                                                id="359594"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  359594,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 600,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="447"
                                              id="447"
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={12}
                                              xxl={12}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            ></KCol>
                                          </KRow>
                                          <KRow
                                            key="281337"
                                            id="281337"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="533617"
                                              id="533617"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="724741"
                                                id="724741"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  724741,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="998841"
                                              id="998841"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <HorizontalStack
                                                key="825089"
                                                id="825089"
                                                visibility={
                                                  this.state.isComp825089Visible
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="139831"
                                                  id="139831"
                                                  iconName="check_circle"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(114, 194, 64, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="784309"
                                                  id="784309"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      0
                                                    )?.kesif_Tarih ?? undefined
                                                  }
                                                  formatter="date"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="769315"
                                                  id="769315"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    769315,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="936865"
                                                  id="936865"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      0
                                                    )?.netKesif_KullaniciAdi ??
                                                    undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                              <HorizontalStack
                                                key="340333"
                                                id="340333"
                                                visibility={
                                                  this.state.isComp340333Visible
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="317607"
                                                  id="317607"
                                                  iconName="hourglass_bottom"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="283877"
                                                  id="283877"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    283877,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="697158"
                                            id="697158"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="745220"
                                              id="745220"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="697210"
                                                id="697210"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  697210,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="103739"
                                              id="103739"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <HorizontalStack
                                                key="589579"
                                                id="589579"
                                                visibility={
                                                  this.state.isComp589579Visible
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="799951"
                                                  id="799951"
                                                  iconName="check_circle"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(114, 194, 64, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="115403"
                                                  id="115403"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      0
                                                    )?.proforma_Tarih ??
                                                    undefined
                                                  }
                                                  formatter="date"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="979155"
                                                  id="979155"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    979155,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="199667"
                                                  id="199667"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      0
                                                    )?.proforma_KullaniciAdi ??
                                                    undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                              <HorizontalStack
                                                key="278838"
                                                id="278838"
                                                visibility={
                                                  this.state.isComp278838Visible
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="963466"
                                                  id="963466"
                                                  iconName="hourglass_bottom"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="904529"
                                                  id="904529"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    904529,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="71583"
                                            id="71583"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="185703"
                                              id="185703"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="653453"
                                                id="653453"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  653453,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="390645"
                                              id="390645"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <HorizontalStack
                                                key="788639"
                                                id="788639"
                                                visibility={
                                                  this.state.isComp788639Visible
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="39225"
                                                  id="39225"
                                                  iconName="check_circle"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(114, 194, 64, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="122248"
                                                  id="122248"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      0
                                                    )?.netKesif_Tarih ??
                                                    undefined
                                                  }
                                                  formatter="date"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="785953"
                                                  id="785953"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    785953,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="330741"
                                                  id="330741"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      0
                                                    )?.netKesif_KullaniciAdi ??
                                                    undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                              <HorizontalStack
                                                key="557821"
                                                id="557821"
                                                visibility={
                                                  this.state.isComp557821Visible
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="6765"
                                                  id="6765"
                                                  iconName="hourglass_bottom"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="789758"
                                                  id="789758"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    789758,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="126570"
                                            id="126570"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="793339"
                                              id="793339"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="115413"
                                                id="115413"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  115413,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="69687"
                                              id="69687"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <HorizontalStack
                                                key="171830"
                                                id="171830"
                                                visibility={
                                                  this.state.isComp171830Visible
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="842694"
                                                  id="842694"
                                                  iconName="check_circle"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(114, 194, 64, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="977440"
                                                  id="977440"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      0
                                                    )?.pM_OnayTarih ?? undefined
                                                  }
                                                  formatter="date"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="265953"
                                                  id="265953"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    265953,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="76435"
                                                  id="76435"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      0
                                                    )?.pM_OnaylayanAdi ??
                                                    undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                              <HorizontalStack
                                                key="485928"
                                                id="485928"
                                                visibility={
                                                  this.state.isComp485928Visible
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="856035"
                                                  id="856035"
                                                  iconName="hourglass_bottom"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="478901"
                                                  id="478901"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    478901,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="64850"
                                            id="64850"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="564039"
                                              id="564039"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="893975"
                                                id="893975"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  893975,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="196713"
                                              id="196713"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <HorizontalStack
                                                key="429832"
                                                id="429832"
                                                visibility={
                                                  this.state.isComp429832Visible
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="521160"
                                                  id="521160"
                                                  iconName="check_circle"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(114, 194, 64, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="585379"
                                                  id="585379"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      -1
                                                    )?.uY_OnayTarih ?? undefined
                                                  }
                                                  formatter="date"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="536017"
                                                  id="536017"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    536017,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="678296"
                                                  id="678296"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      -1
                                                    )?.uY_OnaylayanAdi ??
                                                    undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                              <HorizontalStack
                                                key="384588"
                                                id="384588"
                                                visibility={
                                                  this.state.isComp384588Visible
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="664508"
                                                  id="664508"
                                                  iconName="hourglass_bottom"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="286761"
                                                  id="286761"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    286761,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                            </KCol>
                                          </KRow>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                  <KRow
                                    key="602194"
                                    id="602194"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="814465"
                                      id="814465"
                                      visibility={
                                        this.state.isComp814465Visible
                                      }
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 0,
                                          paddingBottom: 8,
                                          paddingLeft: 0,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="537581"
                                        id="537581"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderTopLeftRadius: 12,
                                            borderTopRightRadius: 12,
                                            borderBottomRightRadius: 12,
                                            borderBottomLeftRadius: 12,
                                            borderTopWidth: 1,
                                            borderRightWidth: 1,
                                            borderBottomWidth: 1,
                                            borderLeftWidth: 1,
                                            borderColor:
                                              "rgba(203, 179, 242, 0.66)",
                                            borderStyle: "solid",
                                            backgroundColor:
                                              "rgba(203, 179, 242, 0.36)",
                                            paddingTop: 0,
                                            paddingRight: 8,
                                            paddingBottom: 0,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="664394"
                                          id="664394"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <KRow
                                            key="457116"
                                            id="457116"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="373557"
                                              id="373557"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={24}
                                              xxl={24}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="523429"
                                                id="523429"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  523429,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "12px",
                                                    color:
                                                      "rgba(106, 50, 201, 1)",
                                                  } as any
                                                }
                                              ></Label>
                                              <KRow
                                                key="102645"
                                                id="102645"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 8,
                                                    paddingLeft: 0,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="735258"
                                                  id="735258"
                                                  xs={24}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={6}
                                                  xxl={6}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                    } as any
                                                  }
                                                >
                                                  <KRow
                                                    key="68207"
                                                    id="68207"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="560821"
                                                      id="560821"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 8,
                                                          borderTopRightRadius: 8,
                                                          borderBottomRightRadius: 8,
                                                          borderBottomLeftRadius: 8,
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          backgroundColor:
                                                            "rgba(255, 255, 255, 1)",
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-center",
                                                        } as any
                                                      }
                                                    >
                                                      <VerticalStack
                                                        key="579527"
                                                        id="579527"
                                                        direction="vertical"
                                                        size={2}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="197581"
                                                          id="197581"
                                                          value={
                                                            this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                              0
                                                            )
                                                              ?.kesif_TahminiGuc ??
                                                            undefined
                                                          }
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 600,
                                                              fontSize: "16px",
                                                              color:
                                                                "rgba(106, 50, 201, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                        <Label
                                                          key="242331"
                                                          id="242331"
                                                          value={ReactSystemFunctions.translate(
                                                            this.ml,
                                                            242331,
                                                            "value",
                                                            this.defaultML
                                                          )}
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "12px",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </VerticalStack>
                                                    </KCol>
                                                  </KRow>
                                                </KCol>
                                                <KCol
                                                  key="203621"
                                                  id="203621"
                                                  xs={24}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={6}
                                                  xxl={6}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                    } as any
                                                  }
                                                >
                                                  <KRow
                                                    key="399382"
                                                    id="399382"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="685031"
                                                      id="685031"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 8,
                                                          borderTopRightRadius: 8,
                                                          borderBottomRightRadius: 8,
                                                          borderBottomLeftRadius: 8,
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          backgroundColor:
                                                            "rgba(255, 255, 255, 1)",
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-center",
                                                        } as any
                                                      }
                                                    >
                                                      <VerticalStack
                                                        key="700032"
                                                        id="700032"
                                                        direction="vertical"
                                                        size={2}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="4809"
                                                          id="4809"
                                                          value={
                                                            this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                              0
                                                            )?.kesif_AlanM2 ??
                                                            undefined
                                                          }
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 600,
                                                              fontSize: "16px",
                                                              color:
                                                                "rgba(106, 50, 201, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                        <Label
                                                          key="874933"
                                                          id="874933"
                                                          value={ReactSystemFunctions.translate(
                                                            this.ml,
                                                            874933,
                                                            "value",
                                                            this.defaultML
                                                          )}
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "12px",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </VerticalStack>
                                                    </KCol>
                                                  </KRow>
                                                </KCol>
                                                <KCol
                                                  key="983804"
                                                  id="983804"
                                                  xs={24}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={6}
                                                  xxl={6}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                    } as any
                                                  }
                                                >
                                                  <KRow
                                                    key="453471"
                                                    id="453471"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="583039"
                                                      id="583039"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 8,
                                                          borderTopRightRadius: 8,
                                                          borderBottomRightRadius: 8,
                                                          borderBottomLeftRadius: 8,
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          backgroundColor:
                                                            "rgba(255, 255, 255, 1)",
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-center",
                                                        } as any
                                                      }
                                                    >
                                                      <VerticalStack
                                                        key="389544"
                                                        id="389544"
                                                        direction="vertical"
                                                        size={2}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="969958"
                                                          id="969958"
                                                          value={
                                                            this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                              0
                                                            )
                                                              ?.teknik_CatiTipi ??
                                                            undefined
                                                          }
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 600,
                                                              fontSize: "16px",
                                                              color:
                                                                "rgba(106, 50, 201, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                        <Label
                                                          key="456282"
                                                          id="456282"
                                                          value={ReactSystemFunctions.translate(
                                                            this.ml,
                                                            456282,
                                                            "value",
                                                            this.defaultML
                                                          )}
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "12px",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </VerticalStack>
                                                    </KCol>
                                                  </KRow>
                                                </KCol>
                                                <KCol
                                                  key="864517"
                                                  id="864517"
                                                  xs={24}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={6}
                                                  xxl={6}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                    } as any
                                                  }
                                                >
                                                  <KRow
                                                    key="849909"
                                                    id="849909"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="620195"
                                                      id="620195"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 8,
                                                          borderTopRightRadius: 8,
                                                          borderBottomRightRadius: 8,
                                                          borderBottomLeftRadius: 8,
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          backgroundColor:
                                                            "rgba(255, 255, 255, 1)",
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-center",
                                                        } as any
                                                      }
                                                    >
                                                      <VerticalStack
                                                        key="139961"
                                                        id="139961"
                                                        direction="vertical"
                                                        size={2}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="905887"
                                                          id="905887"
                                                          value={
                                                            this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                              0
                                                            )
                                                              ?.onKesif_ToplamMaliyet ??
                                                            undefined
                                                          }
                                                          formatter="money-tl"
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 600,
                                                              fontSize: "16px",
                                                              color:
                                                                "rgba(106, 50, 201, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                        <Label
                                                          key="813761"
                                                          id="813761"
                                                          value={ReactSystemFunctions.translate(
                                                            this.ml,
                                                            813761,
                                                            "value",
                                                            this.defaultML
                                                          )}
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "12px",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </VerticalStack>
                                                    </KCol>
                                                  </KRow>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                          </KRow>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                    <KCol
                                      key="831693"
                                      id="831693"
                                      visibility={
                                        this.state.isComp831693Visible
                                      }
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 10,
                                          paddingRight: 0,
                                          paddingBottom: 8,
                                          paddingLeft: 0,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="129489"
                                        id="129489"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="477730"
                                          id="477730"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            477730,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "12px",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_858665_value"
                                        >
                                          <TextArea
                                            key="858665"
                                            id="858665"
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              858665,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={false}
                                            autoSize={false}
                                            showCount={false}
                                            formatter="None"
                                            readOnly={false}
                                            speechToText={false}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></TextArea>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="284664"
                                      id="284664"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 20,
                                          paddingRight: 0,
                                          paddingBottom: 8,
                                          paddingLeft: 0,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-right",
                                        } as any
                                      }
                                    >
                                      <HorizontalStack
                                        key="551171"
                                        id="551171"
                                        direction="horizontal"
                                        size={12}
                                        overflowX="auto"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Button
                                          key="551404"
                                          id="551404"
                                          onClick={(e?: any) => {
                                            if (e && e.stopPropagation)
                                              e.stopPropagation();
                                            this.CatiGesOnSureclerComponent_551404_onClick();
                                          }}
                                          showCursorPointer
                                          visibility={
                                            this.state.isComp551404Visible
                                          }
                                          label={ReactSystemFunctions.translate(
                                            this.ml,
                                            551404,
                                            "label",
                                            this.defaultML
                                          )}
                                          size="middle"
                                          loading={false}
                                          ghost={false}
                                          block={false}
                                          htmlType="button"
                                          icon="clear"
                                          iconPosition="left"
                                          danger={false}
                                          style={
                                            {
                                              borderTopLeftRadius: 8,
                                              borderTopRightRadius: 8,
                                              borderBottomRightRadius: 8,
                                              borderBottomLeftRadius: 8,
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              backgroundColor:
                                                "rgba(140, 140, 140, 1)",
                                              backgroundRepeat: "no-repeat",
                                              backgroundSize: "contain",
                                              backgroundPosition: "left",
                                              paddingTop: 8,
                                              paddingRight: 16,
                                              paddingBottom: 8,
                                              paddingLeft: 16,
                                              alignItems: "center",
                                              textAlign: "-webkit-center",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "12px",
                                              color: "rgba(255, 255, 255, 1)",
                                              lineHeight: "22px",
                                            } as any
                                          }
                                        ></Button>
                                        <Button
                                          key="549129"
                                          id="549129"
                                          label={ReactSystemFunctions.translate(
                                            this.ml,
                                            549129,
                                            "label",
                                            this.defaultML
                                          )}
                                          size="middle"
                                          loading={false}
                                          ghost={false}
                                          block={false}
                                          htmlType="button"
                                          icon="check"
                                          iconPosition="left"
                                          danger={false}
                                          style={
                                            {
                                              borderTopLeftRadius: 8,
                                              borderTopRightRadius: 8,
                                              borderBottomRightRadius: 8,
                                              borderBottomLeftRadius: 8,
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              backgroundColor:
                                                "rgba(225, 60, 57, 0.8)",
                                              backgroundRepeat: "no-repeat",
                                              backgroundSize: "contain",
                                              backgroundPosition: "left",
                                              paddingTop: 8,
                                              paddingRight: 16,
                                              paddingBottom: 8,
                                              paddingLeft: 16,
                                              alignItems: "center",
                                              textAlign: "-webkit-center",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "12px",
                                              color: "rgba(255, 255, 255, 1)",
                                              lineHeight: "22px",
                                            } as any
                                          }
                                        ></Button>
                                        <Button
                                          key="687126"
                                          id="687126"
                                          onClick={(e?: any) => {
                                            if (e && e.stopPropagation)
                                              e.stopPropagation();
                                            this.CatiGesOnSureclerComponent_687126_onClick();
                                          }}
                                          showCursorPointer
                                          visibility={
                                            this.state.isComp687126Visible
                                          }
                                          label={ReactSystemFunctions.translate(
                                            this.ml,
                                            687126,
                                            "label",
                                            this.defaultML
                                          )}
                                          size="middle"
                                          loading={false}
                                          ghost={false}
                                          block={false}
                                          htmlType="button"
                                          icon="check"
                                          iconPosition="left"
                                          danger={false}
                                          style={
                                            {
                                              borderTopLeftRadius: 8,
                                              borderTopRightRadius: 8,
                                              borderBottomRightRadius: 8,
                                              borderBottomLeftRadius: 8,
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              backgroundColor:
                                                "rgba(114, 194, 64, 1)",
                                              backgroundRepeat: "no-repeat",
                                              backgroundSize: "contain",
                                              backgroundPosition: "left",
                                              paddingTop: 8,
                                              paddingRight: 16,
                                              paddingBottom: 8,
                                              paddingLeft: 16,
                                              alignItems: "center",
                                              textAlign: "-webkit-center",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "12px",
                                              color: "rgba(255, 255, 255, 1)",
                                              lineHeight: "22px",
                                            } as any
                                          }
                                        ></Button>
                                      </HorizontalStack>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                        </KTabItem>
                        <KTabItem
                          key={494735}
                          id="494735"
                          onActive={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.CatiGesOnSureclerComponent_494735_onActive();
                          }}
                          visibility={
                            this.state
                              .isCompcatigesonsurecler_494735AuthorizationVisible
                          }
                          visibilityByAuthorization={
                            this.state
                              .isCompcatigesonsurecler_494735AuthorizationVisible
                          }
                          tab={ReactSystemFunctions.translate(
                            this.ml,
                            494735,
                            "tab",
                            this.defaultML
                          )}
                          forceRender={false}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(255, 255, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KRow
                            key="123507"
                            id="123507"
                            editability={this.state.isComp123507Enabled}
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <KCol
                              key="384084"
                              id="384084"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                } as any
                              }
                            >
                              <KRow
                                key="3470"
                                id="3470"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="538388"
                                  id="538388"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="975743"
                                    id="975743"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="870302"
                                      id="870302"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderTopLeftRadius: 16,
                                          borderTopRightRadius: 16,
                                          borderBottomRightRadius: 16,
                                          borderBottomLeftRadius: 16,
                                          borderTopWidth: 1,
                                          borderRightWidth: 1,
                                          borderBottomWidth: 1,
                                          borderLeftWidth: 1,
                                          borderColor: "rgba(244, 248, 251, 1)",
                                          borderStyle: "solid",
                                          paddingBottom: 8,
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="40315"
                                        id="40315"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="12242"
                                          id="12242"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderTopLeftRadius: 16,
                                              borderTopRightRadius: 16,
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              backgroundColor:
                                                "rgba(244, 248, 251, 1)",
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <KRow
                                            key="42263"
                                            id="42263"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="841377"
                                              id="841377"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={24}
                                              xxl={24}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 0,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="251668"
                                                id="251668"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  251668,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="785476"
                                            id="785476"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="199319"
                                              id="199319"
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={3}
                                              xxl={3}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="373424"
                                                id="373424"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  373424,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontSize: "10px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="926729"
                                              id="926729"
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={3}
                                              xxl={3}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="950849"
                                                id="950849"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  950849,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontSize: "10px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="886323"
                                              id="886323"
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={3}
                                              xxl={3}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="741548"
                                                id="741548"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  741548,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontSize: "10px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="781087"
                                              id="781087"
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={3}
                                              xxl={3}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="304412"
                                                id="304412"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  304412,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontSize: "10px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="244891"
                                              id="244891"
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={2}
                                              xxl={2}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="954891"
                                                id="954891"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  954891,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontSize: "10px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="468861"
                                              id="468861"
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={2}
                                              xxl={2}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="801928"
                                                id="801928"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  801928,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontSize: "10px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="206667"
                                              id="206667"
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={2}
                                              xxl={2}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="530484"
                                                id="530484"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  530484,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontSize: "10px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="612043"
                                              id="612043"
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={2}
                                              xxl={2}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="984005"
                                                id="984005"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  984005,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontSize: "10px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="625747"
                                              id="625747"
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={2}
                                              xxl={2}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="81596"
                                                id="81596"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  81596,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontSize: "10px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="849647"
                                              id="849647"
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={2}
                                              xxl={2}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="473022"
                                                id="473022"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  473022,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontSize: "10px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                          </KRow>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="638205"
                                        id="638205"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="378542"
                                          id="378542"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderTopLeftRadius: 8,
                                              borderTopRightRadius: 8,
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                            } as any
                                          }
                                        >
                                          <KRow
                                            key="219141"
                                            id="219141"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="408115"
                                              id="408115"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={24}
                                              xxl={24}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <KTable
                                                key="594487"
                                                id="594487"
                                                kuikaRef={
                                                  this
                                                    .catigesonsurecler_594487_value_kuikaTableRef
                                                }
                                                form={this.props.form}
                                                dataSource={
                                                  this.state
                                                    .PROFORMA_KALEMLERI_GETIR
                                                }
                                                size="middle"
                                                bordered={true}
                                                loading={false}
                                                rowKey="id"
                                                transformedOnMobileResolution={
                                                  false
                                                }
                                                hideHeaderOnMobileResolution={
                                                  false
                                                }
                                                showHeader={false}
                                                fixedHeader={false}
                                                tableWidthMode="fit"
                                                editable={false}
                                                editableAlwaysActive={false}
                                                insertRowActive={false}
                                                insertRowPosition="top"
                                                globalSearch={false}
                                                searchable={false}
                                                shouldSearchOnChange={true}
                                                searchDelay={200}
                                                sorter={false}
                                                filtering={false}
                                                resizableColumns={false}
                                                pagination={false}
                                                pageSize={10}
                                                showSizeChanger={false}
                                                paginationSelectedTextColor="#246eff"
                                                paginationUnselectedTextColor="#000"
                                                columnChooser={false}
                                                striped={false}
                                                stripedColor="#F5F7FA"
                                                rowHoverBgColor="#fafafa"
                                                showRowNumbers={false}
                                                showNoDataFound={true}
                                                nodatafoundmessage={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  594487,
                                                  "nodatafoundmessage",
                                                  this.defaultML
                                                )}
                                                multiSelect={false}
                                                multiSelectScope="page"
                                                export={false}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <KTableHeader
                                                  key="742161"
                                                  id="742161"
                                                  hideOnMobileResolution={false}
                                                  textDirection="Default"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                      color:
                                                        "rgba(155, 155, 155, 1)",
                                                      lineHeight: "20px",
                                                    } as any
                                                  }
                                                ></KTableHeader>
                                                <KTableRow
                                                  key="363069"
                                                  id="363069"
                                                  hoverFontColor="red"
                                                  hoverBgColor="#F5F5F5"
                                                  style={
                                                    {
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <KTableColumn
                                                    key="617573"
                                                    id="617573"
                                                    title={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      617573,
                                                      "title",
                                                      this.defaultML
                                                    )}
                                                    alwaysVisibleOnMobileResolution={
                                                      false
                                                    }
                                                    hideFiltering={false}
                                                    hideSorting={false}
                                                    hideSearch={false}
                                                    footerOptions="none"
                                                    footerFontSize={14}
                                                    footerFontColor="rgb(68, 68, 68)"
                                                    excludeFromExport={false}
                                                    footerFontWeight="Regular"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <KRow
                                                      key="450129"
                                                      id="450129"
                                                      align="top"
                                                      justify="start"
                                                      horizontalGutter={0}
                                                      verticalGutter={0}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                        } as any
                                                      }
                                                    >
                                                      <KCol
                                                        key="989198"
                                                        id="989198"
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        lg={12}
                                                        xl={3}
                                                        xxl={3}
                                                        order={0}
                                                        pull={0}
                                                        push={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "flex-start",
                                                            textAlign:
                                                              "-webkit-left",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="825120"
                                                          id="825120"
                                                          value="[datafield:fisno]"
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "9px",
                                                              color:
                                                                "rgba(44, 62, 80, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </KCol>
                                                      <KCol
                                                        key="305946"
                                                        id="305946"
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        lg={12}
                                                        xl={3}
                                                        xxl={3}
                                                        order={0}
                                                        pull={0}
                                                        push={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "flex-start",
                                                            textAlign:
                                                              "-webkit-left",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="998092"
                                                          id="998092"
                                                          value="[datafield:stoK_KODU]"
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "9px",
                                                              color:
                                                                "rgba(44, 62, 80, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </KCol>
                                                      <KCol
                                                        key="558635"
                                                        id="558635"
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        lg={12}
                                                        xl={3}
                                                        xxl={3}
                                                        order={0}
                                                        pull={0}
                                                        push={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "flex-start",
                                                            textAlign:
                                                              "-webkit-left",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="858542"
                                                          id="858542"
                                                          value="[datafield:stoK_ADI]"
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "9px",
                                                              color:
                                                                "rgba(44, 62, 80, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </KCol>
                                                      <KCol
                                                        key="438032"
                                                        id="438032"
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        lg={12}
                                                        xl={3}
                                                        xxl={3}
                                                        order={0}
                                                        pull={0}
                                                        push={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "flex-start",
                                                            textAlign:
                                                              "-webkit-left",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="307074"
                                                          id="307074"
                                                          value="[datafield:sthaR_GCMIK]"
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "9px",
                                                              color:
                                                                "rgba(44, 62, 80, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </KCol>
                                                      <KCol
                                                        key="105731"
                                                        id="105731"
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        lg={12}
                                                        xl={2}
                                                        xxl={2}
                                                        order={0}
                                                        pull={0}
                                                        push={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "flex-start",
                                                            textAlign:
                                                              "-webkit-left",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="218303"
                                                          id="218303"
                                                          value="[datafield:sthaR_DOVFIAT]"
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "9px",
                                                              color:
                                                                "rgba(44, 62, 80, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </KCol>
                                                      <KCol
                                                        key="672633"
                                                        id="672633"
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        lg={12}
                                                        xl={2}
                                                        xxl={2}
                                                        order={0}
                                                        pull={0}
                                                        push={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "flex-start",
                                                            textAlign:
                                                              "-webkit-center",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="67970"
                                                          id="67970"
                                                          value="[datafield:parA_BIRIMI]"
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "9px",
                                                              color:
                                                                "rgba(44, 62, 80, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </KCol>
                                                      <KCol
                                                        key="205750"
                                                        id="205750"
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        lg={12}
                                                        xl={2}
                                                        xxl={2}
                                                        order={0}
                                                        pull={0}
                                                        push={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "flex-start",
                                                            textAlign:
                                                              "-webkit-left",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="276392"
                                                          id="276392"
                                                          value="[datafield:sthaR_NF]"
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "9px",
                                                              color:
                                                                "rgba(44, 62, 80, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </KCol>
                                                      <KCol
                                                        key="949029"
                                                        id="949029"
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        lg={12}
                                                        xl={2}
                                                        xxl={2}
                                                        order={0}
                                                        pull={0}
                                                        push={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "flex-start",
                                                            textAlign:
                                                              "-webkit-left",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="624021"
                                                          id="624021"
                                                          value="[datafield:isK1]"
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "9px",
                                                              color:
                                                                "rgba(44, 62, 80, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </KCol>
                                                      <KCol
                                                        key="157471"
                                                        id="157471"
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        lg={12}
                                                        xl={2}
                                                        xxl={2}
                                                        order={0}
                                                        pull={0}
                                                        push={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "flex-start",
                                                            textAlign:
                                                              "-webkit-left",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="152259"
                                                          id="152259"
                                                          value="[datafield:isK2]"
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "9px",
                                                              color:
                                                                "rgba(44, 62, 80, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </KCol>
                                                      <KCol
                                                        key="645330"
                                                        id="645330"
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        lg={12}
                                                        xl={2}
                                                        xxl={2}
                                                        order={0}
                                                        pull={0}
                                                        push={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "flex-start",
                                                            textAlign:
                                                              "-webkit-left",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="536887"
                                                          id="536887"
                                                          value="[datafield:doviztut]"
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "9px",
                                                              color:
                                                                "rgba(44, 62, 80, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </KCol>
                                                    </KRow>
                                                  </KTableColumn>
                                                </KTableRow>
                                              </KTable>
                                            </KCol>
                                          </KRow>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="571582"
                                        id="571582"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderTopLeftRadius: 8,
                                            borderTopRightRadius: 8,
                                            borderBottomRightRadius: 8,
                                            borderBottomLeftRadius: 8,
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            backgroundColor:
                                              "rgba(9, 124, 176, 1)",
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="926397"
                                          id="926397"
                                          xs={16}
                                          sm={16}
                                          md={16}
                                          lg={16}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="74803"
                                            id="74803"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              74803,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(255, 255, 255, 1)",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="828959"
                                          id="828959"
                                          xs={8}
                                          sm={8}
                                          md={8}
                                          lg={8}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="575347"
                                            id="575347"
                                            value={
                                              this.state.PROFORMA_KALEMLERI_GETIR?.at?.(
                                                0
                                              )?.geneltoplam ?? undefined
                                            }
                                            formatter="money-tl"
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 600,
                                                fontSize: "14px",
                                                color: "rgba(255, 255, 255, 1)",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                  <KRow
                                    key="681247"
                                    id="681247"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingBottom: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="150663"
                                      id="150663"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={12}
                                      xxl={12}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 0,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="349370"
                                        id="349370"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderTopLeftRadius: 12,
                                            borderTopRightRadius: 12,
                                            borderBottomRightRadius: 12,
                                            borderBottomLeftRadius: 12,
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            backgroundColor:
                                              "rgba(244, 248, 251, 1)",
                                            paddingTop: 0,
                                            paddingRight: 8,
                                            paddingBottom: 0,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="489477"
                                          id="489477"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <KRow
                                            key="514637"
                                            id="514637"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="275084"
                                              id="275084"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="27727"
                                                id="27727"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  27727,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 600,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="129595"
                                              id="129595"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            ></KCol>
                                          </KRow>
                                          <KRow
                                            key="651951"
                                            id="651951"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="534817"
                                              id="534817"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="774444"
                                                id="774444"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  774444,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="393639"
                                              id="393639"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="958888"
                                                id="958888"
                                                value={
                                                  this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                    0
                                                  )?.kategoriAdi ?? undefined
                                                }
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="117703"
                                            id="117703"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="465806"
                                              id="465806"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="407484"
                                                id="407484"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  407484,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="836005"
                                              id="836005"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="156155"
                                                id="156155"
                                                value={
                                                  this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                    0
                                                  )?.netsisProjKodu ?? undefined
                                                }
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="808101"
                                            id="808101"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="28709"
                                              id="28709"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="742812"
                                                id="742812"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  742812,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="17363"
                                              id="17363"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="987296"
                                                id="987296"
                                                value={
                                                  this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                    0
                                                  )?.musteriAdi ?? undefined
                                                }
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="36852"
                                            id="36852"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="460576"
                                              id="460576"
                                              xs={8}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="838137"
                                                id="838137"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  838137,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="25007"
                                              id="25007"
                                              xs={16}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="179447"
                                                id="179447"
                                                value={
                                                  this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                    0
                                                  )?.iletisimKisi ?? undefined
                                                }
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="958650"
                                            id="958650"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="888700"
                                              id="888700"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="205169"
                                                id="205169"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  205169,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="172123"
                                              id="172123"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="451953"
                                                id="451953"
                                                value={
                                                  this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                    0
                                                  )?.telefon ?? undefined
                                                }
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                          </KRow>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                    <KCol
                                      key="495409"
                                      id="495409"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={12}
                                      xxl={12}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 0,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="184179"
                                        id="184179"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderTopLeftRadius: 12,
                                            borderTopRightRadius: 12,
                                            borderBottomRightRadius: 12,
                                            borderBottomLeftRadius: 12,
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            backgroundColor:
                                              "rgba(244, 248, 251, 1)",
                                            paddingTop: 0,
                                            paddingRight: 8,
                                            paddingBottom: 0,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="739547"
                                          id="739547"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <KRow
                                            key="196998"
                                            id="196998"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="835514"
                                              id="835514"
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={12}
                                              xxl={12}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="130983"
                                                id="130983"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  130983,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 600,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="943823"
                                              id="943823"
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={12}
                                              xxl={12}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            ></KCol>
                                          </KRow>
                                          <KRow
                                            key="810472"
                                            id="810472"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="148937"
                                              id="148937"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="947754"
                                                id="947754"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  947754,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="219352"
                                              id="219352"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <HorizontalStack
                                                key="52540"
                                                id="52540"
                                                visibility={
                                                  this.state.isComp52540Visible
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="246541"
                                                  id="246541"
                                                  iconName="check_circle"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(114, 194, 64, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="106507"
                                                  id="106507"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      0
                                                    )?.kesif_Tarih ?? undefined
                                                  }
                                                  formatter="date"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="123188"
                                                  id="123188"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    123188,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="117221"
                                                  id="117221"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      0
                                                    )?.netKesif_KullaniciAdi ??
                                                    undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                              <HorizontalStack
                                                key="647527"
                                                id="647527"
                                                visibility={
                                                  this.state.isComp647527Visible
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="840203"
                                                  id="840203"
                                                  iconName="hourglass_bottom"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="808976"
                                                  id="808976"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    808976,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="602950"
                                            id="602950"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="329732"
                                              id="329732"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="947009"
                                                id="947009"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  947009,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="741590"
                                              id="741590"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <HorizontalStack
                                                key="371141"
                                                id="371141"
                                                visibility={
                                                  this.state.isComp371141Visible
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="374563"
                                                  id="374563"
                                                  iconName="check_circle"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(114, 194, 64, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="686232"
                                                  id="686232"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      0
                                                    )?.proforma_Tarih ??
                                                    undefined
                                                  }
                                                  formatter="date"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="586632"
                                                  id="586632"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    586632,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="621424"
                                                  id="621424"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      0
                                                    )?.proforma_KullaniciAdi ??
                                                    undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                              <HorizontalStack
                                                key="583734"
                                                id="583734"
                                                visibility={
                                                  this.state.isComp583734Visible
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="70793"
                                                  id="70793"
                                                  iconName="hourglass_bottom"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="202005"
                                                  id="202005"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    202005,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="100148"
                                            id="100148"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="240415"
                                              id="240415"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="81396"
                                                id="81396"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  81396,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="252068"
                                              id="252068"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <HorizontalStack
                                                key="3461"
                                                id="3461"
                                                visibility={
                                                  this.state.isComp3461Visible
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="455729"
                                                  id="455729"
                                                  iconName="check_circle"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(114, 194, 64, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="112950"
                                                  id="112950"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      0
                                                    )?.netKesif_Tarih ??
                                                    undefined
                                                  }
                                                  formatter="date"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="720867"
                                                  id="720867"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    720867,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="615433"
                                                  id="615433"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      0
                                                    )?.netKesif_KullaniciAdi ??
                                                    undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                              <HorizontalStack
                                                key="848368"
                                                id="848368"
                                                visibility={
                                                  this.state.isComp848368Visible
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="265247"
                                                  id="265247"
                                                  iconName="hourglass_bottom"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="870616"
                                                  id="870616"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    870616,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="112387"
                                            id="112387"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="72982"
                                              id="72982"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="526165"
                                                id="526165"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  526165,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="746402"
                                              id="746402"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <HorizontalStack
                                                key="135945"
                                                id="135945"
                                                visibility={
                                                  this.state
                                                    .isComp135945Visible ==
                                                    "hidden" ||
                                                  this.state
                                                    .isCompcatigesonsurecler_135945AuthorizationVisible ==
                                                    "hidden"
                                                    ? "hidden"
                                                    : "visible"
                                                }
                                                visibilityByAuthorization={
                                                  this.state
                                                    .isCompcatigesonsurecler_135945AuthorizationVisible ==
                                                  "hidden"
                                                    ? "hidden"
                                                    : "visible"
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="848229"
                                                  id="848229"
                                                  iconName="check_circle"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(114, 194, 64, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="140697"
                                                  id="140697"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      0
                                                    )?.pM_OnayTarih ?? undefined
                                                  }
                                                  formatter="date"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="632457"
                                                  id="632457"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    632457,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="64459"
                                                  id="64459"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      0
                                                    )?.pM_OnaylayanAdi ??
                                                    undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                              <HorizontalStack
                                                key="289590"
                                                id="289590"
                                                visibility={
                                                  this.state.isComp289590Visible
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="592586"
                                                  id="592586"
                                                  iconName="hourglass_bottom"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="994923"
                                                  id="994923"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    994923,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="980981"
                                            id="980981"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="790544"
                                              id="790544"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={8}
                                              xxl={8}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="642939"
                                                id="642939"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  642939,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="69602"
                                              id="69602"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={16}
                                              xxl={16}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <HorizontalStack
                                                key="432583"
                                                id="432583"
                                                visibility={
                                                  this.state.isComp432583Visible
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="723719"
                                                  id="723719"
                                                  iconName="check_circle"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(114, 194, 64, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="616609"
                                                  id="616609"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      -1
                                                    )?.uY_OnayTarih ?? undefined
                                                  }
                                                  formatter="date"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="563960"
                                                  id="563960"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    563960,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="619277"
                                                  id="619277"
                                                  value={
                                                    this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                      -1
                                                    )?.uY_OnaylayanAdi ??
                                                    undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                              <HorizontalStack
                                                key="781192"
                                                id="781192"
                                                visibility={
                                                  this.state.isComp781192Visible
                                                }
                                                direction="horizontal"
                                                size={2}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="861192"
                                                  id="861192"
                                                  iconName="hourglass_bottom"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                                <Label
                                                  key="285720"
                                                  id="285720"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    285720,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "12px",
                                                      color:
                                                        "rgba(245, 166, 35, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </HorizontalStack>
                                            </KCol>
                                          </KRow>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                  <KRow
                                    key="254897"
                                    id="254897"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="465589"
                                      id="465589"
                                      visibility={
                                        this.state.isComp465589Visible
                                      }
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 0,
                                          paddingBottom: 8,
                                          paddingLeft: 0,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="194397"
                                        id="194397"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderTopLeftRadius: 12,
                                            borderTopRightRadius: 12,
                                            borderBottomRightRadius: 12,
                                            borderBottomLeftRadius: 12,
                                            borderTopWidth: 1,
                                            borderRightWidth: 1,
                                            borderBottomWidth: 1,
                                            borderLeftWidth: 1,
                                            borderColor:
                                              "rgba(203, 179, 242, 0.66)",
                                            borderStyle: "solid",
                                            backgroundColor:
                                              "rgba(203, 179, 242, 0.36)",
                                            paddingTop: 0,
                                            paddingRight: 8,
                                            paddingBottom: 0,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="655872"
                                          id="655872"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <KRow
                                            key="339593"
                                            id="339593"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="658684"
                                              id="658684"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={24}
                                              xxl={24}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  alignItems: "center",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="317578"
                                                id="317578"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  317578,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "12px",
                                                    color:
                                                      "rgba(106, 50, 201, 1)",
                                                  } as any
                                                }
                                              ></Label>
                                              <KRow
                                                key="299990"
                                                id="299990"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 8,
                                                    paddingLeft: 0,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="721208"
                                                  id="721208"
                                                  xs={24}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={6}
                                                  xxl={6}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                    } as any
                                                  }
                                                >
                                                  <KRow
                                                    key="778246"
                                                    id="778246"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="475157"
                                                      id="475157"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 8,
                                                          borderTopRightRadius: 8,
                                                          borderBottomRightRadius: 8,
                                                          borderBottomLeftRadius: 8,
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          backgroundColor:
                                                            "rgba(255, 255, 255, 1)",
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-center",
                                                        } as any
                                                      }
                                                    >
                                                      <VerticalStack
                                                        key="835795"
                                                        id="835795"
                                                        direction="vertical"
                                                        size={2}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="676113"
                                                          id="676113"
                                                          value={
                                                            this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                              0
                                                            )
                                                              ?.kesif_TahminiGuc ??
                                                            undefined
                                                          }
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 600,
                                                              fontSize: "16px",
                                                              color:
                                                                "rgba(106, 50, 201, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                        <Label
                                                          key="501317"
                                                          id="501317"
                                                          value={ReactSystemFunctions.translate(
                                                            this.ml,
                                                            501317,
                                                            "value",
                                                            this.defaultML
                                                          )}
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "12px",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </VerticalStack>
                                                    </KCol>
                                                  </KRow>
                                                </KCol>
                                                <KCol
                                                  key="437271"
                                                  id="437271"
                                                  xs={24}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={6}
                                                  xxl={6}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                    } as any
                                                  }
                                                >
                                                  <KRow
                                                    key="309603"
                                                    id="309603"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="473821"
                                                      id="473821"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 8,
                                                          borderTopRightRadius: 8,
                                                          borderBottomRightRadius: 8,
                                                          borderBottomLeftRadius: 8,
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          backgroundColor:
                                                            "rgba(255, 255, 255, 1)",
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-center",
                                                        } as any
                                                      }
                                                    >
                                                      <VerticalStack
                                                        key="49266"
                                                        id="49266"
                                                        direction="vertical"
                                                        size={2}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="395234"
                                                          id="395234"
                                                          value={
                                                            this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                              0
                                                            )?.kesif_AlanM2 ??
                                                            undefined
                                                          }
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 600,
                                                              fontSize: "16px",
                                                              color:
                                                                "rgba(106, 50, 201, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                        <Label
                                                          key="585488"
                                                          id="585488"
                                                          value={ReactSystemFunctions.translate(
                                                            this.ml,
                                                            585488,
                                                            "value",
                                                            this.defaultML
                                                          )}
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "12px",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </VerticalStack>
                                                    </KCol>
                                                  </KRow>
                                                </KCol>
                                                <KCol
                                                  key="491691"
                                                  id="491691"
                                                  xs={24}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={6}
                                                  xxl={6}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                    } as any
                                                  }
                                                >
                                                  <KRow
                                                    key="353074"
                                                    id="353074"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="586838"
                                                      id="586838"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 8,
                                                          borderTopRightRadius: 8,
                                                          borderBottomRightRadius: 8,
                                                          borderBottomLeftRadius: 8,
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          backgroundColor:
                                                            "rgba(255, 255, 255, 1)",
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-center",
                                                        } as any
                                                      }
                                                    >
                                                      <VerticalStack
                                                        key="350805"
                                                        id="350805"
                                                        direction="vertical"
                                                        size={2}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="554511"
                                                          id="554511"
                                                          value={
                                                            this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                              0
                                                            )
                                                              ?.teknik_CatiTipi ??
                                                            undefined
                                                          }
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 600,
                                                              fontSize: "16px",
                                                              color:
                                                                "rgba(106, 50, 201, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                        <Label
                                                          key="172700"
                                                          id="172700"
                                                          value={ReactSystemFunctions.translate(
                                                            this.ml,
                                                            172700,
                                                            "value",
                                                            this.defaultML
                                                          )}
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "12px",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </VerticalStack>
                                                    </KCol>
                                                  </KRow>
                                                </KCol>
                                                <KCol
                                                  key="505275"
                                                  id="505275"
                                                  xs={24}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={6}
                                                  xxl={6}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                    } as any
                                                  }
                                                >
                                                  <KRow
                                                    key="512369"
                                                    id="512369"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="347038"
                                                      id="347038"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 8,
                                                          borderTopRightRadius: 8,
                                                          borderBottomRightRadius: 8,
                                                          borderBottomLeftRadius: 8,
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          backgroundColor:
                                                            "rgba(255, 255, 255, 1)",
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-center",
                                                        } as any
                                                      }
                                                    >
                                                      <VerticalStack
                                                        key="403205"
                                                        id="403205"
                                                        direction="vertical"
                                                        size={2}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="688343"
                                                          id="688343"
                                                          value={
                                                            this.state.GET_ON_SUREC_OZET_GETIR?.at?.(
                                                              0
                                                            )
                                                              ?.onKesif_ToplamMaliyet ??
                                                            undefined
                                                          }
                                                          formatter="money-tl"
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 600,
                                                              fontSize: "16px",
                                                              color:
                                                                "rgba(106, 50, 201, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                        <Label
                                                          key="290895"
                                                          id="290895"
                                                          value={ReactSystemFunctions.translate(
                                                            this.ml,
                                                            290895,
                                                            "value",
                                                            this.defaultML
                                                          )}
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "12px",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </VerticalStack>
                                                    </KCol>
                                                  </KRow>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                          </KRow>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                    <KCol
                                      key="848477"
                                      id="848477"
                                      visibility={
                                        this.state.isComp848477Visible
                                      }
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 0,
                                          paddingBottom: 8,
                                          paddingLeft: 0,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="646747"
                                        id="646747"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="87740"
                                          id="87740"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            87740,
                                            "value",
                                            this.defaultML
                                          )}
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "12px",
                                            } as any
                                          }
                                        ></Label>
                                        <Form.Item
                                          className="kFormItem"
                                          name="catigesonsurecler_961677_value"
                                        >
                                          <TextArea
                                            key="961677"
                                            id="961677"
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              961677,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={false}
                                            autoSize={false}
                                            showCount={false}
                                            formatter="None"
                                            readOnly={false}
                                            speechToText={false}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></TextArea>
                                        </Form.Item>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="500544"
                                      id="500544"
                                      visibility={
                                        this.state.isComp500544Visible
                                      }
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 20,
                                          paddingRight: 0,
                                          paddingBottom: 8,
                                          paddingLeft: 0,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-right",
                                        } as any
                                      }
                                    >
                                      <HorizontalStack
                                        key="269137"
                                        id="269137"
                                        direction="horizontal"
                                        size={12}
                                        overflowX="auto"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Button
                                          key="233488"
                                          id="233488"
                                          onClick={(e?: any) => {
                                            if (e && e.stopPropagation)
                                              e.stopPropagation();
                                            this.CatiGesOnSureclerComponent_233488_onClick();
                                          }}
                                          showCursorPointer
                                          visibility={
                                            this.state.isComp233488Visible
                                          }
                                          label={ReactSystemFunctions.translate(
                                            this.ml,
                                            233488,
                                            "label",
                                            this.defaultML
                                          )}
                                          size="middle"
                                          loading={false}
                                          ghost={false}
                                          block={false}
                                          htmlType="button"
                                          icon="clear"
                                          iconPosition="left"
                                          danger={false}
                                          style={
                                            {
                                              borderTopLeftRadius: 8,
                                              borderTopRightRadius: 8,
                                              borderBottomRightRadius: 8,
                                              borderBottomLeftRadius: 8,
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              backgroundColor:
                                                "rgba(140, 140, 140, 1)",
                                              backgroundRepeat: "no-repeat",
                                              backgroundSize: "contain",
                                              backgroundPosition: "left",
                                              paddingTop: 8,
                                              paddingRight: 16,
                                              paddingBottom: 8,
                                              paddingLeft: 16,
                                              alignItems: "center",
                                              textAlign: "-webkit-center",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "12px",
                                              color: "rgba(255, 255, 255, 1)",
                                              lineHeight: "22px",
                                            } as any
                                          }
                                        ></Button>
                                        <Button
                                          key="320489"
                                          id="320489"
                                          onClick={(e?: any) => {
                                            if (e && e.stopPropagation)
                                              e.stopPropagation();
                                            this.CatiGesOnSureclerComponent_320489_onClick();
                                          }}
                                          showCursorPointer
                                          visibility={
                                            this.state.isComp320489Visible
                                          }
                                          label={ReactSystemFunctions.translate(
                                            this.ml,
                                            320489,
                                            "label",
                                            this.defaultML
                                          )}
                                          size="middle"
                                          loading={false}
                                          ghost={false}
                                          block={false}
                                          htmlType="button"
                                          icon="check"
                                          iconPosition="left"
                                          danger={false}
                                          style={
                                            {
                                              borderTopLeftRadius: 8,
                                              borderTopRightRadius: 8,
                                              borderBottomRightRadius: 8,
                                              borderBottomLeftRadius: 8,
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              backgroundColor:
                                                "rgba(114, 194, 64, 1)",
                                              backgroundRepeat: "no-repeat",
                                              backgroundSize: "contain",
                                              backgroundPosition: "left",
                                              paddingTop: 8,
                                              paddingRight: 16,
                                              paddingBottom: 8,
                                              paddingLeft: 16,
                                              alignItems: "center",
                                              textAlign: "-webkit-center",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "12px",
                                              color: "rgba(255, 255, 255, 1)",
                                              lineHeight: "22px",
                                            } as any
                                          }
                                        ></Button>
                                      </HorizontalStack>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                        </KTabItem>
                      </KTab>
                    </Form.Item>
                    <KRow
                      key="3264"
                      id="3264"
                      align="top"
                      justify="start"
                      horizontalGutter={0}
                      verticalGutter={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                        } as any
                      }
                    ></KRow>
                  </KCol>
                </KRow>
              </div>
              <Footer
                key="-3"
                id="catigesonsurecler_footer"
                style={
                  {
                    borderStyle: "solid",
                    borderTopWidth: 0,
                    borderRightWidth: 0,
                    borderBottomWidth: 0,
                    borderLeftWidth: 0,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "left",
                    paddingTop: 0,
                    paddingRight: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    fontSize: "14px",
                    color: "rgba(68, 68, 68, 1)",
                  } as any
                }
              ></Footer>
            </div>
          </Form>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withForm(
        withHistory(
          connect(mapStateToProps, mapDispatchToProps)(CatiGesOnSurecler_Screen)
        )
      )
    )
  )
);
export { tmp as CatiGesOnSurecler_Screen };
//export default tmp;
//export { tmp as CatiGesOnSurecler_Screen };
